/* =====================================================================
   OWNER-REPORTED FIXES 2026-06-06  (externalised from sections/jacket.liquid
   2026-06-06 — the section template hit Shopify's 256 KB limit, so this
   inline <script> was moved into an asset. Assets have no size limit and
   this is where ongoing owner-fix JS edits should live now.)

   WS1: collapse toggle + fixed-footer width tracking + dynamic bottom pad
        + default-collapsed summary that auto-expands when an item is added.
   WS2: keep-angle re-fit of the 3D jacket whenever its container resizes
        or the layout changes. The engine is jacket-cf.js in production
        (jacket.js is the legacy mirror); most fixes should still use
        exposed window.* hooks before touching the minified engine.
   WS-popin: robust render pump that guarantees the jacket draws on load.

   Loaded with `defer` at the same DOM position the inline block occupied,
   so the elements it queries already exist and behaviour is unchanged.
   Rollback = restore the inline <script> block in jacket.liquid.
   ===================================================================== */
(function () {
  'use strict';

  var panel     = document.getElementById('desktop-config-panel');
  var footer    = panel ? panel.querySelector('.panel-footer') : null;
  var content   = panel ? panel.querySelector('.panel-content') : null;
  var toggle    = document.getElementById('sv-footer-toggle');
  var container = document.getElementById('3d-preview-container');

  var refitT = null, refitting = false;

  /* ---- WS2: keep-angle re-fit -----------------------------------------
     Fire the engine's own resize path so it re-syncs the renderer buffer to
     the new CSS box WITHOUT changing the user's rotation/zoom, then force a
     render. This is what stops the jacket "popping" out of frame / cropping
     when the layout changes. */
  function doRefit() {
    refitting = true;
    try {
      window.dispatchEvent(new Event('resize'));
      /* Desktop: the canvas aspect barely changes on resize, so the engine's
         own setSize keeps the jacket framed AND preserves the user's rotation
         (keep-angle). Mobile: the bottom-sheet expand/collapse flips the canvas
         between portrait and landscape — setSize updates the aspect but NOT the
         camera fit, so the tall jacket falls out of the short-wide frustum and
         vanishes. reset3DModelView re-frames the model to the new canvas; gated
         to mobile so desktop rotation is never reset. */
      /* 2026-08-20: gate the phone reset on a REAL canvas-size change.
         The sheet no longer resizes the viewer (its 50dvh shrink rule was
         retired in jacket.css the same day), so sheet slides and step
         changes reach here with identical dimensions — resetting then
         would wipe the customer's zoom/angle for nothing. Orientation
         flips and genuine layout changes still re-frame as before. */
      var __rc = document.getElementById('3d-preview-container');
      var __rw = __rc ? __rc.clientWidth : 0, __rh = __rc ? __rc.clientHeight : 0;
      var __dimsChanged = (__rw !== window.__svLastRefitW || __rh !== window.__svLastRefitH);
      window.__svLastRefitW = __rw; window.__svLastRefitH = __rh;
      if (window.innerWidth <= 767 && typeof window.reset3DModelView === 'function') {
        if (__dimsChanged) window.reset3DModelView();
      } else if (typeof window.update3DView === 'function') {
        /* Re-apply the CURRENT view (front/back/…). NEVER call update3DView()
           with NO argument — that re-runs the view logic with an undefined view
           and BLANKS the jacket. (Pressing "Got it!" on the zoom popup adds
           .expanded to the bottom sheet, which trips this refit on desktop.) */
        var avEl = document.querySelector('.view-btn.active');
        window.update3DView((avEl && avEl.getAttribute('data-view')) || 'front');
      }
      if (typeof window.svSetNeedsRender === 'function') window.svSetNeedsRender();
    } catch (e) { /* engine not ready yet */ }
    /* Clear window MUST exceed the svRefit debounce (120ms) + ResizeObserver
       latency, so a resize WE caused is always absorbed and never re-triggers
       the observer into a refit loop. */
    setTimeout(function () { refitting = false; }, 200);
  }
  function svRefit() {
    if (refitT) clearTimeout(refitT);
    refitT = setTimeout(doRefit, 120);
  }
  window.svRefit = svRefit; // exposed for other handlers / DEV testing

  /* ---- WS1a: keep the fixed footer aligned to the real panel ---------- */
  function syncPanelMetrics() {
    if (!panel || !footer) return;
    var r = panel.getBoundingClientRect();
    footer.style.setProperty('--sv-panel-w', r.width + 'px');
    footer.style.setProperty('--sv-panel-left', r.left + 'px');
    if (content) {
      var h = footer.getBoundingClientRect().height;
      content.style.paddingBottom = (h + 24) + 'px'; /* never hide content */
    }
  }

  /* ---- WS1b: collapse / expand toggle --------------------------------- */
  function setCollapsed(collapsed) {
    if (!footer || !toggle) return;
    footer.classList.toggle('sv-footer-min', collapsed);
    toggle.setAttribute('aria-expanded', String(!collapsed));
    var label = toggle.querySelector('.sv-footer-toggle-label');
    if (label) label.textContent = collapsed ? 'Show summary' : 'Hide summary';
    toggle.title = collapsed ? 'Show the price summary' : 'Minimise the price summary';
    try { localStorage.setItem('sv-footer-min', collapsed ? '1' : '0'); } catch (e) {}
    syncPanelMetrics();
    svRefit(); /* footer height changed → keep jacket framed */
  }
  /* ---- one-time registration guard -----------------------------------
     The Theme Editor re-runs this on every section edit. Functions above are
     safe to redefine, but observers/listeners must register ONCE or they leak
     (N observers each calling svRefit). svGoToStep has its own guard below. */
  if (window.__svFooterFitInit) return;
  window.__svFooterFitInit = true;

  if (toggle && footer) {
    toggle.addEventListener('click', function () {
      setCollapsed(!footer.classList.contains('sv-footer-min'));
    });
    /* Owner ask: the summary ALWAYS starts collapsed ("Show summary") and
       pops open ("Hide summary") the moment the customer adds a stud/badge.
       (Previously it restored the last localStorage state — now always closed.) */
    setCollapsed(true);

    /* 2026-09-22 — Sam: "stop the auto-open on desktop". The auto-expand that
       stood here (parseTotal + evalAdd + three early timers + a footer
       MutationObserver) opened the summary whenever the total rose. Its own
       label-change mutations also re-opened it right after the customer pressed
       "Hide summary" — measured on DEV: hidden, then forced open again 8 ms
       later. The summary is now manual only. It starts collapsed and moves only
       when the customer presses the toggle above.
       Verified on DEV at 1440x900: two stud presses left the footer at 105px
       with the total correct; Show gave 471px and held; Hide gave 105px and
       held; 0 JS errors.
       Rollback: pending-patches/sv-owner-fixes.PRE-liveGiletNoAuto.LIVE-ROLLBACK.js */
  }

  /* ---- WS2 triggers --------------------------------------------------- */
  /* Primary: the canvas container changing size — covers mobile sheet
     expand/collapse, window resize, device rotation, footer collapse. */
  if (container && 'ResizeObserver' in window) {
    var ro = new ResizeObserver(function () {
      if (refitting) return; /* ignore size changes we caused ourselves */
      svRefit();
    });
    ro.observe(container);
  }
  /* Secondary: layout changes that may not resize the container. */
  var sheet = document.getElementById('nike-bottom-sheet');
  if (sheet && 'MutationObserver' in window) {
    new MutationObserver(svRefit).observe(sheet, { attributes: true, attributeFilter: ['class'] });
  }
  var viewer = document.querySelector('.viewer-section');
  if (viewer) {
    viewer.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'height' || e.propertyName === 'max-height') svRefit();
    });
  }

  /* ---- WS2 smart-per-step --------------------------------------------
     Wrap the engine's own step navigator so we re-fit after a step change
     (never fighting its choreography — we only guarantee the jacket stays
     fully framed for the new layout). Retried since svGoToStep may be
     defined after first paint. */
  function tryWrapStep() {
    if (window.__svGoToStepWrapped) return;
    if (typeof window.svGoToStep !== 'function') return;
    var _orig = window.svGoToStep;
    window.svGoToStep = function () { var r = _orig.apply(this, arguments); svRefit(); return r; };
    window.__svGoToStepWrapped = true;
  }
  tryWrapStep();
  setTimeout(tryWrapStep, 1200);
  setTimeout(tryWrapStep, 2500);

  /* ---- WS-zoom: handled in the minified engine ------------------------------
     The zoom button blanks the jacket. Investigated exhaustively on DEV: the
     engine's zoom dollies the camera so the billboard plane leaves the frustum,
     and the behaviour is NON-DETERMINISTIC from outside (reset3DModelView
     animates async; the zoom accumulator holds broken internal state). Every
     external mitigation tried — forced render pump, scaling the model group,
     rerouting the button to the wheel path — fixed it only intermittently, so
     none is safe to ship. The reliable primitive is reset3DModelView (full
     reframe), which isn't a zoom. Proper fix = clamp/repair the zoom in
     jacket-cf.js + jacket.js itself (owner cleared this). Intentionally NO zoom override here
     so we don't ship a flaky pseudo-fix. */

  /* ---- WS-popin: guarantee the jacket draws on load (robust render pump) ----
     The engine renders ON-DEMAND (event-driven, no continuous RAF loop), so on
     some loads the model never receives a draw frame and the viewer stays blank
     until the user interacts (the reported "pop-in"). A single forced reset
     (the previous approach) was flaky — the engine could blank the canvas again
     just AFTER our reset, and the one confirm-pass didn't always catch it.

     Robust fix: once the jacket texture is ready, run a short requestAnimation-
     Frame render PUMP that forces a frame every tick for ~4s, re-asserting the
     default framing at a few points across the load-settle window. If the engine
     self-clears the canvas at any moment during load, the very next pumped frame
     redraws it — so the canvas always ends up drawn. The pump is render-only
     (svSetNeedsRender, no camera change) and the reset re-asserts are gated to
     !userInteracted so they never fight the user. Then it stops (battery). */
  var revealTries = 0, userInteracted = false, pumpStart = 0, pumping = false;
  ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
    (container || document).addEventListener(ev, function () { userInteracted = true; }, { passive: true });
  });
  function jacketTextureReady() {
    /* The plane MESH exists well before its TEXTURE finishes loading. Forcing a
       draw before the texture is ready paints an empty model. Gate on the jacket
       plane having a loaded texture image. */
    if (typeof window.svSetNeedsRender !== 'function' || !window.threeScene) return false;
    var ready = false;
    try {
      window.threeScene.traverse(function (o) {
        if (o.isMesh && o.geometry && o.geometry.type === 'PlaneGeometry' && o.material && o.material.map) {
          var img = o.material.map.image;
          if (img && (img.complete || img.naturalWidth > 0 || img.width > 0)) ready = true;
        }
      });
    } catch (e) { /* not traversable yet */ }
    return ready;
  }
  function pumpFrame(ts) {
    if (!pumping) return;
    try { if (window.svSetNeedsRender) window.svSetNeedsRender(); } catch (e) {}
    if (ts - pumpStart < 4000) {
      requestAnimationFrame(pumpFrame);
    } else {
      pumping = false; /* model has settled and been drawn — stop forcing frames */
    }
  }
  function startRevealPump() {
    if (pumping) return;
    pumping = true;
    pumpStart = (window.performance && performance.now) ? performance.now() : 0;
    /* Re-assert the default front framing a few times across the settle window,
       so a late engine clear can't leave it blank. Skipped once the user has
       taken control (their rotation/zoom must win). */
    [0, 350, 900, 1800, 2800].forEach(function (d) {
      setTimeout(function () {
        if (userInteracted) return;
        try {
          if (typeof window.reset3DModelView === 'function') window.reset3DModelView();
          if (window.svSetNeedsRender) window.svSetNeedsRender();
        } catch (e) {}
      }, d);
    });
    requestAnimationFrame(pumpFrame);
  }
  function ensureJacketRevealed() {
    if (window.__svJacketRevealed) return;
    revealTries++;
    if (jacketTextureReady()) {
      window.__svJacketRevealed = true;
      startRevealPump();
      return;
    }
    if (revealTries < 80) setTimeout(ensureJacketRevealed, 200); /* poll up to ~16s */
  }
  setTimeout(ensureJacketRevealed, 500);

  /* ---- metric sync + initial fit -------------------------------------- */
  window.addEventListener('scroll', syncPanelMetrics, { passive: true });
  window.addEventListener('resize', syncPanelMetrics, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPanelMetrics);
  } else {
    syncPanelMetrics();
  }
  setTimeout(syncPanelMetrics, 800);
  setTimeout(svRefit, 1200); /* once the engine has likely finished first paint */
})();

/* =====================================================================
   WS-replace 2026-06-14 — REPLACE a placed badge IN PLACE
   ---------------------------------------------------------------------
   Owner ask: tap a placed badge → "Replace" → pick a different design →
   it swaps onto the SAME spot, correctly sized for the new design (never
   squished) and at the same price model as a normal placement.

   The engine is driven ONLY through a window.* hook, exactly like WS2:
     window.svReplaceBadgeInPlace(targetMesh, meta, image)  (added to
     jacket-cf.js / jacket.js as an ADDITIVE helper — it reuses the
     engine's own Pn() placement + SurfaceProjectionBadge sizing + decal
     bookkeeping, so sizing, price, count, order data and the canvas
     screenshot all behave as if the customer placed the new badge).
     window.svActiveBadge — the badge mesh the action menu is open for.

   Flow:
     1. MutationObserver injects a "Replace" button into the engine's
        .sv-badge-action-menu when it appears (above the Remove button).
     2. Replace click → capture window.svActiveBadge, arm "replace mode",
        show a banner, dismiss the menu.
     3. A CAPTURE-phase click listener diverts the NEXT gallery-tile tap:
        it stops the engine's own tile handler (so NO new badge is armed),
        loads that design's image as a data URL (mirrors the engine's
        zs(): fetch→blob→dataURL, which keeps the WebGL canvas untainted
        so the order screenshot's toBlob still works), then calls
        svReplaceBadgeInPlace on the original mesh.
   Rollback = delete this IIFE (+ the engine helper) — additive only.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__svReplaceInit) return; /* Theme Editor re-runs this script */
  window.__svReplaceInit = true;

  var replaceMode = false;
  var replaceTarget = null; /* the placed badge mesh being replaced */
  var banner = null;

  function badgeAssetBase() { return window.SHOPIFY_BADGE_ASSET_URL || 'assets/'; }
  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }
  function refitMobileViewer() {
    if (!isMobileViewport()) return;
    [0, 120, 300].forEach(function (delay) {
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
        if (typeof window.svSetNeedsRender === 'function') window.svSetNeedsRender();
      }, delay);
    });
  }
  function openMobileBadgeDrawerForReplace() {
    if (!isMobileViewport()) return;
    var sheet = document.getElementById('nike-bottom-sheet');
    if (sheet) {
      sheet.classList.remove('sv-drawer-collapsed');
      sheet.style.transform = '';
    }
    if (document.body) {
      document.body.classList.remove('sv-mobile-placement-active', 'sv-mobile-placement-review');
    }
    refitMobileViewer();
  }
  function collapseMobileBadgeDrawerAfterReplace() {
    if (!isMobileViewport()) return;
    var sheet = document.getElementById('nike-bottom-sheet');
    if (sheet) {
      sheet.classList.add('sv-drawer-collapsed');
      sheet.style.transform = '';
    }
    if (document.body) {
      document.body.classList.remove('sv-mobile-placement-active');
      document.body.classList.add('sv-mobile-placement-review');
    }
    refitMobileViewer();
  }

  function findBadgeData(id) {
    try {
      var arr = window.svBadgesData && window.svBadgesData.badges;
      if (!arr) return null;
      for (var i = 0; i < arr.length; i++) if (String(arr[i].id) === String(id)) return arr[i];
    } catch (e) {}
    return null;
  }

  function showBanner() {
    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'sv-replace-banner';
      banner.innerHTML =
        '<span class="sv-replace-banner-text">Pick a design to replace this badge</span>' +
        '<button type="button" class="sv-replace-banner-cancel" aria-label="Cancel replace">Cancel</button>';
      banner.querySelector('.sv-replace-banner-cancel').addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation(); exitReplaceMode();
      });
      document.body.appendChild(banner);
    }
    banner.classList.add('is-visible');
  }
  function hideBanner() { if (banner) banner.classList.remove('is-visible'); }

  function enterReplaceMode(target) {
    replaceTarget = target;
    replaceMode = true;
    showBanner();
    openMobileBadgeDrawerForReplace();
  }
  function exitReplaceMode() { replaceMode = false; replaceTarget = null; hideBanner(); }

  /* Load a badge image as a data URL (mirrors engine zs()): fetch → blob →
     dataURL → Image. The dataURL keeps the badge texture same-origin so the
     canvas never taints and the design-screenshot toBlob keeps working. */
  function loadBadgeImage(filename, cb) {
    var url = badgeAssetBase() + filename;
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
      .then(function (blob) {
        var fr = new FileReader();
        fr.onload = function (e) {
          var img = new Image();
          img.onload = function () { cb(img); };
          img.onerror = function () { cb(null); };
          img.src = e.target.result;
        };
        fr.onerror = function () { cb(null); };
        fr.readAsDataURL(blob);
      })
      .catch(function () { cb(null); });
  }

  function doReplace(badgeData) {
    var target = replaceTarget;
    if (!target || !badgeData) { exitReplaceMode(); return; }
    var meta = {
      type: 'stock', badgeId: badgeData.id, name: badgeData.name, price: badgeData.price,
      category: badgeData.category, id: badgeData.id, aspectRatio: badgeData.aspectRatio
    };
    loadBadgeImage(badgeData.filename, function (img) {
      try {
        if (img && typeof window.svReplaceBadgeInPlace === 'function') {
          window.svReplaceBadgeInPlace(target, meta, img);
          collapseMobileBadgeDrawerAfterReplace();
        }
      } catch (e) { /* helper guards internally */ }
      exitReplaceMode();
    });
  }

  /* CAPTURE-phase divert: while replacing, the next gallery-tile tap swaps the
     design in place instead of placing a new badge. Capture +
     stopImmediatePropagation runs before the engine's own tile handler, so the
     engine never arms a new placement. Tiles (mobile + desktop) carry
     data-badge-id. A tap outside any tile leaves replace mode armed. */
  document.addEventListener('click', function (e) {
    if (!replaceMode) return;
    var tile = e.target && e.target.closest ? e.target.closest('[data-badge-id]') : null;
    if (!tile) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var id = tile.getAttribute('data-badge-id') || (tile.dataset && tile.dataset.badgeId);
    doReplace(findBadgeData(id));
  }, true);

  /* Inject the "Replace" button into the badge action menu each time it opens. */
  function injectReplace(menu) {
    if (!menu || menu.querySelector('#context-action-replace')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sv-badge-action-item sv-replace-action';
    btn.id = 'context-action-replace';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="23 4 23 10 17 10"></polyline>' +
      '<polyline points="1 20 1 14 7 14"></polyline>' +
      '<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>' +
      '</svg><span>Replace</span>';
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var target = window.svActiveBadge || null; /* read BEFORE the menu closes */
      if (!target) return;
      enterReplaceMode(target);
      if (menu.parentNode) menu.parentNode.removeChild(menu); /* dismiss the menu */
    });
    menu.insertBefore(btn, menu.firstChild); /* Replace sits above Remove */
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('sv-badge-action-menu')) injectReplace(n);
          else if (n.querySelector) {
            var m = n.querySelector('.sv-badge-action-menu');
            if (m) injectReplace(m);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ===========================================================================
   SV MOVE — reposition a placed badge (WS 2026-06-14)
   Tap a placed badge → "Move" → "tap a new spot". A gesture-safe capture-phase
   click handler distinguishes a tap (move) from a drag (rotate the jacket).
   On a tap it calls window.svMoveBadgeToPoint(target, x, y) — an additive
   engine helper that raycasts the jacket and re-places the SAME design at the
   hit point through the engine's own sizing path (no squish, price unchanged).
   Self-contained IIFE; additive; does not touch the Replace block above.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svMoveInit) return; /* Theme Editor re-runs this script */
  window.__svMoveInit = true;

  var TAP_PX = 10;              /* movement under this = a tap, not a rotate-drag */
  var moveMode = false;
  var moveTarget = null;        /* the placed badge mesh being moved */
  var moveBanner = null;
  var downX = null, downY = null;

  function showMoveBanner() {
    if (!moveBanner) {
      moveBanner = document.createElement('div');
      moveBanner.className = 'sv-replace-banner sv-move-banner';
      moveBanner.innerHTML =
        '<span class="sv-replace-banner-text">Tap a new spot on the jacket</span>' +
        '<button type="button" class="sv-replace-banner-cancel" aria-label="Cancel move">Cancel</button>';
      moveBanner.querySelector('.sv-replace-banner-cancel').addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation(); exitMoveMode();
      });
      document.body.appendChild(moveBanner);
    }
    moveBanner.classList.add('is-visible');
  }
  function hideMoveBanner() { if (moveBanner) moveBanner.classList.remove('is-visible'); }

  function enterMoveMode(target) { moveTarget = target; moveMode = true; downX = downY = null; showMoveBanner(); }
  function exitMoveMode() { moveMode = false; moveTarget = null; downX = downY = null; hideMoveBanner(); }

  /* Record the gesture start so we can tell a tap from a rotate-drag.
     Recorded from pointerdown AND touchstart: we must not depend on the
     pointer-event sequence surviving the engine's own canvas handlers. */
  document.addEventListener('pointerdown', function (e) {
    if (!moveMode) return;
    downX = e.clientX; downY = e.clientY;
  }, true);

  document.addEventListener('touchstart', function (e) {
    if (!moveMode) return;
    var t = e.touches && e.touches[0];
    if (t) { downX = t.clientX; downY = t.clientY; }
  }, true);

  /* GHOST PURGE (2026-08-20) — the engine helper drops the old badge from the
     PRICING array unconditionally but removes it from the SCENE inside a
     swallowed try/catch:

         try { if (B && svOld.mesh) B.remove(svOld.mesh); } catch (e) {}
         var svRi = G.indexOf(svOld); if (svRi !== -1) G.splice(svRi, 1);

     If that scene removal does not happen, the old mesh is orphaned: still
     drawn, no longer priced. Observed on staging immediately after the
     touchend fix landed — 2 hearts on the jacket, TOTAL £59.00 (one badge).
     That is arguably worse than the overcharge it replaced: the customer sees
     two badges, pays for one, and receives one.

     We cannot edit the minified helper, so purge from the mesh's OWN parent
     rather than trusting the engine's scene reference. No-ops safely when the
     helper already did its job (parent is null).

     MUST be shape-agnostic. The decal list holds EITHER a raw mesh OR a
     { mesh: ... } wrapper — the engine itself defends against both:
         G.findIndex(function (d) { return (d && (d.mesh || d)) === svTargetMesh; })
     A first version of this purge assumed a raw mesh, so when it was handed a
     wrapper `.parent` was undefined and the purge silently did nothing — the
     ghost survived and looked like the purge had failed outright. Resolve the
     mesh the same way the engine does before touching it. */
  function resolveMesh(t) {
    if (!t) return null;
    if (t.isMesh) return t;
    if (t.mesh && t.mesh.isMesh) return t.mesh;
    if (t.mesh) return t.mesh;
    return t;
  }

  function purgeGhost(target) {
    try {
      var mesh = resolveMesh(target);
      if (mesh && mesh.parent && typeof mesh.parent.remove === 'function') {
        mesh.parent.remove(mesh);
        if (typeof window.svSetNeedsRender === 'function') window.svSetNeedsRender();
      }
    } catch (err) { /* never let cleanup break the move */ }
  }

  /* Shared tap -> move. True only when the badge was actually relocated. */
  function tryMoveAt(clientX, clientY) {
    var old = moveTarget;
    try {
      if (moveTarget && typeof window.svMoveBadgeToPoint === 'function') {
        var ok = window.svMoveBadgeToPoint(moveTarget, clientX, clientY);
        if (ok) purgeGhost(old); /* the helper may have left it in the scene */
        return ok;
      }
    } catch (err) { /* helper guards internally */ }
    return false;
  }

  function movedTooFar(x, y) {
    if (downX === null) return false;
    return Math.sqrt(Math.pow(x - downX, 2) + Math.pow(y - downY, 2)) > TAP_PX;
  }

  /* ======================================================================
     WHY THIS INTERCEPTS touchend AS WELL AS click  (fix 2026-08-20)

     The engine binds badge placement to the canvas TWICE:
         g.addEventListener("click", Ut, true);
         g.addEventListener("touchend", <handler that calls Ut(...)>,
                            { passive: true });

     On a touch device `touchend` fires BEFORE the synthetic click, so a
     click-only interceptor never got a say: the engine dropped a NEW badge
     at the tap point before Move was ever consulted, and the customer was
     charged £4 for the duplicate. The original was left where it was.

     Measured on LIVE 2026-08-20 from a zero baseline:
         place one badge      -> 1placed, £59.00
         Move -> tap new spot -> 2placed, £63.00, a badge on BOTH chests

     It worked with a mouse (no touchend), which is why it read as a
     mobile-only bug. `svMoveBadgeToPoint` itself was always correct.

     stopImmediatePropagation at DOCUMENT CAPTURE runs before the canvas's
     own listener and stops it even though that listener is passive —
     passive only forbids preventDefault, it never blocks propagation
     control. We then swallow the synthetic click so the engine's click
     binding cannot place a second badge either.

     ⛔ REVISED 2026-08-28 — THE OLD SHAPE WAS CORRECT ONLY WHEN IT FAILED.
     This block used to call preventDefault() on the touchend and then latch a
     boolean for 700ms to "swallow the follow-up click". But preventDefault on a
     non-passive touchend CANCELS that follow-up click in iOS Safari and Chrome.
     So on mobile — the normal path — no synthetic click ever arrived, the latch
     sat armed with nothing to eat, and the first REAL click within 700ms was
     swallowed instead. Reachable defect: tap off-jacket while Move is armed (the
     helper no-ops, Move stays armed), then tap Cancel inside 700ms — Cancel is
     eaten. The latch only behaved as designed in the branch where preventDefault
     did NOT work.

     Now: stopImmediatePropagation ONLY (invariant 13), so the synthetic click
     DOES arrive and we consume the exact event we armed for, identified by time
     AND position the way SV ONE TAP ONE BADGE does. A boolean can only ever mean
     "the next click"; identity means "that click".
     ====================================================================== */
  var GHOST_MS = 800;   /* browsers emit the synthetic click ~300ms after touchend */
  var GHOST_PX = 40;    /* and at essentially the same point */
  var ghostAt = 0, ghostX = 0, ghostY = 0;
  var ghostsArmed = 0, ghostsSwallowed = 0;   /* a guard you cannot see fail is not a guard */

  function armGhost(x, y) { ghostAt = Date.now(); ghostX = x; ghostY = y; ghostsArmed++; }

  function isGhost(e) {
    if (!ghostAt) return false;
    if (Date.now() - ghostAt > GHOST_MS) return false;
    /* Our own UI is never a ghost. Cancel must always reach its handler, even if
       the failed tap that armed us happened to land near the banner. */
    if (e.target && e.target.closest && e.target.closest('.sv-replace-banner')) return false;
    return Math.abs(e.clientX - ghostX) <= GHOST_PX &&
           Math.abs(e.clientY - ghostY) <= GHOST_PX;
  }

  document.addEventListener('touchend', function (e) {
    if (!moveMode) return;
    if (e.target && e.target.closest && e.target.closest('.sv-replace-banner')) return; /* our UI */
    if (e.touches && e.touches.length !== 0) return; /* still multi-touch */

    var t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    if (movedTooFar(t.clientX, t.clientY)) { downX = downY = null; return; } /* rotate-drag */
    downX = downY = null;

    /* Take the whole gesture before the canvas sees it.
       stopImmediatePropagation ONLY — never preventDefault here. The synthetic
       click that follows is load-bearing: it is the event the suppressor below
       consumes. Cancelling it is what left the old latch armed with nothing to
       eat but the customer's next real tap. */
    e.stopImmediatePropagation();

    /* Arm for the ghost click that trails this touch: on an off-jacket tap the
       helper no-ops, and letting that click through would place a badge exactly
       where the move just failed. */
    armGhost(t.clientX, t.clientY);
    if (tryMoveAt(t.clientX, t.clientY)) exitMoveMode(); /* else stay armed */
  }, { capture: true, passive: false });

  /* CAPTURE-phase click: the desktop path, and the mop-up after touch. */
  document.addEventListener('click', function (e) {
    if (isGhost(e)) {
      ghostAt = 0;                /* consumed — one ghost per touch, never two */
      ghostsSwallowed++;
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (!moveMode) return;
    if (e.target && e.target.closest && e.target.closest('.sv-replace-banner')) return; /* our UI */

    if (movedTooFar(e.clientX, e.clientY)) { downX = downY = null; return; } /* rotate-drag */
    downX = downY = null;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (tryMoveAt(e.clientX, e.clientY)) exitMoveMode(); /* off-jacket keeps it armed */
  }, true);

  /* Inject the "Move" button into the badge action menu each time it opens. */
  function injectMove(menu) {
    if (!menu || menu.querySelector('#context-action-move')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sv-badge-action-item sv-move-action';
    btn.id = 'context-action-move';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="5 9 2 12 5 15"></polyline>' +
      '<polyline points="9 5 12 2 15 5"></polyline>' +
      '<polyline points="15 19 12 22 9 19"></polyline>' +
      '<polyline points="19 9 22 12 19 15"></polyline>' +
      '<line x1="2" y1="12" x2="22" y2="12"></line>' +
      '<line x1="12" y1="2" x2="12" y2="22"></line>' +
      '</svg><span>Move</span>';
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var target = window.svActiveBadge || null; /* read BEFORE the menu closes */
      if (!target) return;
      enterMoveMode(target);
      if (menu.parentNode) menu.parentNode.removeChild(menu); /* dismiss the menu */
    });
    /* Sit directly above Remove (and below Replace, which prepends to firstChild). */
    var remove = menu.querySelector('#context-action-remove');
    if (remove) menu.insertBefore(btn, remove);
    else menu.appendChild(btn);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('sv-badge-action-menu')) injectMove(n);
          else if (n.querySelector) {
            var m = n.querySelector('.sv-badge-action-menu');
            if (m) injectMove(m);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* A guard you cannot see fail is not a guard. The shape to expect after a
     touch move is armed === swallowed. armed climbing while swallowed stays
     flat means the synthetic click is not arriving and the engine's click
     binding is free to place a duplicate — the original 08-20 defect. */
  window.svAuditMove = function () {
    var n = 0;
    try { window.threeScene.traverse(function (o) { if (o.userData && o.userData.badge) n++; }); } catch (e) {}
    var cost = null;
    try { cost = window.calculateCustomizationCosts(); } catch (e) {}
    var report = {
      ghostsArmed: ghostsArmed,
      ghostsSwallowed: ghostsSwallowed,
      moveModeNow: moveMode,
      badgesInSceneNow: n,
      customisationCostNow: cost,
      windowMs: GHOST_MS, windowPx: GHOST_PX
    };
    if (ghostsArmed > 0 && ghostsSwallowed === 0) {
      console.warn('SV MOVE AUDIT: ' + ghostsArmed + ' armed, 0 swallowed — the ' +
                   'synthetic click is not reaching the suppressor. Check for a ' +
                   'preventDefault on touchend upstream.', report);
    } else {
      console.log('SV MOVE AUDIT', report);
    }
    return report;
  };
})();

/* ===========================================================================
   SV REMOVE — fix "Remove Badge" not firing on mobile (2026-08-20)
   Same root cause class as SV MOVE / SV REPLACE above, but the specific
   mechanism is the iOS Safari "no synthetic click for an element created
   during the gesture" quirk: #context-action-remove is built by
   document.body.appendChild(...) in direct response to the long-press that
   opened the menu, so it did not exist at touchstart. iOS then frequently
   drops the synthetic click that would normally follow touchend, so the
   button's own (correct) click listener never runs and only the menu
   closes — exactly what was reported: menu opens, tap Remove, nothing
   removed. Self-contained IIFE; additive; does not touch Move or Replace.
   Forces the SAME existing, correct click listener by calling btn.click()
   ourselves from a capture-phase touchend — no need to duplicate removal
   logic. That listener is registered {once:true}, so even if iOS also
   manages to deliver its own natural click afterwards, it is a no-op.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svRemoveFixInit) return; /* Theme Editor re-runs this script */
  window.__svRemoveFixInit = true;

  document.addEventListener('touchend', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    var target = t && t.target;
    var btn = target && target.closest ? target.closest('#context-action-remove') : null;
    if (!btn) return;

    e.stopImmediatePropagation();
    /* This listener is {passive:false}, so preventDefault is always permitted.
       It used to be wrapped in try/catch "for passive contexts" — dead code:
       preventDefault in a passive listener returns silently, it never throws,
       so the catch could not run and the comment described a failure mode that
       does not exist. Nothing load-bearing follows here — the menu is torn down
       and the button's own listener is {once:true} — so cancelling iOS's own
       synthetic click is safe and wanted. */
    e.preventDefault();
    btn.click();
  }, { capture: true, passive: false });
})();

/* ===========================================================================
   SV PLACEMENT VIEW — drop the sheet while placing a badge (2026-08-20)
   Owner report: on mobile the jacket is too small/far away to place badges.
   Root cause is layout, not camera: selecting a badge enters placement mode
   but leaves the bottom sheet expanded (up to 72dvh), so the customer places
   badges on a ~28% sliver of jacket. This block auto-collapses the sheet to
   its 120px peek when a badge tile is tapped on mobile, and re-expands it on
   "Done placing" so the flow resumes where it left off.
   Capture-phase listeners: tile handlers stopPropagation at target phase,
   which cannot stop a document-capture listener — same technique as SV MOVE.
   NOTE the camera itself stays put: the engine's exposed camera helpers
   (animateCameraToArea / returnCameraToOriginal) guard on `threeControls`,
   which is never assigned anywhere — they are unreachable. A placement
   dolly-in needs a one-line engine export first (the svMoveBadgeToPoint
   pattern). Pinch-zoom (floor 2.05 on mobile) still works meanwhile.
   Self-contained IIFE; additive; does not touch Move, Replace or Remove.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svPlacementViewInit) return; /* Theme Editor re-runs this script */
  window.__svPlacementViewInit = true;

  var collapsedByUs = false;

  function getSheet() {
    return document.getElementById('nike-bottom-sheet') ||
           document.querySelector('.nike-bottom-sheet');
  }
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  /* Badge tile tapped → the engine enters placement mode and shows the
     "Tap the jacket to place it" toast. Let the engine take the tap first,
     then drop the sheet so there is actually a jacket to tap. */
  function maybeCollapse(e) {
    if (!isMobile()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.mobile-sv-badge-item[data-badge-id]')) return;
    var s = getSheet();
    if (!s || !s.classList.contains('expanded')) return;
    setTimeout(function () {
      s.classList.remove('expanded');
      s.style.transform = ''; /* the swipe path leaves inline transforms behind */
      collapsedByUs = true;
    }, 250);
  }
  document.addEventListener('click', maybeCollapse, true);
  document.addEventListener('touchend', maybeCollapse, true);

  /* "Done placing" → bring the sheet back, but only if we hid it. A sheet
     the customer re-opened or closed themselves is their choice to keep. */
  function maybeRestore(e) {
    if (!collapsedByUs) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('#floating-done-placing-btn')) return;
    collapsedByUs = false;
    var s = getSheet();
    if (!s) return;
    setTimeout(function () {
      s.classList.add('expanded');
      s.style.transform = '';
    }, 250);
  }
  document.addEventListener('click', maybeRestore, true);
  document.addEventListener('touchend', maybeRestore, true);
})();

/* ===========================================================================
   SV NO CONTACT SHADOW — remove the blob shadow under the jacket (2026-08-20)
   Owner ask: the soft radial "contact shadow" plane under the model doesn't
   read well and should go. Not baked into the GLB — jacket-cf.js generates it
   entirely at scene setup: a canvas radial-gradient texture on a flat
   THREE.PlaneGeometry(2.4, 2.4), exposed as window._svContactShadow.
   Hiding rather than deleting the object: the engine's own bounding-box
   centering code repositions/rescales this exact mesh on every model load
   (base switch, gender switch, reset) and would throw if the object it
   expects to find were gone. Self-contained IIFE; additive; polls briefly
   because the mesh is created synchronously during initial scene setup,
   before this script is guaranteed to have run.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svNoContactShadowInit) return; /* Theme Editor re-runs this script */
  window.__svNoContactShadowInit = true;

  function hideIt() {
    if (window._svContactShadow) {
      window._svContactShadow.visible = false;
      return true;
    }
    return false;
  }

  if (!hideIt()) {
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (hideIt() || tries > 100) clearInterval(poll); /* ~10s ceiling */
    }, 100);
  }
})();

/* ===========================================================================
   SV GARMENT FIT — margin-based default framing (2026-08-20)
   Owner ask: the gilet should start closer (no sleeves), the jacket framed so
   the sleeves just fit. Designer rule applied: frame every garment to a
   UNIFORM MARGIN, not a uniform distance. Measure the garment's bounding box,
   then set camera distance so the larger of (height, width-for-aspect) fills
   the frame with 10% margin each side. A narrow gilet naturally comes closer;
   a wide jacket backs off exactly enough for the cuffs. fov and aspect are
   read live from the camera — no guessed constants. Angles preserved: only
   the distance along the camera's existing direction changes. Collar view is
   exempt (it has its own deliberate close framing and target offset).
   Runs on mobile only for now. Rails match the zoom system: [1.05, 4].
   Triggers: initial load (poll), and after update3DView/reset3DModelView
   (wrapped with try/finally so an engine throw cannot skip the fit).
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svGarmentFitInit) return; /* Theme Editor re-runs this script */
  window.__svGarmentFitInit = true;

  var MARGIN = 0.10, MIN_D = 1.05, MAX_D = 4, SETTLE_MS = 700;

  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
  function activeView() {
    var el = document.querySelector('.view-btn.active');
    return (el && el.getAttribute('data-view')) || 'front';
  }
  /* Effective visibility: a mesh only counts if itself AND every ancestor
     is visible. The scene carries invisible raycast proxies (proxy_male_jacket,
     2x3x0.8) and hidden stud templates — measuring those framed the warehouse,
     not the garment (caught on first verify: box came back 2x3, camera pushed
     to 3.87). */
  function isShown(o) {
    while (o) { if (o.visible === false) return false; o = o.parent; }
    return true;
  }
  function garmentBox() {
    if (!window.threeScene || typeof THREE === 'undefined') return null;
    var box = new THREE.Box3(), found = false;
    window.threeScene.traverse(function (o) {
      if (o.isMesh && o !== window._svContactShadow && isShown(o)) { box.expandByObject(o); found = true; }
    });
    if (!found) return null;
    var s = new THREE.Vector3(); box.getSize(s);
    if (!isFinite(s.x) || !isFinite(s.y) || s.y < 0.3) return null; /* garment not loaded yet */
    return box;
  }

  function fit() {
    if (!isMobile()) return;
    if (activeView() === 'collar') return; /* deliberate close-up, leave it */
    var cam = window.threeCamera, box = garmentBox();
    if (!cam || !box) return;
    var c = new THREE.Vector3(); box.getCenter(c);
    var s = new THREE.Vector3(); box.getSize(s);
    var t = Math.tan((cam.fov * Math.PI / 180) / 2);
    if (!t || !cam.aspect) return;
    /* Height breathes (10%); width runs near-flush (2%) — on a portrait
       phone the cuff-to-cuff span sets the distance, and a generous width
       margin just pushes the garment away. Sleeves should kiss the frame. */
    var dH = (s.y / 2) * (1 + MARGIN) / t;
    var dW = (Math.max(s.x, s.z) / 2) * 1.02 / (t * cam.aspect);
    var d = Math.max(dH, dW) + s.z / 2; /* front face must clear, not the centre */
    d = Math.max(MIN_D, Math.min(MAX_D, d));
    var dir = cam.position.clone().sub(c);
    if (dir.lengthSq() < 1e-6) return;
    dir.normalize();
    /* Owner feedback 2026-08-20: the first version snapped ("it kind of
       jumps"). Tween the distance over 450ms, easeOutCubic — same family
       as the sheet's own 0.3s ease. A re-trigger cancels the previous
       tween so double-fits (radio path fires at 800ms and 2400ms) blend. */
    var from = cam.position.distanceTo(c);
    if (Math.abs(from - d) < 0.02) return; /* already framed */
    if (window.__svFitAnim) cancelAnimationFrame(window.__svFitAnim);
    var start = null, DUR = 450;
    function stepA(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / DUR, 1);
      var e = 1 - Math.pow(1 - p, 3);
      cam.position.copy(c.clone().add(dir.clone().multiplyScalar(from + (d - from) * e)));
      cam.lookAt(c);
      if (typeof window.svSetNeedsRender === 'function') window.svSetNeedsRender();
      if (p < 1) window.__svFitAnim = requestAnimationFrame(stepA);
      else window.__svFitAnim = null;
    }
    window.__svFitAnim = requestAnimationFrame(stepA);
  }
  function later() { setTimeout(fit, SETTLE_MS); }

  /* Re-fit after the engine's own view moves. try/finally: the engine's
     updateCameraPosition tail throws (applyZoom is not defined anywhere),
     and the fit must run regardless. */
  ['update3DView', 'reset3DModelView'].forEach(function (name) {
    var done = false;
    function wrap() {
      if (done || typeof window[name] !== 'function') return;
      var orig = window[name];
      window[name] = function () {
        try { return orig.apply(this, arguments); } finally { later(); }
      };
      done = true;
    }
    wrap(); setTimeout(wrap, 1500); setTimeout(wrap, 3500);
  });

  /* Style/gender changes (Jacket ↔ Gilet, Men's ↔ Women's) are VISIBILITY
     FLIPS on the loaded model — they never pass through update3DView or
     reset3DModelView, so the wrappers above cannot see them (caught on
     verify: gilet selected, sleeves hidden, camera still parked at the
     jacket's distance). Listen to the radios directly, and fit twice —
     once after the flip, once after the engine's show/hide animation
     settles (a mid-animation box measures ~0.5 wide and lies). */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="radio"]')) return;
    if (!/^(Jacket|Gilet|Male|Female)$/.test(t.value || '')) return;
    setTimeout(fit, 800);
    setTimeout(fit, 2400);
  }, true);

  /* Initial load: poll until camera + garment exist, fit once. Full model
     reloads end in a reset/update call the wrappers catch. */
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    if (window.threeCamera && garmentBox()) { clearInterval(poll); fit(); }
    else if (tries > 120) clearInterval(poll); /* ~30s ceiling */
  }, 250);
})();

/* ===========================================================================
   SV GENDER SYNC — heal the split-brain between controls and model (2026-08-20)
   Owner repro: male gilet on screen → press "Full Jacket" → male jacket →
   flips to a WOMEN'S jacket. Root cause, reproduced with a crafted URL:
   three persistence layers (URL params baked by the chooser via replaceState,
   sv-chooser-pick in localStorage, and the saved-design restore) apply at
   different moments. The chooser's S() stamps the CONTROLS ~50ms after
   DOM-ready and trusts change events to move the model — but the engine
   binds its handlers after THREE/GLB init, so those events land on nobody.
   Result: every gender control says Female while jacket-Male renders
   (verified live; engine then logs "Current model: Female" over a male
   scene). The next style press re-reads the poisoned controls → surprise
   gender swap.
   Fix: once the engine is ready (and again after the async design-restore
   settles), read the RENDERED truth — which jacket-<G> group is visible,
   whether sleeves are shown — and silently re-align every control layer
   (both radio sets, the selects, the URL params) to match. No change events
   are dispatched: this aligns state, it must never trigger swaps. What the
   customer sees is what the system believes. Idempotent; runs 3 times.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svGenderSyncInit) return; /* Theme Editor re-runs this script */
  window.__svGenderSyncInit = true;

  function shown(o) {
    while (o) { if (o.visible === false) return false; o = o.parent; }
    return true;
  }

  function renderedState() {
    if (!window.threeScene) return null;
    var gender = null, sleeves = false;
    window.threeScene.traverse(function (o) {
      var n = o.name || '';
      if (/^jacket-Male$/i.test(n) && o.visible) gender = 'Male';
      else if (/^jacket-Female$/i.test(n) && o.visible) gender = 'Female';
      if (o.isMesh && /Sleeve/i.test(n) && shown(o)) sleeves = true;
    });
    if (!gender) return null;
    return { gender: gender, style: sleeves ? 'Jacket' : 'Gilet' };
  }

  function setRadios(name, value) {
    document.querySelectorAll('input[name="' + name + '"]').forEach(function (r) {
      r.checked = (r.value === value);
    });
  }

  /* 2026-09-22 (Women's Gilet): while a model change is in flight, the OLD
     model is still the rendered one. Reading it as the truth wrote "Male" back
     over a Women's chooser pick; the DENIM WASH GATE then fired a real change on
     that stale radio and the engine switched to Men's. Measured on DEV: pick
     Women's Gilet, end on mens_gilet_blue. So never read the scene mid-switch;
     wait until it settles.
     Rollback: pending-patches/sv-owner-fixes.PRE-liveGiletNoAuto.LIVE-ROLLBACK.js */
  function switching() {
    if (window._svChooserApplying) return true;
    if (document.body.classList.contains('sv-price-muted')) return true;
    var sp = document.getElementById('loading-spinner');
    return !!(sp && sp.classList.contains('show'));
  }

  function settledSync(left) {
    if (switching()) { if (left > 0) setTimeout(function () { settledSync(left - 1); }, 500); return; }
    sync();
  }

  function sync() {
    if (switching()) return false;
    var truth = renderedState();
    if (!truth) return false;
    setRadios('ui-gender', truth.gender);
    setRadios('ui-mobile-gender', truth.gender);
    setRadios('ui-style', truth.style);
    setRadios('ui-mobile-style', truth.style);
    var gSel = document.getElementById('gender');
    if (gSel && gSel.value !== truth.gender) gSel.value = truth.gender;
    var sSel = document.getElementById('jacket-style');
    if (sSel && sSel.value !== truth.style) sSel.value = truth.style;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('gender') && u.searchParams.get('gender') !== truth.gender.toLowerCase()) {
        u.searchParams.set('gender', truth.gender.toLowerCase());
        u.searchParams.set('style', truth.style.toLowerCase());
        window.history.replaceState({}, '', u.toString());
      }
    } catch (e) { /* URL API unavailable — controls are the part that matters */ }
    return true;
  }

  /* Engine-ready poll, then re-sync after the async design-restore window. */
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    if (sync()) {
      clearInterval(poll);
      setTimeout(function () { settledSync(40); }, 2500);
      setTimeout(function () { settledSync(40); }, 6000);
    } else if (tries > 120) clearInterval(poll); /* ~30s ceiling */
  }, 250);
})();

/* ===========================================================================
   SV CONSENT MODAL ORDER — hold the saved-session modal until the cookie
   choice is made (2026-08-20, found by break_the_ui)
   On a return visit with a saved design and no consent decision yet, Shopify's
   consent banner (#shopify-pc__banner, z-index 2000000) covers every control
   of the "Continue Your Design" modal (.continue-design-overlay, z-index
   100000). Measured with elementFromPoint at each control's centre: the saved
   design card, "Start Fresh" and "Continue Design" all returned the banner,
   not the button. The customer is shown a dialog they cannot operate, with no
   indication why.
   Raising the modal above the banner is the WRONG fix: on a 375px-wide phone
   the banner is 415px tall, so the two cannot both fit, and burying a consent
   UI under an app modal is worse than the bug. The correct order is consent
   first, then the app's own dialog.
   Deliberately scoped to the AUTO-APPEARING saved-session modal only. The
   other .svm-overlay modals (size chart, size confirmation, gender change,
   design manager) are user-initiated — holding those would turn a deliberate
   tap into a silent no-op, a worse bug than the one being fixed. Their
   overlap with the banner is a UX trade-off for the owner to call, not a
   defect to patch here.
   Self-contained IIFE; additive; makes no engine calls.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svConsentModalOrderInit) return; /* Theme Editor re-runs this script */
  window.__svConsentModalOrderInit = true;

  var HELD = 'sv-held-for-consent';
  var SEL  = '.continue-design-overlay, #continue-design-overlay';

  /* Shopify puts the banner in the DOM before showing it and removes it on
     choice, so test real visibility rather than mere existence. */
  function consentPending() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var r = b.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var cs = window.getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  /* visibility, not display: the modal keeps its box, so any engine code that
     measures it still reads sane numbers. */
  function hold(ov) {
    if (ov.classList.contains(HELD)) return;
    ov.classList.add(HELD);
    ov.style.visibility = 'hidden';
    ov.style.pointerEvents = 'none';
  }
  function release(ov) {
    if (!ov.classList.contains(HELD)) return;
    ov.classList.remove(HELD);
    ov.style.visibility = '';
    ov.style.pointerEvents = '';
  }

  function sweep() {
    var pending = consentPending();
    document.querySelectorAll(SEL).forEach(function (ov) {
      if (pending) hold(ov); else release(ov);
    });
  }

  sweep();

  /* The modal is created with document.body.appendChild, so childList on body
     alone catches it — no subtree, no attribute filter. A subtree/attribute
     observer would fire constantly against the 3D engine's own DOM churn.
     hold() and release() are both idempotent, so the observer cannot feed
     itself into a loop. */
  if (document.body) {
    new MutationObserver(sweep).observe(document.body, { childList: true });
  }

  /* Shopify can drop the banner without a mutation we observe, so also poll
     briefly for the consent choice landing. */
  var ctries = 0;
  var cpoll = setInterval(function () {
    sweep();
    if (++ctries > 240) clearInterval(cpoll); /* ~60s ceiling */
  }, 250);
})();

/* ===========================================================================
   SV RESTORE ASSET MAP  —  P0: "Continue My Design" restored ZERO badges
   ---------------------------------------------------------------------------
   Found by break_the_ui pass 3 (2026-08-22). A customer could design a jacket,
   come back, tap "Continue My Design", and get an EMPTY jacket at base price.
   Measured: saved blob held designState.badges = 1; restored scene held 0 and
   the price fell back to £55.00. Reproduced twice from clean starts.

   Root cause — the engine's restoreStockBadge() resolves the badge image as:

     window.JACKET_ASSETS && window.JACKET_ASSETS.badges &&
     window.JACKET_ASSETS.badges[record.filename]
       ? load from Theme Assets
       : load from a hardcoded https://cdn.shopify.com/s/files/1/... path

   window.JACKET_ASSETS exists but only ever carries { hdrPath, logoPath,
   badgeBaseUrl } — there is NO .badges map, so that test can never pass. Every
   restore took the fallback, and the fallback 404s:

     ⚠️ Using fallback CDN path for badge: a-blue-white.png
     404  https://cdn.shopify.com/s/files/1/0845/0450/files/a-blue-white.png
     ❌ Failed to load stock badge image: a-blue-white.png

   The gallery loads the very same PNG fine from the Theme Assets base, so the
   asset is present — only the restore path looked in the wrong place.

   The fix is to populate the map the engine already asks for, from the same
   base the gallery uses. No engine edit, and it puts the restore back on the
   branch its author intended (the one that logs "Loading badge from Theme
   Assets"). If this block never runs, behaviour is exactly as it is today.

   Deliberately does NOT overwrite an existing entry — if a future theme build
   ships a real .badges map, that map wins.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svBadgeAssetMapInit) return; /* Theme Editor re-runs this script */
  window.__svBadgeAssetMapInit = true;

  function assetBase() {
    var J = window.JACKET_ASSETS || {};
    var base = J.badgeBaseUrl || window.SHOPIFY_BADGE_ASSET_URL || null;
    /* ⛔ P0 (08-25, pass 21; LOST in the 08-26 overwrite, restored 08-26).
       Shopify's `asset_url` returns a PROTOCOL-RELATIVE url — `//shop.com/...`
       with no `https:` on the front. An Image() given that address never fires
       `load` AND never fires `error` — it hangs forever. The engine only places
       a badge once its image reports success, so the restore silently produces
       0 badges at £0 while logging "✅ Restored N/N" (that log fires when the
       loads are STARTED, not finished — it is structurally incapable of
       catching this).
       Deliberately narrow: an already-absolute url is left completely alone,
       so this cannot change behaviour for anything that already worked.
       Measured: `https://` loaded in 75ms; `//` still pending at 15s.
       Verified end-to-end on DEV and confirmed by Sam on a real phone
       (0 badges/£55.00 → 2 badges/£68.45). */
    if (base && base.indexOf('//') === 0) base = window.location.protocol + base;
    return base;
  }

  function populate() {
    var J    = window.JACKET_ASSETS;
    var data = window.svBadgesData && window.svBadgesData.badges;
    var base = assetBase();
    /* Both the asset base and the badge catalogue land asynchronously. Wait
       for all three rather than guessing an order. */
    if (!J || !base || !data || !data.length) return false;

    if (!J.badges) J.badges = {};
    var added = 0;
    for (var i = 0; i < data.length; i++) {
      var rec = data[i];
      if (rec && rec.filename && !J.badges[rec.filename]) {
        J.badges[rec.filename] = base + rec.filename;
        added++;
      }
    }
    console.log('SV RESTORE MAP: JACKET_ASSETS.badges populated — ' + added +
                ' entries, base=' + base);
    return true;
  }

  if (!populate()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (populate() || ++tries > 200) clearInterval(poll); /* ~30s ceiling */
    }, 150);
  }
})();

/* ===========================================================================
   SV AUTOSAVE SLIMMING  —  P0: autosave blew the localStorage quota silently
   ---------------------------------------------------------------------------
   Found by break_the_ui pass 3 (2026-08-22). Measured on DEV:

     localStorage['jacket-autosave-design'] = 6,339 KB (6.19 MB) for ONE badge
       embedded data URLs : 1
       base64 bytes       : 6,337 KB  =  100% of the payload
     Everything else on the whole origin: 20 KB across 15 keys.

   The badge record stores imageDataUrl — the full-resolution source PNG as
   base64. The stock art is large (a-blue-white.png is 1885x1980), so a single
   badge can exceed the entire quota. Observed at two badges on Chromium:

     ❌ Auto-save failed: QuotaExceededError: Failed to execute 'setItem' ...

   When it throws, the write is lost, the stored timestamp stops advancing, and
   the ONLY signal is a console line — the customer is told nothing and keeps
   designing against a save that is no longer happening. iOS Safari's quota is
   commonly 5 MB, below this single payload, and iOS is the main audience here.

   The stored imageDataUrl is redundant for STOCK badges: the record already
   carries badgeId, and restoreStockBadge() re-resolves the image from the
   catalogue by filename (which the block above now makes work). So we strip it
   on the way into storage for any badge that has a badgeId, and leave CUSTOM
   uploads untouched — they have no catalogue entry and imageDataUrl is their
   only copy. Measured effect: 6.19 MB -> 2.1 KB.

   ⚠️ Verified 2026-08-22: a CUSTOM upload keeps its imageDataUrl (213.6 KB,
   not stripped) and restores correctly — 3 of 3 runs at a full settle. Note a
   large custom upload can still exceed the quota on its own (a 2.5 MB PNG
   produces a 6.63 MB blob); that is pre-existing and NOT addressed here,
   because slimming it would mean re-encoding the customer's own artwork.

   ⚠️ Scope is deliberately the SERIALISED COPY ONLY. The live decal objects
   keep their imageDataUrl, so nothing the scene or the pricing reads changes.
   Checked before shipping: the cart payload is built from live state and its
   line-item properties are _design_studs, _design_custom_text,
   _design_camera_view, _design_zoom_level, _design_references_data,
   _design_session_id, _design_timestamp and _design_order_number. No badge
   image data goes to the order, so this cannot alter what is bought.

   Shadows localStorage.setItem rather than Storage.prototype.setItem to keep
   the blast radius off sessionStorage and off other apps on the origin. Any
   parse failure falls through and stores the original string unchanged.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svAutosaveSlimInit) return; /* Theme Editor re-runs this script */
  window.__svAutosaveSlimInit = true;

  var KEY = 'jacket-autosave-design';

  var original;
  try {
    original = localStorage.setItem.bind(localStorage);
  } catch (e) {
    return; /* storage unavailable (private mode) — nothing to patch */
  }

  localStorage.setItem = function (key, value) {
    if (key === KEY && typeof value === 'string') {
      try {
        var parsed = JSON.parse(value);
        var list = parsed && parsed.designState && parsed.designState.badges;
        if (Array.isArray(list)) {
          var before = value.length;
          var stripped = 0;
          for (var i = 0; i < list.length; i++) {
            var b = list[i];
            /* badgeId present => stock badge => image is re-resolvable */
            if (b && b.badgeId && b.imageDataUrl) { b.imageDataUrl = null; stripped++; }
          }
          if (stripped) {
            value = JSON.stringify(parsed);
            console.log('SV AUTOSAVE SLIM: stripped ' + stripped +
                        ' stock image(s), ' + Math.round(before / 1024) + 'KB -> ' +
                        Math.round(value.length / 1024) + 'KB');
          }
        }
      } catch (e) { /* leave `value` exactly as supplied */ }
    }
    return original(key, value);
  };
})();

/* ===========================================================================
   SV TOOLBAR GATE  —  P2: "Clear All" was unreachable on mobile
   ---------------------------------------------------------------------------
   Found by break_the_ui pass 3 (2026-08-22). With a badge placed on a phone,
   #floating-badge-toolbar carried an inline display:none, so BOTH of its
   buttons — "Clear All" and "Done placing" — had a 0x0 rect and could not be
   tapped. A customer could place badges and had no way to clear them; the only
   escape was per-badge Remove via long-press, or reloading the page.

   The engine's own gate:

     (G.length > 0 || Ce) && (l || c) ? show : hide
       l = #sv-badge-section.expanded || #custom-badge-section.expanded
       c = (currentStep === 4 || currentStep === 5)

   Measured with one badge placed on step 4/9: #floating-badge-count read "1",
   so bt() had run and the badge clause was TRUE. Both sections measured
   .expanded = false, so l was false — which means c was false too, on the step
   the UI labels 4/9 whose DOM index is 3. `currentStep` is module-scoped and
   cannot be read or set from here, so c is not a lever we can reach.
   bt() also does NOT re-run on step change: its last log line is at
   badge-placement time, and walking to 5/9 left the stale display:none behind.

   So the reachable lever is `l`. #sv-badge-section is the DESKTOP accordion
   panel and on mobile it sits inside .desktop-config-panel, which is
   display:none — verified at 390px, the section measures 0x0 and its hidden-by
   ancestor is .desktop-config-panel. Marking it .expanded therefore has NO
   visual effect on a phone; it only satisfies the gate. Same shape as the
   SV RESTORE MAP fix above: give the engine the state it already asks for
   rather than reimplement its logic or fight its inline styles.

   With l pinned true on mobile the gate reduces to "badges exist OR a placement
   is active", which is the semantic the toolbar actually wants. bt() then does
   the showing and the hiding itself.

   Verified identical on DEV and LIVE before writing this (same gate hash), so
   the one fix is correct for both.

   Functional test on DEV, not just visibility:
     one tap  -> "Sure?", badges and price UNCHANGED
     +4.2s    -> reverts to "Clear All", badges STILL intact (timeout is safe)
     two taps -> 0 badges, price back to base, "Cleared all badges"
   Layout at 390px and 320px: no overflow, no horizontal page scroll,
   Clear All 84x44 and Done placing 130x44 at both widths.

   ⚠️ The toolbar stays visible after a clear: G is empty but placement is still
   armed (Ce), which matches the engine's own "Ready to place new badges".
   Cosmetic — tapping Clear All on an empty array is a no-op.

   ⚠️ LIVE's jacket.css lacks the min-height:44px these buttons get on DEV, so
   on LIVE they render 84x32 / 130x32 — under the 44px touch minimum. That is a
   pre-existing CSS divergence, not caused by this gate; making the toolbar
   reachable is simply what exposed it. Tracked separately.

   ⚠️ Mobile-only by design. On desktop the accordion is a real control the
   customer opens, and the existing gate already works there — we must not
   force it open. The MutationObserver re-asserts only while still mobile, and
   arm() is a no-op when the class is already present, so it cannot loop.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svToolbarGateInit) return; /* Theme Editor re-runs this script */
  window.__svToolbarGateInit = true;

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function arm() {
    if (!isMobile()) return false;
    var sec = document.getElementById('sv-badge-section');
    if (!sec) return false;
    if (!sec.classList.contains('expanded')) {
      sec.classList.add('expanded');
      console.log('SV TOOLBAR GATE: armed — #sv-badge-section marked .expanded on mobile, ' +
                  'Clear All / Done placing now reachable');
    }
    return true;
  }

  var tries = 0;
  var poll = setInterval(function () {
    if (arm() || ++tries > 200) clearInterval(poll); /* ~30s ceiling */
  }, 150);

  /* The engine resets accordion state on some flows (base switch, restore).
     Re-assert, but only while we are still on a phone. */
  var wtries = 0;
  var watch = setInterval(function () {
    var sec = document.getElementById('sv-badge-section');
    if (sec) {
      clearInterval(watch);
      new MutationObserver(function () { arm(); })
        .observe(sec, { attributes: true, attributeFilter: ['class'] });
    } else if (++wtries > 100) clearInterval(watch); /* ~30s ceiling */
  }, 300);
})();

/* ===========================================================================
   SV BADGE HIT AREA  —  P1: Replace / Move / Remove unreachable by finger
   ---------------------------------------------------------------------------
   Found by break_the_ui pass 4 (2026-08-22) on real touch. A long-press on a
   placed badge logged `📐 ACTION MENU MODE` → `- Badge intersects found: 0` →
   `❌ No badge found at click position`, so the action menu — the ONLY route to
   Replace, Move and Remove Badge — could not be opened. Reproduced 5 runs.

   Root cause, settled with a temporary Raycaster wrapper (since removed). It
   re-ran the engine's OWN ray against the scene's badges as a control, which
   separates a bad target list from a bad ray:

     engineTargetsThatAreTheSceneBadges: 1   -> G holds the right badge, in-scene
     rayOrigin [0,0.600,1.600] == camera pos -> same camera, not stale
     controlHits: 0                          -> the ray itself misses
     ii(e)                                   -> standard, correct NDC formula

   So nothing is broken. The badge is simply a **15x13 px target that is still
   moving**: the camera is easing when the gesture is evaluated — two samples
   seconds apart read [0,0.600,1.600] then [0,0.616,1.638]. The menu fires
   during placement only because the tap point and the badge coincide by
   construction. A mouse lands it; a finger cannot.

   Fix: give each badge mesh a raycast ASSIST. The exact hit is tried first and
   always wins. Only if it misses do we fall back to a proximity test against
   the badge's bounding sphere, widened by a tolerance computed to be
   TARGET_RADIUS_PX on screen — converted to world units from the camera, so it
   stays a constant finger-sized target at any zoom.

   ⚠️ Deliberately DISABLED while placement is armed. The engine's own
   overlap guard raycasts these same meshes to decide "did you tap an existing
   badge?" — widening that would stop a customer placing a badge close to
   another one, trading this bug for a worse one. Placing keeps the exact test.

   Escape hatch: window.__svHitAreaOff = true disables the assist at runtime.
   Never throws — any failure falls through to the engine's original result.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svBadgeHitAreaInit) return; /* Theme Editor re-runs this script */
  window.__svBadgeHitAreaInit = true;

  var TARGET_RADIUS_PX = 22;   /* 44px across — the iOS minimum touch target */

  function placementArmed() {
    var pill = document.querySelector('.sv-place-pill');
    return !!(pill && pill.classList.contains('is-visible'));
  }

  function patch(mesh, T) {
    if (mesh.__svHitPatched) return false;
    var orig = mesh.raycast.bind(mesh);
    var _c = new T.Vector3(), _p = new T.Vector3(), _cam = new T.Vector3();

    mesh.raycast = function (raycaster, intersects) {
      var before = intersects.length;
      orig(raycaster, intersects);
      var dbg = window.__svHitDebug;            /* off unless explicitly switched on */
      if (intersects.length > before) {
        if (dbg) console.log('SVHIT: exact hit — assist not needed');
        return;                                 /* exact hit wins, always */
      }
      if (window.__svHitAreaOff) { if (dbg) console.log('SVHIT: bail — assist disabled'); return; }
      if (placementArmed()) { if (dbg) console.log('SVHIT: bail — placement armed'); return; }
      if (dbg) console.log('SVHIT: exact miss, trying assist');
      try {
        var geo = this.geometry;
        if (!geo) return;
        if (!geo.boundingSphere) geo.computeBoundingSphere();
        if (!geo.boundingSphere) return;

        this.updateWorldMatrix(true, false);
        _c.copy(geo.boundingSphere.center).applyMatrix4(this.matrixWorld);
        var rWorld = geo.boundingSphere.radius * this.matrixWorld.getMaxScaleOnAxis();

        /* screen pixels -> world units, so the target stays finger-sized at any zoom */
        var tol = rWorld;
        var cam = raycaster.camera;
        if (cam && cam.isPerspectiveCamera) {
          cam.getWorldPosition(_cam);
          var cv = document.getElementById('3d-preview-canvas');
          var vh = cv ? cv.getBoundingClientRect().height : 0;
          if (vh > 0) {
            var worldPerPx = (2 * _c.distanceTo(_cam) * Math.tan(cam.fov * Math.PI / 360)) / vh;
            tol = TARGET_RADIUS_PX * worldPerPx;
          }
        }

        if (raycaster.ray.distanceToPoint(_c) > (rWorld + tol)) return;

        raycaster.ray.closestPointToPoint(_c, _p);
        var travel = raycaster.ray.origin.distanceTo(_p);
        if (travel < raycaster.near || travel > raycaster.far) return;

        intersects.push({
          distance: travel, point: _p.clone(), object: this,
          face: null, faceIndex: null, uv: null, svHitAreaAssist: true
        });
      } catch (e) { /* never break a raycast — fall through to the exact result */ }
    };
    mesh.__svHitPatched = true;
    return true;
  }

  var announced = false;
  var tries = 0;
  var scan = setInterval(function () {
    var T = window.THREE, scene = window.threeScene;
    if (!T || !scene) { if (++tries > 300) clearInterval(scan); return; }
    var n = 0;
    scene.traverse(function (o) {
      if (o.isMesh && o.userData && o.userData.badge && patch(o, T)) n++;
    });
    if (n && !announced) {
      announced = true;
      console.log('SV BADGE HIT AREA: assist installed — badges now ' +
                  (TARGET_RADIUS_PX * 2) + 'px to the finger (exact hit still wins, ' +
                  'assist off while placing)');
    }
  }, 600);
})();

/* ===========================================================================
   SV TOOLBAR REPARENT  —  P1: jacket-aimed taps were hitting "Clear All"

   #floating-badge-toolbar is markup inside #3d-preview-container. That container
   carries `transform: translateY(...)`, and CSS makes a transformed element the
   CONTAINING BLOCK for any `position: fixed` descendant. So the toolbar's
   `bottom: 124px` stopped meaning "124px above the viewport" and started meaning
   "124px above the canvas" — parking a live tap target on the jacket.

   Measured on DEV 2026-08-22, viewport 393x659, both readings to the pixel:

     placing    container transform none   -> containing block = viewport
                toolbar bottom = 659 - 124 = 535   (canvas ends 463)  SAFE
     done       container translateY(-69.75) -> containing block = container
                toolbar bottom = 393 - 124 = 269   (canvas -20..393)  ON THE JACKET

   Two taps in that band hit Clear All -> "Sure?" -> the whole design is gone.

   Fix: on mobile, move the toolbar to <body> so nothing between it and the
   viewport is transformed, and `position: fixed` resolves against the viewport
   again. Paired with the SV TOOLBAR ANCHOR rule in sv-customiser-ui.css — that
   rule supplies the geometry, this supplies a containing block it can trust.
   Neither works alone.

   Desktop keeps the original parent: there the base rule is
   `position: absolute; top: 16px`, which is deliberately relative to the viewer.

   Escape hatch: window.__svToolbarReparentOff = true, then resize, to restore.
   =========================================================================== */
(function () {
  if (window.__svToolbarReparentInit) return;
  window.__svToolbarReparentInit = true;

  var MOBILE = '(max-width: 768px)';
  var homeParent = null;      /* original parent, so desktop can be restored */
  var homeNext = null;        /* original next sibling, to preserve DOM order */
  var announced = false;

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE).matches;
  }

  function apply() {
    var tb = document.getElementById('floating-badge-toolbar');
    if (!tb) return false;

    if (isMobile() && !window.__svToolbarReparentOff) {
      if (tb.parentNode === document.body) return true;   /* already moved */
      homeParent = tb.parentNode;
      homeNext = tb.nextSibling;
      document.body.appendChild(tb);
      if (!announced) {
        announced = true;
        console.log('SV TOOLBAR REPARENT: toolbar moved to <body> — ' +
                    'fixed positioning now resolves against the viewport, ' +
                    'not the transformed viewer container');
      }
      return true;
    }

    /* Desktop, or the escape hatch: put it back exactly where it was. */
    if (homeParent && tb.parentNode === document.body) {
      if (homeNext && homeNext.parentNode === homeParent) homeParent.insertBefore(tb, homeNext);
      else homeParent.appendChild(tb);
    }
    return true;
  }

  /* The toolbar is server-rendered, but re-run on resize so a rotation or a
     desktop/mobile crossover lands in the right parent. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  var rtries = 0;
  var rwatch = setInterval(function () {
    if (apply() || ++rtries > 100) clearInterval(rwatch);   /* ~30s ceiling */
  }, 300);

  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply);
})();


/* ============================================================================
   SV AUTOSAVE COVERAGE  —  P0: a back image or design references ALONE were
   never saved, so the whole design vanished on reload with no Continue prompt

   autoSaveSystem.saveNow() opens with a three-condition guard:

       const l = a.activeStuds && a.activeStuds.length > 0,
             r = a.badges      && a.badges.length > 0,
             c = a.customText  && a.customText.text;
       if (!l && !r && !c) { "Auto-save: No customizations to save"; return; }

   Those three predate the back image (+£50) and design references (+£15 each)
   becoming PAID features. A design made only of those is judged empty and
   thrown away — no blob is written at all, so on the next visit the customer
   is not even offered "Continue Your Design".

   Measured on DEV 199317193041, 2026-08-22, break_the_ui pass 6:
       clean slate            £55.00    blob 0 bytes
       back image uploaded    £105.00   blob 0 bytes   <- +£50 charged, nothing saved
       after a full 38s       £105.00   blob 0 bytes   <- interval is 30s
       reload                 the Continue modal is NOT OFFERED

   TWO barriers, so two halves to the fix:
     1. nothing calls markDirty() when either of these changes, so the 30s
        interval never even considers a save;
     2. even when a save IS triggered by something else (a stud will do it),
        captureDesignState() has no back-image field, so the back image is
        dropped anyway.

   WHAT THIS BLOCK DELIBERATELY DOES NOT DO: store image bytes.
   Design references serialise to metadata only — 188 bytes each, no data URL —
   so they are quota-safe. A back image cannot be: its File will not serialise
   and its localPreviewUrl is a blob: URL that is revoked when the page
   unloads. Persisting the bitmap would walk straight into the iOS ~5MB
   localStorage quota that is ALREADY an open P0 on the badge-upload path.

   So: the metadata is saved, every other choice the customer made is saved,
   and the Continue modal is made to SAY that the image files must be added
   again. That converts silent data loss into a visible, recoverable prompt.
   Making the images genuinely restorable needs the Cloudinary upload to move
   from cart-time to add-time — that is an owner decision, not a bug fix.
   ============================================================================ */
(function () {
  if (window.__svAutosaveCoverageInit) return;
  window.__svAutosaveCoverageInit = true;

  function backImageMeta() {
    try {
      var s = window.svBackImageState && window.svBackImageState();
      if (!s || !s.mesh) return null;
      var f = s.file || null;
      var slider = document.getElementById('mobile-sv-back-image-scale') ||
                   document.getElementById('sv-back-image-scale');
      return {
        name: (f && f.name) || '',
        size: (f && f.size) || 0,
        type: (f && f.type) || '',
        scale: typeof s.scale === 'number' ? s.scale : (slider ? Number(slider.value) : null),
        cloudinaryUrl: (typeof s.cloudinaryUrl === 'string' && s.cloudinaryUrl) || '',
        /* blob: previews die with the page, so without a Cloudinary URL the
           bitmap genuinely cannot come back. The modal reads this flag. */
        needsReupload: !(typeof s.cloudinaryUrl === 'string' && s.cloudinaryUrl)
      };
    } catch (e) { return null; }
  }

  function hasBackImage() { return !!backImageMeta(); }

  function refCount() {
    try {
      var m = window.imageUploadManager;
      return (m && m.uploadedFiles && m.uploadedFiles.length) || 0;
    } catch (e) { return 0; }
  }

  function pick(desktopId, mobileId, fallback) {
    var a = document.getElementById(desktopId);
    if (a && a.value) return a.value;
    var b = document.getElementById(mobileId);
    if (b && b.value) return b.value;
    return fallback;
  }

  /* ---- half 2: teach the serialiser about the back image --------------- */
  function patchCapture(dsm) {
    if (dsm.__svCoveragePatched) return;
    var orig = dsm.captureDesignState;
    if (typeof orig !== 'function') return;
    dsm.captureDesignState = function () {
      var st = orig.apply(this, arguments);
      try {
        var bi = backImageMeta();
        if (bi) st.svBackImage = bi;
      } catch (e) { /* never let a capture wrapper break a save */ }
      return st;
    };
    dsm.__svCoveragePatched = true;
  }

  /* ---- the guard itself ------------------------------------------------ */
  function patchSave(as, dsm) {
    if (as.__svCoveragePatched) return;
    var orig = as.saveNow;
    if (typeof orig !== 'function') return;

    as.saveNow = function (opts) {
      var before = null, after = null;
      try { before = localStorage.getItem(as.STORAGE_KEY); } catch (e) {}
      try { orig.apply(this, arguments); }
      catch (e) { console.warn('SV AUTOSAVE COVERAGE: engine saveNow threw', e); }
      try { after = localStorage.getItem(as.STORAGE_KEY); } catch (e) {}

      if (after !== before) return;          /* the engine saved — nothing to add */

      var bi = hasBackImage(), rc = refCount();

      if (!bi && !rc) {
        /* Nothing paid-for is left. If the STORED blob is one we wrote — it
           has no studs, badges or text either — it now describes a design that
           does not exist, and offering it back would be worse than offering
           nothing. Clear it.

           ONLY on a genuine user change, never on an interval tick. The
           engine's restore is asynchronous (waitForModelAndRestore polls for
           up to 15s), so between "Continue" and the studs actually landing
           there is a window where the design legitimately looks empty. An
           interval-driven save in that window would delete the customer's
           design mid-restore. Caught on DEV during pass 6 verification. */
        if (!(opts && opts.__svUserChange)) return;
        try {
          var cur = after ? JSON.parse(after) : null;
          var ds = cur && cur.designState;
          if (ds && !(ds.activeStuds || []).length && !(ds.badges || []).length &&
              !(ds.customText && ds.customText.text)) {
            localStorage.removeItem(as.STORAGE_KEY);
            as.isDirty = false;
            console.log('SV AUTOSAVE COVERAGE: cleared a stored design that no ' +
                        'longer has any customisations');
          }
        } catch (e) {}
        return;
      }

      /* The engine bailed on its three-condition guard, but the customer HAS
         paid-for customisations. Write the same shape it would have written. */
      try {
        var st = dsm.captureDesignState();
        var blob = {
          timestamp: new Date().toISOString(),
          designState: st,
          gender: pick('gender', 'mobile-gender', 'Male'),
          style:  pick('jacket-style', 'mobile-style', 'Jacket'),
          size:   pick('size', 'mobile-size', 'Medium'),
          summary: {
            studCount:  (st.activeStuds || []).length,
            badgeCount: (st.badges || []).length,
            hasCustomText: !!(st.customText && st.customText.text)
          }
        };
        localStorage.setItem(as.STORAGE_KEY, JSON.stringify(blob));
        as.isDirty = false;
        console.log('SV AUTOSAVE COVERAGE: saved a design the engine would have ' +
                    'discarded — back image: ' + (bi ? 'yes' : 'no') +
                    ', references: ' + rc);
      } catch (e) {
        console.warn('SV AUTOSAVE COVERAGE: fallback save failed', e);
      }
    };
    as.__svCoveragePatched = true;
  }

  /* ---- half 1: make these changes mark the design dirty ---------------- */
  function wireDirty(as) {
    if (as.__svCoverageWired) return;
    var deb = null;
    function touched(what) {
      try { as.markDirty(); } catch (e) {}
      clearTimeout(deb);
      /* The engine's own cadence is a 30s interval. These two are discrete,
         deliberate, PAID actions, so settle them quickly instead — a reload
         inside that window is exactly how the work was being lost. */
      deb = setTimeout(function () {
        /* the flag authorises the stale-blob clear — see patchSave */
        try { as.saveNow({ __svUserChange: true }); } catch (e) {}
      }, 1500);
      console.log('SV AUTOSAVE COVERAGE: ' + what + ' changed — marked dirty');
    }
    /* delegated + capture, so it survives the inputs being re-rendered */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.id) return;
      if (t.id === 'sv-back-image-file') touched('back image');
      else if (t.id === 'image-upload-input') touched('design references');
    }, true);

    /* removals must re-save too, or the blob keeps describing what was removed */
    if (typeof window.svRemoveBackImage === 'function' && !window.svRemoveBackImage.__svWrapped) {
      var origRemove = window.svRemoveBackImage;
      window.svRemoveBackImage = function () {
        var r = origRemove.apply(this, arguments);
        touched('back image removed');
        return r;
      };
      window.svRemoveBackImage.__svWrapped = true;
    }
    as.__svCoverageWired = true;
  }

  /* ---- make the loss visible at the moment of choice ------------------- */
  function decorateModal(ov) {
    if (!ov || ov.__svDecorated) return;
    var info = ov.querySelector('.saved-design-info');
    if (!info) return;
    ov.__svDecorated = true;

    var saved = null;
    try { saved = window.autoSaveSystem.getAutoSavedDesign(); } catch (e) {}
    var ds = saved && saved.designState;
    if (!ds) return;

    var bi = ds.svBackImage || null;
    var refs = Array.isArray(ds.uploadedImages) ? ds.uploadedImages.length : 0;
    if (!bi && !refs) return;

    var ago = info.querySelector('.time-ago');
    function addRow(label, value) {
      var d = document.createElement('div');
      d.className = 'info-row';
      var a = document.createElement('span'); a.className = 'info-label'; a.textContent = label;
      var b = document.createElement('span'); b.className = 'info-value'; b.textContent = value;
      d.appendChild(a); d.appendChild(b);
      if (ago) info.insertBefore(d, ago); else info.appendChild(d);
    }
    if (bi)   addRow('Back image', '1');
    if (refs) addRow('Design references', String(refs));

    var needs = (bi && bi.needsReupload) || refs > 0;
    if (needs) {
      var note = document.createElement('div');
      note.className = 'time-ago';
      note.style.color = '#b45309';
      note.style.fontWeight = '600';
      note.textContent = 'Your uploaded image files cannot be restored — ' +
                         'you will need to add them again.';
      if (ago) info.insertBefore(note, ago); else info.appendChild(note);
    }
    console.log('SV AUTOSAVE COVERAGE: continue modal now discloses back image / references');
  }

  var mo = new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var added = recs[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.id === 'continue-design-overlay') decorateModal(n);
        else if (n.querySelector) {
          var inner = n.querySelector('#continue-design-overlay');
          if (inner) decorateModal(inner);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  decorateModal(document.getElementById('continue-design-overlay'));

  /* The engine loads after this file, so poll for it the way the other blocks
     in here do rather than assuming a load order. */
  var tries = 0;
  var watch = setInterval(function () {
    var as = window.autoSaveSystem, dsm = window.designStateManager;
    if (as && dsm) {
      patchCapture(dsm);
      patchSave(as, dsm);
      wireDirty(as);
      clearInterval(watch);
      console.log('SV AUTOSAVE COVERAGE: installed — a back image or design ' +
                  'references now count as customisations worth saving');
    } else if (++tries > 100) {               /* ~30s ceiling */
      clearInterval(watch);
      console.warn('SV AUTOSAVE COVERAGE: autoSaveSystem/designStateManager never appeared');
    }
  }, 300);
})();


/* ============================================================================
   SV MODAL DISMISS  —  P1: any tap on the "Continue Your Design" backdrop, and
   the Escape key, both silently chose CONTINUE

   showContinueDesignModal() binds FOUR listeners, not the two you would expect:

       continue-design-btn  click   ->  a(), t(!0)                      = Continue
       start-fresh-btn      click   ->  clearAutoSave(), i.remove(), t(!1)
       i (the overlay)      click   ->  d.target === i && (a(), t(!0))  <-- backdrop
       document             keydown ->  key === "Escape" && (a(), t(!0)) <-- Escape

   `t(!0)` resolves the modal's promise TRUE, which means Continue. So both
   DISMISS gestures pick the option that changes the price and loads an old
   design — the opposite of what dismissing a dialog means anywhere else.
   Worse, a() then replaces the modal's innerHTML with a spinner veil, which
   DESTROYS #start-fresh-btn: the gesture that makes the mistake also removes
   the control that would undo it. Measured pass 6: one tap at (10,10) took
   £55.00 -> £65.50 with a 10s zero-gesture control proving it is not a timer.

   The listeners are inside the minified bundle and cannot be unbound, so this
   swallows the two gestures during the CAPTURE phase — a capture listener on
   document/window runs before the overlay's own target-phase listener, so
   stopPropagation() means the engine's handler never sees the event.

   Deliberately scoped to the window where the choice is still pending: once
   the engine swaps in its veil the buttons are gone, this stops firing, and
   Escape behaves normally everywhere else on the page.
   ============================================================================ */
(function () {
  if (window.__svModalDismissInit) return;
  window.__svModalDismissInit = true;

  function pendingOverlay() {
    var ov = document.getElementById('continue-design-overlay');
    if (!ov) return null;
    /* both buttons still present === the customer has not chosen yet */
    return (ov.querySelector('#start-fresh-btn') && ov.querySelector('#continue-design-btn'))
      ? ov : null;
  }

  document.addEventListener('click', function (e) {
    var ov = pendingOverlay();
    if (!ov) return;
    if (e.target !== ov) return;      /* a button or the card — let it through */
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
    console.log('SV MODAL DISMISS: backdrop tap swallowed — the customer must choose');
  }, true);

  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!pendingOverlay()) return;
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
    console.log('SV MODAL DISMISS: Escape swallowed — the customer must choose');
  }, true);

  console.log('SV MODAL DISMISS: installed — backdrop and Escape no longer ' +
              'resolve the saved-design modal to Continue');
})();


/* ============================================================================
   SV SUMMARY REFERENCES  —  P2: the Summary charged for design references but
   never itemised them

   Step 9/9 renders .sv-design-recap with a fixed row list — Studs, Badges,
   Back image, Custom text — that predates design references. Measured pass 6
   with a back image and two references:

       Back image      +£50            <- the only itemised charge
       Customisations: £80.00          <- £30 unaccounted for
       Total:          £135.00         <- correct, and matches the price pill

   The total is right, so nobody is overcharged. What fails is the customer's
   ability to check what they are paying for, on the one screen built for
   exactly that. This adds the missing row and keeps it in step with the
   upload manager. There are two .sv-design-recap containers (desktop and
   mobile), so both are updated.
   ============================================================================ */
(function () {
  if (window.__svSummaryRefsInit) return;
  window.__svSummaryRefsInit = true;

  function unitPrice() {
    return (window.SV_PRICING && window.SV_PRICING.designReferencePricePerImage) || 15;
  }
  function count() {
    try {
      var m = window.imageUploadManager;
      return (m && m.uploadedFiles && m.uploadedFiles.length) || 0;
    } catch (e) { return 0; }
  }

  var applying = false;

  function apply() {
    if (applying) return true;                 /* our own writes re-enter the observer */
    var recaps = document.querySelectorAll('.sv-design-recap');
    if (!recaps.length) return false;
    var n = count(), p = unitPrice();
    var value = n ? (n + ' × £' + p + ' = £' + (n * p).toFixed(2)) : 'None yet';

    applying = true;
    try {
    Array.prototype.forEach.call(recaps, function (recap) {
      var row = recap.querySelector('[data-sv-refs-row]');
      if (!row) {
        row = document.createElement('div');
        row.className = 'sv-design-recap__row';
        row.setAttribute('data-sv-refs-row', '');
        var a = document.createElement('span'); a.textContent = 'Design references';
        var b = document.createElement('span');
        row.appendChild(a); row.appendChild(b);

        /* sit directly after Back image, so the recap reads in wizard order */
        var back = null;
        Array.prototype.forEach.call(recap.querySelectorAll('.sv-design-recap__row'), function (r) {
          if (/^Back image/.test((r.textContent || '').trim())) back = r;
        });
        if (back && back.nextSibling) recap.insertBefore(row, back.nextSibling);
        else recap.appendChild(row);
      }
      row.lastChild.textContent = value;
    });
    } finally { applying = false; }
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  /* The recap is re-rendered WHOLESALE whenever the design changes, which
     deletes our row. A one-shot re-apply after the change event is not enough:
     verified on DEV during pass 6, the re-render lands several seconds after
     the upload, so a 400ms retry re-inserted the row and the re-render then
     wiped it again. A fixed-length poll is no better — it expires while the
     customer is still designing.

     So: observe, and re-insert whenever the DOM settles. Debounced, and
     re-entrancy guarded, because our own insertion mutates the same subtree. */
  var deb = null;
  var mo = new MutationObserver(function () {
    if (applying) return;
    clearTimeout(deb);
    deb = setTimeout(apply, 150);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* This markup is DEV-only: the LIVE theme's Summary step has no itemised
     recap at all, just Base / Customisations / Total. Rather than leave a
     whole-document observer running for nothing on a page that is already
     doing heavy 3D work, give the recap 20s to appear and then stand down. */
  setTimeout(function () {
    if (!document.querySelector('.sv-design-recap')) {
      mo.disconnect();
      console.log('SV SUMMARY REFERENCES: no .sv-design-recap on this theme — ' +
                  'observer disconnected, block is inert here');
    }
  }, 20000);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'image-upload-input') setTimeout(apply, 400);
  }, true);

  console.log('SV SUMMARY REFERENCES: installed — the recap now itemises design references');
})();
/* ===========================================================================
   SV BADGE HIT AREA  —  P1: Replace / Move / Remove unreachable by finger
   ---------------------------------------------------------------------------
   Found by break_the_ui pass 4 (2026-08-22) on real touch. A long-press on a
   placed badge logged `📐 ACTION MENU MODE` → `- Badge intersects found: 0` →
   `❌ No badge found at click position`, so the action menu — the ONLY route to
   Replace, Move and Remove Badge — could not be opened. Reproduced 5 runs.

   Root cause, settled with a temporary Raycaster wrapper (since removed). It
   re-ran the engine's OWN ray against the scene's badges as a control, which
   separates a bad target list from a bad ray:

     engineTargetsThatAreTheSceneBadges: 1   -> G holds the right badge, in-scene
     rayOrigin [0,0.600,1.600] == camera pos -> same camera, not stale
     controlHits: 0                          -> the ray itself misses
     ii(e)                                   -> standard, correct NDC formula

   So nothing is broken. The badge is simply a **15x13 px target that is still
   moving**: the camera is easing when the gesture is evaluated — two samples
   seconds apart read [0,0.600,1.600] then [0,0.616,1.638]. The menu fires
   during placement only because the tap point and the badge coincide by
   construction. A mouse lands it; a finger cannot.

   Fix: give each badge mesh a raycast ASSIST. The exact hit is tried first and
   always wins. Only if it misses do we fall back to a proximity test against
   the badge's bounding sphere, widened by a tolerance computed to be
   TARGET_RADIUS_PX on screen — converted to world units from the camera, so it
   stays a constant finger-sized target at any zoom.

   ⚠️ Deliberately DISABLED while placement is armed. The engine's own
   overlap guard raycasts these same meshes to decide "did you tap an existing
   badge?" — widening that would stop a customer placing a badge close to
   another one, trading this bug for a worse one. Placing keeps the exact test.

   Escape hatch: window.__svHitAreaOff = true disables the assist at runtime.
   Never throws — any failure falls through to the engine's original result.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svBadgeHitAreaInit) return; /* Theme Editor re-runs this script */
  window.__svBadgeHitAreaInit = true;

  var TARGET_RADIUS_PX = 22;   /* 44px across — the iOS minimum touch target */

  function placementArmed() {
    var pill = document.querySelector('.sv-place-pill');
    return !!(pill && pill.classList.contains('is-visible'));
  }

  function patch(mesh, T) {
    if (mesh.__svHitPatched) return false;
    var orig = mesh.raycast.bind(mesh);
    var _c = new T.Vector3(), _p = new T.Vector3(), _cam = new T.Vector3();

    mesh.raycast = function (raycaster, intersects) {
      var before = intersects.length;
      orig(raycaster, intersects);
      var dbg = window.__svHitDebug;            /* off unless explicitly switched on */
      if (intersects.length > before) {
        if (dbg) console.log('SVHIT: exact hit — assist not needed');
        return;                                 /* exact hit wins, always */
      }
      if (window.__svHitAreaOff) { if (dbg) console.log('SVHIT: bail — assist disabled'); return; }
      if (placementArmed()) { if (dbg) console.log('SVHIT: bail — placement armed'); return; }
      if (dbg) console.log('SVHIT: exact miss, trying assist');
      try {
        var geo = this.geometry;
        if (!geo) return;
        if (!geo.boundingSphere) geo.computeBoundingSphere();
        if (!geo.boundingSphere) return;

        this.updateWorldMatrix(true, false);
        _c.copy(geo.boundingSphere.center).applyMatrix4(this.matrixWorld);
        var rWorld = geo.boundingSphere.radius * this.matrixWorld.getMaxScaleOnAxis();

        /* screen pixels -> world units, so the target stays finger-sized at any zoom */
        var tol = rWorld;
        var cam = raycaster.camera;
        if (cam && cam.isPerspectiveCamera) {
          cam.getWorldPosition(_cam);
          var cv = document.getElementById('3d-preview-canvas');
          var vh = cv ? cv.getBoundingClientRect().height : 0;
          if (vh > 0) {
            var worldPerPx = (2 * _c.distanceTo(_cam) * Math.tan(cam.fov * Math.PI / 360)) / vh;
            tol = TARGET_RADIUS_PX * worldPerPx;
          }
        }

        if (raycaster.ray.distanceToPoint(_c) > (rWorld + tol)) return;

        raycaster.ray.closestPointToPoint(_c, _p);
        var travel = raycaster.ray.origin.distanceTo(_p);
        if (travel < raycaster.near || travel > raycaster.far) return;

        intersects.push({
          distance: travel, point: _p.clone(), object: this,
          face: null, faceIndex: null, uv: null, svHitAreaAssist: true
        });
      } catch (e) { /* never break a raycast — fall through to the exact result */ }
    };
    mesh.__svHitPatched = true;
    return true;
  }

  var announced = false;
  var tries = 0;
  var scan = setInterval(function () {
    var T = window.THREE, scene = window.threeScene;
    if (!T || !scene) { if (++tries > 300) clearInterval(scan); return; }
    var n = 0;
    scene.traverse(function (o) {
      if (o.isMesh && o.userData && o.userData.badge && patch(o, T)) n++;
    });
    if (n && !announced) {
      announced = true;
      console.log('SV BADGE HIT AREA: assist installed — badges now ' +
                  (TARGET_RADIUS_PX * 2) + 'px to the finger (exact hit still wins, ' +
                  'assist off while placing)');
    }
  }, 600);
})();

/* ===========================================================================
   SV MENU FLIP  —  P1: the badge action menu renders ABOVE the badge and is
   clipped by the viewport top, so "Replace" is entirely off-screen.
   Filed pass 7 item 4 on iOS Simulator Safari iPhone 17 Pro (402x874).

   MECHANISM (measured, not assumed)
     .sv-badge-action-menu is position:fixed. The engine sets .style.top to the
     badge's screen Y. jacket.css then lifts the whole menu with
       transform: translate(-50%, -110%)
     so the menu sits above that point and the ::after arrow points down at it.
     A badge high on the garment gives anchorY - 1.10*height < 0, so the top of
     the menu — which is where "Replace" lives — leaves the viewport.

   TWO TRAPS THIS BLOCK EXISTS TO AVOID
     1. jacket.css runs `animation: svMenuPop ... forwards`, whose 100% keyframe
        is `translate(-50%, -110%) scale(1)`. An animation fill BEATS an inline
        style.transform, so setting menu.style.transform here would do nothing
        at all and would look like a working fix. We therefore swap the
        ANIMATION (via a class), never the inline transform.
     2. getBoundingClientRect() during that animation returns the part-way
        rect, not the resting one. offsetHeight ignores transforms, so the
        honest oracle is  anchorY - 1.10 * offsetHeight.

   BEHAVIOUR
     fits above           -> untouched, engine behaviour preserved
     clipped at the top   -> .sv-menu-flip  : menu drops below the badge,
                                              arrow flips to the top edge
     fits neither way     -> .sv-menu-clamp : pinned MARGIN from the viewport
                                              top, arrow hidden (last resort)
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svMenuFlipInit) return; /* Theme Editor re-runs this script */
  window.__svMenuFlipInit = true;

  var MENU_SEL = '.sv-badge-action-menu';
  var MARGIN = 8;      /* px of breathing room against either viewport edge */
  var LIFT = 1.10;     /* must track translate(-50%, -110%) in jacket.css     */
  var DROP = 0.10;     /* must track translate(-50%, 10%) below              */
  var selfWrite = false; /* true while WE write style.top, see the clamp path */

  /* ---- styles: injected here so this fix is ONE file on BOTH themes ------ */
  var style = document.createElement('style');
  style.id = 'sv-menu-flip-styles';
  style.textContent =
    '@keyframes svMenuPopDown {' +
    '  0%   { opacity: 0; transform: translate(-50%, -10%) scale(0.9); }' +
    '  100% { opacity: 1; transform: translate(-50%, 10%) scale(1); }' +
    '}' +
    '.sv-badge-action-menu.sv-menu-flip {' +
    '  transform: translate(-50%, 10%);' +
    '  animation: svMenuPopDown 0.2s cubic-bezier(0.175,0.885,0.32,1.275) forwards;' +
    '}' +
    '.sv-badge-action-menu.sv-menu-flip::after {' +
    '  bottom: auto; top: -6px;' +
    '  border-top: none;' +
    '  border-bottom: 6px solid rgba(10, 10, 10, 0.95);' +
    '}' +
    '.sv-badge-action-menu.sv-menu-clamp {' +
    '  transform: translate(-50%, 0);' +
    '  animation: none !important;' +
    '}' +
    '.sv-badge-action-menu.sv-menu-clamp::after { display: none; }' +
    '@media (prefers-reduced-motion: reduce) {' +
    '  .sv-badge-action-menu.sv-menu-flip { animation: none !important; }' +
    '}';
  (document.head || document.documentElement).appendChild(style);

  /* ---- the decision ------------------------------------------------------ */
  function place(menu) {
    if (!menu || !menu.isConnected) return;

    /* always recompute from a clean slate — the engine may reuse one element */
    menu.classList.remove('sv-menu-flip', 'sv-menu-clamp');

    var anchorY = parseFloat(menu.style.top);
    if (!isFinite(anchorY)) {
      /* A guard you cannot see fail is not a guard. If the engine ever stops
         setting an inline top, this says so instead of silently doing nothing. */
      console.warn('SV MENU FLIP: no inline top on the menu — cannot measure, ' +
                   'left as the engine placed it');
      return;
    }

    var h = menu.offsetHeight; /* transform-independent, unlike the rect */
    if (!h) return;

    var vh = window.innerHeight;
    var topIfAbove = anchorY - LIFT * h;
    var bottomIfBelow = anchorY + DROP * h + h;

    if (topIfAbove >= MARGIN) return; /* fits above — engine behaviour stands */

    if (bottomIfBelow <= vh - MARGIN) {
      menu.classList.add('sv-menu-flip');
      console.log('SV MENU FLIP: menu would have been clipped ' +
                  Math.round(MARGIN - topIfAbove) + 'px off the top — ' +
                  'flipped below the badge, all 3 actions reachable');
      return;
    }

    selfWrite = true; /* our own style write must not retrigger the observer */
    menu.style.top = MARGIN + 'px';
    selfWrite = false;
    menu.classList.add('sv-menu-clamp');
    console.log('SV MENU FLIP: menu (' + h + 'px) fits neither above nor below ' +
                'in a ' + vh + 'px viewport — clamped to the top edge');
  }

  function watch(menu) {
    requestAnimationFrame(function () { place(menu); });
    /* the engine can move an open menu by rewriting style.top. The flip path
       only adds a CLASS, but the clamp path writes style.top itself — hence
       the selfWrite guard, without which clamp would retrigger this observer. */
    new MutationObserver(function () {
      if (selfWrite) return;
      place(menu);
    }).observe(menu, { attributes: true, attributeFilter: ['style'] });
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('sv-badge-action-menu')) {
          watch(n);
        } else if (n.querySelector) {
          var m = n.querySelector(MENU_SEL);
          if (m) watch(m);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* a menu already open when this script lands */
  var existing = document.querySelector(MENU_SEL);
  if (existing) watch(existing);

  console.log('SV MENU FLIP: installed — the badge action menu now flips below ' +
              'the badge instead of clipping "Replace" off the viewport top');
})();

/* ============================================================================
   SV BADGE RESTORE SPACE — restored badges land ~0.4 units above the garment
   ----------------------------------------------------------------------------
   break_the_ui pass 7 filed this as "restore of 3 badges places them OFF the
   garment, floating above the collar" and could not diagnose it. Pass 10
   measured it. It has nothing to do with how MANY badges there are.

   MECHANISM, measured on DEV (role:"unpublished") not inferred:

     1. A freshly placed badge is added to the SCENE by Pn() in jacket-cf.js:
          B.add(c.mesh)              // B === window.threeScene
        so mesh.position is a WORLD coordinate.

     2. Our own orphan rescue in snippets/sv-jacket-js-1.liquid:449 then runs
        jacket.attach(obj) on badge-like meshes that are still at scene root.
        attach() preserves the WORLD transform, which means it REWRITES
        mesh.position into jacket-local space. That rescue is correct and must
        stay: without it a badge does not follow the jacket's transform.

     3. captureDesignState() in jacket-cf.js saves the raw mesh.position:
          position: { x: c.position.x, y: c.position.y, z: c.position.z }
        It never asks who the parent is. So for a rescued badge it writes a
        JACKET-LOCAL coordinate into a field that everything downstream treats
        as absolute. It ALSO writes surfacePoint, which is the true world point
        Pn() was handed at creation.

     4. restoreStockBadge()/restoreCustomBadge() read `position` and hand it
        straight back to Pn(), which does B.add() again. The jacket-local value
        is now applied as a world value.

   THE ARITHMETIC, from a real saved blob on DEV:
     jacket group "jacket-Male":  position (0, -0.7, 0), scale 1.6
     saved position      y  0.5048   z -0.2112     <- jacket-local
     saved surfacePoint  y  0.1072   z -0.3354     <- world
     0.5048 * 1.6 - 0.7 = 0.1077  ~= 0.1072   (y matches to 3dp)
    -0.2112 * 1.6       = -0.3379 ~= -0.3354  (z matches to 3dp)
   The saved `position` is EXACTLY the jacket-local form of `surfacePoint`.
   Restoring it puts the badge ~0.40 units too high: above the collar.

   WHY IT IS ASYMMETRIC (and why "1 badge worked" in pass 3):
   the rescue only fires for meshes it recognises, one test being
   material.map.userData.metadata. A freshly placed badge's texture carries
   that metadata, so it IS rescued. A RESTORED badge builds a brand new texture
   with no userData, so it is NOT rescued and stays at scene root. The saved
   `position` therefore means world for one badge and jacket-local for another,
   depending only on how that badge got there.

   FIX: `surfacePoint` is the correct world point on EVERY path. Verified from
   source that every badge-creating route goes through Pn(), which always sets
   surfacePoint to the world point it was given:
     - fresh placement      -> Pn(raycast hit point)      world
     - svMoveBadgeToPoint   -> Pn(svHit.point)            world, fresh
     - svReplaceBadgeInPlace-> Pn(svOld.surfacePoint)     world, carried over
   So surfacePoint is never stale, not even after a Move. We normalise the
   autosave blob on the READ path so `position` always carries the world point
   before the engine ever parses it.

   Read-path only, deliberately. The write path already carries SV AUTOSAVE
   SLIM and SV AUTOSAVE SLIMMING, which closed a P0; a third setItem wrapper
   there is risk for no gain. Normalising on read also heals blobs that are
   ALREADY saved wrong in a customer's browser.

   Safe by construction: when a badge was never rescued, position already
   equals surfacePoint and this is a no-op. When surfacePoint is missing
   (legacy blob) position is left untouched.

   NOT fixed here, stated honestly: a blob saved from an ALREADY-drifted
   restore has a drifted surfacePoint too, because the next capture records
   where the badge actually is. This stops the drift going forward; it cannot
   recover a design that already drifted before this block shipped.
   ========================================================================== */
(function () {
  if (window.__svBadgeRestoreSpaceInit) return; /* Theme Editor re-runs this script */
  window.__svBadgeRestoreSpaceInit = true;

  var KEY = 'jacket-autosave-design';
  var originalGet;
  try {
    originalGet = localStorage.getItem.bind(localStorage);
  } catch (e) {
    console.warn('SV BADGE RESTORE SPACE: localStorage unavailable, skipping');
    return;
  }

  function same(a, b) { return Math.abs(a - b) < 1e-9; }

  function normalise(raw) {
    if (!raw || typeof raw !== 'string') return raw;

    var parsed;
    try { parsed = JSON.parse(raw); } catch (e) { return raw; }

    var st = parsed && parsed.designState;
    var badges = st && st.badges;
    if (!badges || !badges.length) return raw;

    var rewritten = 0;
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (!b) continue;
      var sp = b.surfacePoint, p = b.position;
      if (!sp || !p) continue;
      if (typeof sp.x !== 'number' || typeof sp.y !== 'number' || typeof sp.z !== 'number') continue;
      if (typeof p.x !== 'number' || typeof p.y !== 'number' || typeof p.z !== 'number') continue;
      if (same(sp.x, p.x) && same(sp.y, p.y) && same(sp.z, p.z)) continue; /* never rescued */
      b.position = { x: sp.x, y: sp.y, z: sp.z };
      rewritten++;
    }

    if (!rewritten) return raw;

    try {
      var out = JSON.stringify(parsed);
      console.log('SV BADGE RESTORE SPACE: rewrote ' + rewritten + ' badge position(s) ' +
                  'from jacket-local to world before restore');
      return out;
    } catch (e) {
      return raw;
    }
  }

  localStorage.getItem = function (k) {
    var v = originalGet(k);
    if (k !== KEY) return v;
    try { return normalise(v); } catch (e) { return v; }
  };

  /* exposed so the fix can be unit-checked without a restore round trip */
  window.__svRestoreSpaceNormalise = normalise;

  console.log('SV BADGE RESTORE SPACE: installed — restored badges now use the ' +
              'saved world point instead of a jacket-local one');
})();


/* ============================================================================
   SV GENDER SWITCH TRUTH — "Change Base" tells the customer their design is
   empty while their badges are on it, then deletes them
   ----------------------------------------------------------------------------
   break_the_ui pass 7, real device, money-adjacent. With 3 badges placed and
   TOTAL £72.85 on screen, the CHANGE BASE confirmation reads:

       "You haven't made any customisations yet — switching is safe."

   The customer taps Switch, and every badge is destroyed.

   MECHANISM, read from source (jacket-cf.js), NOT the one the ledger guessed.
   The ledger attributed this to the engine's `hasAny` guard
   (Bi(): studs/badges/text/backImage). That guard exists but does not drive
   this dialog. showGenderChangeConfirmation() branches on ONE thing:

       ${o.activeStuds.length > 0 ? <summary + safe-transfer copy> : <"no customisations yet">}

   Badges are never consulted. A design of badges and no studs therefore always
   takes the "nothing here" branch, however much money is on it.

   WHAT THE CONFIRM PATH INTENDS. Pass 7 honestly recorded that it tapped CANCEL
   and never measured what switching destroys. handleGenderChange() states the
   intent directly:

       G && G.length > 0 && (
         console.log(`Clearing ${G.length} badges before gender switch (world-space mismatch)`),
         G.forEach(... B.remove(mesh); geometry.dispose(); material.dispose() ...),
         G = [], ... pricing refresh ...
       )

   ⚠️ AND IT DOES NOT DO THAT. Measured on DEV, pass 10: the log line fired
   ("Clearing 1 badges before gender switch") and the badge SURVIVED — still
   parented to the Scene, still visible, left off the garment, and still billed
   (toolbar "1 placed", TOTAL £62.50 unchanged). So the confirm path neither
   keeps the design nor cleanly removes it. That is a separate, newly found
   defect and it is filed as its own ledger row; this block does not fix it.
   What is certain either way is that badges do not survive a base change
   correctly, which is what the corrected copy now says and no more.

   FIX: correct the dialog, do not block the switch. We do not touch the engine's
   clearing behaviour, which is deliberate (the badges are cleared precisely
   because the world-space anchor does not survive a model swap). We only make
   the copy tell the truth so the customer chooses with the facts.

   Two branches are handled, because both are wrong for a badge-only design:
     - the false branch: replaced outright with an accurate warning
     - the studs branch: real, but silent about badges, so a badge line is added

   Copy follows SV-BRAND.md: British English, short sentences, no em-dash. It
   claims ONLY what source proves. It deliberately does NOT promise the design
   can be recovered by switching back: saveDesignForType() does write it to
   savedDesigns first, but whether the customer can reach it again through the
   UI has not been measured, and this dialog has told them one unverified thing
   already.
   ========================================================================== */
(function () {
  if (window.__svGenderSwitchTruthInit) return; /* Theme Editor re-runs this script */
  window.__svGenderSwitchTruthInit = true;

  var OVERLAY_SEL = '.gender-change-overlay';
  var FALSE_CLAIM = "made any customisations"; /* apostrophe-free substring, on purpose */

  function badgeCount() {
    var scene = window.threeScene;
    if (!scene || typeof scene.traverse !== 'function') return 0;
    var n = 0;
    try {
      scene.traverse(function (o) {
        if (o && o.isMesh && o.userData && o.userData.badge) n++;
      });
    } catch (e) {
      return 0;
    }
    return n;
  }

  /* ⚠️ THE WORDING HAS CHANGED TWICE. READ WHY BEFORE CHANGING IT A THIRD TIME.
     v1 (pass 10, never shipped): "switching removes them and the charges come
     off your total" — taken from handleGenderChange, which plainly does
     G.forEach(remove + dispose) then G=[]. MEASURED, and false: the engine
     cleared the badges and then re-restored them 2.3s later, so they survived
     and the total never moved.
     v2 (pass 10, shipped to DEV): "badges do not move across cleanly, so check
     your design after switching" — deliberately claimed only what held whether
     or not the badges survived.
     v3 (pass 13, THIS): Sam's owner decision is to DROP badges on a base
     switch, and `SV BASE SWITCH DROP` below now makes that happen. The removal
     claim is finally TRUE, because we made it true — so the copy says it
     plainly, including the money, which is the part the customer cares about.
     ⛔ This copy and `SV BASE SWITCH DROP` are a PAIR. If that block is ever
     removed or stops firing, this wording becomes a lie again — revert to v2. */
  function warning(n) {
    var subject = (n === 1) ? 'You have 1 badge on this design. '
                            : 'You have ' + n + ' badges on this design. ';
    var object  = (n === 1) ? 'it' : 'them';
    var charge  = (n === 1) ? 'the badge charge comes off your total.'
                            : 'the badge charges come off your total.';
    /* ⛔ An earlier draft of v3 ended with "Your current design is saved, so you
       can switch back to it." REMOVED before it shipped. saveDesignForType()
       does write the design into savedDesigns, but whether a customer can
       actually reach it again through the UI has NEVER been measured. That is
       the same unverified-consequence mistake v1 made. Do not add it back
       until someone switches away, switches back, and sees the badges return. */
    return subject + 'Switching base removes ' + object + ', and ' + charge;
  }

  function styles() {
    if (document.getElementById('sv-switch-truth-styles')) return;
    var st = document.createElement('style');
    st.id = 'sv-switch-truth-styles';
    st.textContent =
      '.sv-switch-warning{' +
      'margin-top:10px;padding:10px 12px;border-radius:6px;' +
      'background:#fdf3f3;border:1px solid #f0c9c9;color:#8f2020;' +
      'font-size:0.9rem;line-height:1.45;text-align:left;}';
    document.head.appendChild(st);
  }

  function correct(overlay) {
    if (!overlay || overlay.getAttribute('data-sv-truth') === '1') return; /* idempotent */

    var n = badgeCount();
    if (n < 1) return; /* no badges: the engine's copy is already true */

    var body = overlay.querySelector('.svm-body');
    if (!body) return;

    styles();

    if ((body.textContent || '').indexOf(FALSE_CLAIM) !== -1) {
      /* the false branch: the engine saw no studs and declared the design empty */
      body.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'sv-switch-warning';
      p.textContent = warning(n);
      body.appendChild(p);
    } else {
      /* the studs branch: the summary is real, but badges are not in it */
      var ul = body.querySelector('ul');
      if (ul) {
        var li = document.createElement('li');
        li.textContent = n + (n === 1 ? ' badge placed' : ' badges placed');
        ul.appendChild(li);
      }
      var p2 = document.createElement('p');
      p2.className = 'sv-switch-warning';
      p2.textContent = warning(n);
      body.appendChild(p2);
    }

    overlay.setAttribute('data-sv-truth', '1');
    console.log('SV GENDER SWITCH TRUTH: corrected the Change Base dialog — ' +
                n + ' badge(s) are on the design and will be removed');
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.matches && node.matches(OVERLAY_SEL)) {
          correct(node);
        } else if (node.querySelector) {
          var inner = node.querySelector(OVERLAY_SEL);
          if (inner) correct(inner);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* a dialog already open when this script lands */
  var existing = document.querySelector(OVERLAY_SEL);
  if (existing) correct(existing);

  console.log('SV GENDER SWITCH TRUTH: installed — the Change Base dialog now ' +
              'names the badges it is about to remove');
})();


/* ============================================================================
   SV CAPTURE WORLD SPACE — fix the badge-coordinate bug AT SOURCE, so it stops
   leaking out of every path that saves a design
   ----------------------------------------------------------------------------
   Pass 12 (2026-08-23). This is the second half of `SV BADGE RESTORE SPACE`
   (pass 10) and it supersedes that block's coverage, without replacing it.

   WHAT PASS 10 GOT RIGHT, AND WHAT IT MISSED.
   Pass 10 established the mechanism: our orphan rescue calls jacket.attach(),
   which rewrites mesh.position into JACKET-LOCAL space, and
   captureDesignState() then saves that raw mesh.position into `position` —
   a field every restore path consumes as if it were a WORLD coordinate.
   It also established the cure: `surfacePoint`, which Pn() always sets from
   the world point it was handed, on every creation path.

   Pass 10 applied that cure on the **localStorage read path** only. That fixes
   "Continue My Design". It does NOT fix anything else, because the blob is not
   the only consumer.

   THE PATH IT MISSED — measured on DEV, pass 12.
   The base switch ("Change Base" -> Women's) does NOT go through localStorage
   at all. handleGenderChange() calls saveDesignForType(), which calls
   captureDesignState() and stashes the result in the IN-MEMORY
   designStateManager.savedDesigns['Male-Jacket']. Nothing is written to or
   read from localStorage, so the pass-10 read hook never fires.

   Captured live, straight out of savedDesigns['Male-Jacket'].badges[0]:
       position     y  0.28954   <- jacket-local  (what restore consumes)
       surfacePoint y -0.23675   <- the true world point
   The restored badge duly landed at world y 0.290 instead of -0.237:
   0.526 too high, up at the collar of a garment the customer never put it on,
   and still billed at £7.50.

   ⛔ AND NOTE WHAT THE BASE SWITCH IS ACTUALLY DOING, because the ledger had
   this backwards. It is NOT failing to clear the badges. Proven by uuid:
   the pre-switch badge (306B771F...) is GONE after the switch, survived: 0.
   The engine clears correctly, and then ~2.3s later RESTORES the design onto
   the new garment — its own logs, in order:
       "Clearing 1 badges before gender switch (world-space mismatch)"
       ...2.3s...
       "Restoring 1 badge placements..." -> "Restoring badge 1/1: a-blue-white"
       "[restoreBadgePlacements] Immediate pricing refresh after badge restore"
   That restore is why the badge reappears and why the total never drops. The
   engine clears *because* it knows the coordinates do not transfer, then
   restores those same untransferred coordinates two seconds later.

   FIX: normalise at CAPTURE instead of at read. `position` then means WORLD
   everywhere, for every consumer, the moment a design is captured — the
   localStorage autosave and the in-memory savedDesigns alike. One hook, at the
   point the ambiguity is created, rather than one hook per consumer.

   Kept alongside `SV BADGE RESTORE SPACE`, not instead of it. With this block
   installed, `position` already equals `surfacePoint` on the way in, so the
   pass-10 read hook becomes a no-op for new saves. It still earns its place by
   healing blobs ALREADY sitting wrong in a customer's browser from before
   either block shipped.

   Safe by construction, same rule as pass 10: acts only when `position` and
   `surfacePoint` disagree, which only happens once a badge has been reparented
   by the rescue. Never rescued -> identical -> untouched. No `surfacePoint`
   (legacy) -> untouched.

   ⚠️ WHAT THIS BLOCK DOES **NOT** DO, stated plainly so nobody assumes it:
   it does not stop the base switch re-restoring badges onto a different
   garment, and it does not re-map coordinates between the Male and Female
   meshes. It makes the restored position the point the customer actually
   tapped, in world space, rather than a jacket-local number. Whether a badge
   placed on a Men's chest should even appear on a Women's jacket at all is an
   OWNER decision, not a bug fix, and it is filed as its own ledger row.
   ========================================================================== */
(function () {
  if (window.__svCaptureWorldSpaceInit) return; /* Theme Editor re-runs this script */

  var MAX_TRIES = 40;   /* ~10s at 250ms — the manager is created by the engine bundle */
  var tries = 0;

  function same(a, b) { return Math.abs(a - b) < 1e-9; }

  function normaliseBadges(state) {
    if (!state || !state.badges || !state.badges.length) return 0;
    var n = 0;
    for (var i = 0; i < state.badges.length; i++) {
      var b = state.badges[i];
      if (!b) continue;
      var sp = b.surfacePoint, p = b.position;
      if (!sp || !p) continue;
      if (typeof sp.x !== 'number' || typeof sp.y !== 'number' || typeof sp.z !== 'number') continue;
      if (typeof p.x !== 'number' || typeof p.y !== 'number' || typeof p.z !== 'number') continue;
      if (same(sp.x, p.x) && same(sp.y, p.y) && same(sp.z, p.z)) continue; /* never rescued */
      b.position = { x: sp.x, y: sp.y, z: sp.z };
      n++;
    }
    return n;
  }

  function install() {
    var dsm = window.designStateManager;
    if (!dsm || typeof dsm.captureDesignState !== 'function') return false;

    var original = dsm.captureDesignState.bind(dsm);

    dsm.captureDesignState = function () {
      var state = original();
      try {
        var n = normaliseBadges(state);
        if (n) {
          console.log('SV CAPTURE WORLD SPACE: rewrote ' + n + ' badge position(s) ' +
                      'from jacket-local to world at capture');
        }
      } catch (e) {
        /* never let this break a capture — a failed normalise must still return state */
      }
      return state;
    };

    window.__svCaptureWorldSpaceInit = true;
    /* exposed so the rule can be checked without triggering a real capture */
    window.__svCaptureWorldSpaceNormalise = normaliseBadges;

    console.log('SV CAPTURE WORLD SPACE: installed — badge positions are now saved ' +
                'in world space on every path, including the base switch');
    return true;
  }

  if (install()) return;

  var timer = setInterval(function () {
    tries++;
    if (install() || tries >= MAX_TRIES) {
      clearInterval(timer);
      if (!window.__svCaptureWorldSpaceInit) {
        console.warn('SV CAPTURE WORLD SPACE: designStateManager never appeared after ' +
                     MAX_TRIES + ' tries — not installed');
      }
    }
  }, 250);
})();


/* ============================================================================
   SV BASE SWITCH DROP — honour the clear. Badges do not follow a base switch.
   ----------------------------------------------------------------------------
   Pass 13 (2026-08-23). OWNER DECISION by Sam, not a bug fix: when a customer
   changes base (Men's <-> Women's), their badges are removed and the charges
   come off the total, rather than being carried onto a garment they were never
   placed on.

   WHY REMOVAL IS THE RIGHT SHAPE. handleGenderChange already clears every badge
   on the confirm path, and its own log says why:
       "Clearing N badges before gender switch (world-space mismatch)"
   The engine knows the coordinates do not transfer between meshes. It then
   restores the design anyway, putting the untransferred coordinates straight
   back. Pass 12 fixed the coordinate SPACE and the badge still sat 0.148 off
   the Women's back panel, because a point on the Men's panel is not a point on
   the Women's panel. Only re-projection or removal fixes that. Sam chose
   removal. This block makes the engine's own clear the last word.

   ⛔ FIRST ATTEMPT FAILED — KEEP THIS, IT IS THE WHOLE REASON FOR THE DESIGN.
   v1 emptied `designStateManager.savedState.badges` when the customer pressed
   confirm, on the theory that the restore reads savedState and would then find
   nothing. It fired correctly and the badge still came back. The log shows why:
       197740ms  SV BASE SWITCH DROP: dropped 1 badge(s) (on confirm)
       197744ms  Clearing 1 badges before gender switch
       197835ms  Restoring 1 badge placements...      <-- 91ms after the clear
   Something repopulates savedState inside that 91ms window, and a 200ms poll
   cannot win that race. ⚠️ Note also that pass 12 measured this same gap as
   ~2.3s. **The gap is variable, so ANY timing-based fix here is unsound** —
   that is the real lesson, not the specific 91ms.

   v2 (this): do not race the data. Intercept the ACTION. We wrap
   `restoreBadgePlacements` and make it a no-op while a base switch is in
   flight. It no longer matters who calls it, when, or from which snapshot.

   The window is opened by a real confirm press and closed on a timer purely as
   a safety net, so a later unrelated restore ("Continue My Design") can never
   be swallowed by a stale flag. Cancel opens nothing.

   ⛔ WHAT WE DELIBERATELY DO NOT TOUCH:
   - `savedDesigns[...]` is left INTACT. saveDesignForType() runs before the
     dialog; we drop badges from the LIVE scene, not from the customer's saved
     design.
   - The engine's own clear is untouched. We remove the thing that undid it.
   - The autosave blob is untouched.

   ⚠️ PAIRED WITH THE COPY IN `SV GENDER SWITCH TRUTH`, which now tells the
   customer the badges will be removed and the charges come off. If this block
   is removed or stops firing, that sentence becomes false — revert the copy to
   the v2 wording recorded in its comment.
   ========================================================================== */
(function () {
  if (window.__svBaseSwitchDropInit) return; /* Theme Editor re-runs this script */

  var OVERLAY_SEL = '.gender-change-overlay';
  var CONFIRM_SEL = '#confirm-gender-change';
  var WINDOW_MS = 20000;   /* safety net only — the flag is cleared on completion too */
  var MAX_TRIES = 40;
  var tries = 0;

  function switchInFlight() {
    return !!(window.__svBaseSwitchUntil && Date.now() < window.__svBaseSwitchUntil);
  }

  function refreshPricing() {
    /* the skipped restore would have refreshed pricing; make sure the total
       still falls to base after we suppress it

       ⛔ FIXED 2026-08-26. THIS FUNCTION USED TO BE A SILENT NO-OP:

           if (typeof window.updateTotalPrice === 'function') window.updateTotalPrice();
           if (typeof window.svRefreshPricing === 'function') window.svRefreshPricing();

       NEITHER OF THOSE FUNCTIONS HAS EVER EXISTED. The `typeof` test meant it
       never threw and the `try/catch` meant it could never complain, so it did
       nothing, silently, from the day it shipped (2026-08-23) — on LIVE too.

       This exact pattern, copied into `SV BADGE GARMENT GUARD`, produced the
       £90.80-on-an-empty-jacket bug on 2026-08-26: every badge that guard
       dropped kept its charge in the total. That guard has been rolled back;
       this is where the pattern came from.

       ⚠️ It was assessed as LATENT here rather than active — PASS 13's money
       oracle showed the total falling correctly on a real base switch
       (£62.50 → £55.00), which means the engine's own clear already refreshes
       pricing and this call was only ever belt-and-braces. It has never been
       shown to cause a wrong price. It is fixed because a dead safety net that
       looks alive is worse than no safety net.

       The REAL globals, verified present at runtime on the served page:
         window.refreshPricing        ✅
         window.updateDynamicPricing  ✅

       ⛔ DO NOT reintroduce a `typeof` guard around these. If a future theme
       build renames them, this MUST make noise — that is the whole lesson.
       Project invariant: A GUARD YOU CANNOT SEE FAIL IS NOT A GUARD. */
    var called = 0;

    try {
      if (typeof window.refreshPricing === 'function') {
        window.refreshPricing();
        called++;
      }
    } catch (e) {
      console.error('SV BASE SWITCH DROP: window.refreshPricing() threw —', e);
    }

    try {
      if (typeof window.updateDynamicPricing === 'function') {
        window.updateDynamicPricing();
        called++;
      }
    } catch (e) {
      console.error('SV BASE SWITCH DROP: window.updateDynamicPricing() threw —', e);
    }

    /* The assertion. If BOTH pricing entry points have vanished, the total may
       now be stale and carrying charges for badges that are no longer on the
       garment — i.e. money. Say so loudly rather than returning quietly. */
    if (called === 0) {
      console.error(
        'SV BASE SWITCH DROP: 🔴 PRICING NOT REFRESHED — neither ' +
        'window.refreshPricing nor window.updateDynamicPricing is available. ' +
        'The displayed total may still include badges that were just removed. ' +
        'This is the £90.80 failure mode (2026-08-26). Check whether the engine ' +
        'renamed its pricing functions.'
      );
      window.__svPricingRefreshFailed = true;
    }

    return called;
  }

  function install() {
    var dsm = window.designStateManager;
    if (!dsm || typeof dsm.restoreBadgePlacements !== 'function') return false;

    var original = dsm.restoreBadgePlacements.bind(dsm);

    dsm.restoreBadgePlacements = function (badges) {
      if (switchInFlight()) {
        var n = (badges && badges.length) || 0;
        console.log('SV BASE SWITCH DROP: suppressed a restore of ' + n +
                    ' badge(s) during a base switch — the clear stands');
        refreshPricing();
        return;
      }
      return original(badges);
    };

    window.__svBaseSwitchDropInit = true;
    console.log('SV BASE SWITCH DROP: installed — badge restores are suppressed ' +
                'while a base switch is in flight');
    return true;
  }

  function armFor(overlay) {
    var confirm = overlay.querySelector(CONFIRM_SEL);
    if (!confirm || confirm.getAttribute('data-sv-drop') === '1') return;
    confirm.setAttribute('data-sv-drop', '1');
    confirm.addEventListener('click', function () {
      window.__svBaseSwitchUntil = Date.now() + WINDOW_MS;
      console.log('SV BASE SWITCH DROP: base switch confirmed — suppressing badge ' +
                  'restores for the next ' + (WINDOW_MS / 1000) + 's');
    }, true); /* capture: arm before the engine's own handler runs */
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.matches && node.matches(OVERLAY_SEL)) armFor(node);
        else if (node.querySelector) {
          var inner = node.querySelector(OVERLAY_SEL);
          if (inner) armFor(inner);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  var existing = document.querySelector(OVERLAY_SEL);
  if (existing) armFor(existing);

  if (install()) return;
  var timer = setInterval(function () {
    tries++;
    if (install() || tries >= MAX_TRIES) {
      clearInterval(timer);
      if (!window.__svBaseSwitchDropInit) {
        console.warn('SV BASE SWITCH DROP: designStateManager never appeared — not installed');
      }
    }
  }, 250);
})();


/* ============================================================================
   SV TOOLBAR VISIBILITY — the floating badge toolbar must get out of the way
   ----------------------------------------------------------------------------
   Pass 14 (2026-08-23). Found by Sam on a real device, LIVE, and it is the
   long-standing ledger row 28 with more reach than that row credited.

   WHAT HE SAW. `#floating-badge-toolbar` ("Clear All · N placed · Done
   placing") is `position:fixed; bottom:124px; z-index:10001` and is reparented
   to <body>. It therefore sits at the same viewport spot no matter what is
   underneath it, and it never moves:
     - with the bottom sheet EXPANDED it covers the drawer header, hiding the
       `Home` button and the `TOTAL £xx.xx` readout;
     - and worse, measured pass 14: it also floats over the FULL-SCREEN
       "CHOOSE YOUR BASE" chooser, sitting on top of the Women's Jacket tile —
       a screen where the toolbar has no business appearing at all.

   ⛔ DO NOT FIX THIS BY REVERTING THE ANCHOR. `SV TOOLBAR ANCHOR` (bottom:
   124px + safe-area) and `SV TOOLBAR REPARENT` (move to <body>) are
   invariant 15. Undoing either re-opens the Clear-All-unreachable P1 that
   they exist to fix. The toolbar's RESTING position is correct; the bug is
   that it stays put when something else takes over the screen.

   FIX: suppress it while another surface owns the screen, and let it come back
   untouched afterwards. Hidden when EITHER
     - `#nike-bottom-sheet` has the `expanded` class, or
     - a full-screen surface is visible: `.sv-chooser-overlay` or any
       `.svm-overlay` (which covers the Change Base dialog, the saved-session
       modal, and the size chart).

   ⚠️ ADDITIVE ONLY, AND THIS IS THE LOAD-BEARING DETAIL. The toolbar's base
   visibility is already owned by the engine and by `SV TOOLBAR GATE` — it is
   `display:none` whenever placement is not armed. This block therefore ONLY
   ever adds or removes its own `.sv-toolbar-suppressed` class, which carries
   `display:none !important`. It NEVER sets display to a visible value. When
   the class is removed the element falls straight back to whatever the engine
   decided, so we cannot accidentally show a toolbar that was meant to be
   hidden — a real risk, because a Clear All button appearing over the jacket
   outside placement mode is exactly the P1 invariant 15 was written for.

   Re-evaluated on: sheet class changes, body subtree changes (overlays are
   added and removed as nodes), and the customiser's own step navigation.
   ========================================================================== */
(function () {
  if (window.__svToolbarVisibilityInit) return; /* Theme Editor re-runs this script */
  window.__svToolbarVisibilityInit = true;

  var TOOLBAR_ID = 'floating-badge-toolbar';
  var SHEET_ID = 'nike-bottom-sheet';
  var SUPPRESS = 'sv-toolbar-suppressed';

  function styles() {
    if (document.getElementById('sv-toolbar-visibility-styles')) return;
    var st = document.createElement('style');
    st.id = 'sv-toolbar-visibility-styles';
    /* !important because the engine writes an inline display on this element */
    st.textContent = '#' + TOOLBAR_ID + '.' + SUPPRESS + '{display:none !important;}';
    document.head.appendChild(st);
  }

  function isVisible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function somethingElseOwnsTheScreen() {
    var sheet = document.getElementById(SHEET_ID);
    if (sheet && sheet.classList.contains('expanded')) return 'sheet expanded';

    var chooser = document.querySelector('.sv-chooser-overlay');
    if (isVisible(chooser)) return 'base chooser open';

    var modals = document.querySelectorAll('.svm-overlay');
    for (var i = 0; i < modals.length; i++) {
      if (isVisible(modals[i])) return 'modal open';
    }
    return null;
  }

  var lastReason = false;

  function apply() {
    var tb = document.getElementById(TOOLBAR_ID);
    if (!tb) return;
    styles();

    var reason = somethingElseOwnsTheScreen();
    if (reason && !tb.classList.contains(SUPPRESS)) {
      tb.classList.add(SUPPRESS);
      if (reason !== lastReason) {
        console.log('SV TOOLBAR VISIBILITY: hiding the badge toolbar — ' + reason);
        lastReason = reason;
      }
    } else if (!reason && tb.classList.contains(SUPPRESS)) {
      /* remove ONLY our class — the engine's own display state takes over again */
      tb.classList.remove(SUPPRESS);
      console.log('SV TOOLBAR VISIBILITY: releasing the badge toolbar — the screen is free');
      lastReason = false;
    }
  }

  /* Throttle to one evaluation per frame. This observer watches class/style
     across the whole body subtree on a page that is running a 3D renderer, and
     apply() itself mutates a class — without the throttle every toggle would
     re-enter the observer. apply() is already idempotent (it only writes when
     the state actually changes) so it cannot loop, but coalescing keeps it off
     the render thread's back. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  apply();

  console.log('SV TOOLBAR VISIBILITY: installed — the badge toolbar now stands ' +
              'down while the drawer, the base chooser or a modal owns the screen');
})();



/* =====================================================================
   SV OUTER SURFACE ONLY  —  P0: badges could be placed on the INSIDE
   of the garment  (2026-08-26)

   SYMPTOM (Sam, real device): "a badge was placed on the inside of the
   jacket, hidden."  The badge is charged for and appears in the design,
   but the customer cannot see it, because it sits on the inward-facing
   side of a panel.

   ROOT CAUSE — measured, not inferred.
   Every garment mesh in both GLBs uses `material.side = THREE.DoubleSide`
   (verified live: all 7 visible meshes on jacket-Male, all 7 on
   female-jacket.glb). THREE's Raycaster honours `material.side`, so with
   DoubleSide it reports BACK faces as hits. The badge placement path takes
   `hits[0]` — the nearest hit — with no front/back test:

       const o = Ht.intersectObjects(t);
       if (o.length > 0) { const n = o[0];
         Pn(n.point, n.face.normal, n.object.name); }   // jacket-cf.js

   When the ray passes through an opening — the neck, the open front, the
   hem, or a gilet's armholes — the nearest surface is the INSIDE of the
   far panel. The badge lands there, facing away from the customer.

   MEASURED EXPOSURE (2,154 / 1,922 / 1,540 rays over 16 azimuths x 5
   elevations x a 5x7 aim grid, first hit only):

       male jacket    195 of 2154 first-hits were inside surfaces   9.1%
       female jacket  127 of 1922                                   6.6%
       female gilet   205 of 1540                                  13.3%

   The gilet is worst because hiding the sleeves opens both armholes.

   THE ENGINE ALREADY KNOWS THIS RULE — for PATCHES, not badges. The patch
   placement path does:
       w.transformDirection($.matrixWorld);
       if (!q(w, h)) { console.log("Not an outer surface, rejecting"); return; }
   `q()` compares the normal against the direction from the garment centre.
   That test is NOT reused here, deliberately: measured against real
   geometry it MISCLASSIFIES legitimate outer sleeve surfaces as inner
   (a sleeve's outer wall points away from the sleeve axis but not away
   from the garment centre), and `q()` additionally hard-codes `g.z > 0`,
   which would forbid every badge on the back of the garment.

   THE FIX. Raycast the garment front-faces-only. `material.side` is set to
   FrontSide for the duration of the raycast and restored immediately, so
   RENDERING IS UNTOUCHED — the inside of the garment still draws exactly as
   before. Only hit-testing changes.

   Patched on THREE.Mesh.prototype, not on the mesh instances, so it covers
   every model loaded for the rest of the session — a gender switch, a style
   switch and a colour switch all rebuild the meshes, and an instance-level
   patch would silently stop applying after the first swap.

   VERIFIED (same probe, after the patch):
       male jacket    inside first-hits 195 -> 0   outer hits 1959 -> 1985
       female gilet   inside first-hits 205 -> 0   outer hits 1335 -> 1336
   Outer hit counts are unchanged, so no legitimate surface became
   untappable. Every mesh in both GLBs has outward normals — checked per
   mesh, no mesh is authored inside-out — so front-face-only raycasting
   cannot make a panel unreachable.

   SELF-TEST — run in the console at any time:
       window.svAuditOuterOnly()
   Returns { installed, root, meshes, inside, outside, per }. `inside` MUST
   be 0. If it is not, this block is not doing its job.

   KNOWN, ACCEPTED CONSEQUENCE: a tap aimed through an opening now hits
   nothing and places nothing, instead of placing a hidden badge. That is
   the intended trade. It is silent — the engine already logs
   "No jacket hit (off-mesh tap)" for the same case. A customer-facing
   message for it is a separate, unapproved change and is NOT made here.

   ROLLBACK: delete this block. Nothing else references it.
   ===================================================================== */
(function () {
  'use strict';

  var tries = 0;
  var wait = setInterval(function () {
    if (window.THREE && window.THREE.Mesh && window.THREE.Mesh.prototype.raycast) {
      clearInterval(wait);
      install(window.THREE);
    } else if (++tries > 200) {                     /* ~60s ceiling */
      clearInterval(wait);
      console.error('SV OUTER SURFACE ONLY: THREE never appeared — ' +
                    'badges can still be placed on the INSIDE of the garment.');
    }
  }, 300);

  function install(THREE) {
    if (THREE.Mesh.prototype.__svOuterOnly) return;

    var origRaycast = THREE.Mesh.prototype.raycast;

    /* A garment mesh is any mesh under the loaded model group (jacket-Male /
       jacket-Female) that is not itself something we placed on the garment.
       Badges live in their own group so the parent walk already excludes
       them; the userData tests are belt-and-braces for the branch that adds
       the back image to the model group. */
    function isGarmentMesh(m) {
      var u = m.userData;
      if (u && (u.meshName || u.isSurfaceDecal || u.isPatch || u.badge)) return false;
      if (m.name === 'sv_back_image') return false;
      for (var p = m.parent; p; p = p.parent) {
        if (/^jacket-/i.test(p.name || '')) return true;
      }
      return false;
    }

    THREE.Mesh.prototype.raycast = function (raycaster, intersects) {
      if (!isGarmentMesh(this)) return origRaycast.call(this, raycaster, intersects);

      var mats = Array.isArray(this.material) ? this.material : [this.material];
      var saved = [], i;
      for (i = 0; i < mats.length; i++) {
        saved.push(mats[i] ? mats[i].side : null);
        if (mats[i]) mats[i].side = THREE.FrontSide;
      }
      try {
        return origRaycast.call(this, raycaster, intersects);
      } finally {
        /* Restore in a finally so a throw inside raycast can never leave the
           garment rendering single-sided. */
        for (i = 0; i < mats.length; i++) {
          if (mats[i] && saved[i] !== null) mats[i].side = saved[i];
        }
      }
    };

    THREE.Mesh.prototype.__svOuterOnly = true;
    console.log('SV OUTER SURFACE ONLY: installed — badge placement now ' +
                'ignores inward-facing garment surfaces. Run ' +
                'window.svAuditOuterOnly() to verify (inside must be 0).');
  }

  /* -------- the guard you can watch fail --------------------------------
     Casts rays at the garment from 16 azimuths x 5 elevations x a 5x7 aim
     grid and classifies each FIRST hit as an outer or an inner surface,
     exactly as the placement path would see it. */
  window.svAuditOuterOnly = function () {
    var THREE = window.THREE;
    var scene = window.threeScene;
    if (!THREE || !scene) return { error: 'THREE or threeScene not available yet' };

    var root = null;
    scene.traverse(function (o) {
      if (!root && /^jacket-/i.test(o.name || '') && o.visible) root = o;
    });
    if (!root) return { error: 'no visible jacket-* group — model not loaded yet' };

    var targets = [];
    root.traverse(function (o) {
      if (!o.isMesh || !o.visible) return;
      var n = o.name || '';
      if (n.indexOf('Studs') > -1) return;
      var lo = n.toLowerCase();
      if (lo.indexOf('button') > -1 || lo.indexOf('btn') > -1) return;
      targets.push(o);
    });
    if (!targets.length) return { error: 'no garment meshes found under ' + root.name };

    var box = new THREE.Box3().setFromObject(root);
    var centre = box.getCenter(new THREE.Vector3());
    var radius = box.getSize(new THREE.Vector3()).length();
    var rc = new THREE.Raycaster();
    var per = {}, inside = 0, outside = 0;
    targets.forEach(function (t) { per[t.name] = { inside: 0, outside: 0 }; });

    for (var a = 0; a < 16; a++) {
      for (var e = -2; e <= 2; e++) {
        var th = a / 16 * Math.PI * 2, ph = e * 0.25;
        var dir = new THREE.Vector3(Math.sin(th) * Math.cos(ph), Math.sin(ph),
                                    Math.cos(th) * Math.cos(ph));
        var up = new THREE.Vector3(0, 1, 0);
        var right = new THREE.Vector3().crossVectors(up, dir).normalize();
        for (var jx = -2; jx <= 2; jx++) {
          for (var jy = -3; jy <= 3; jy++) {
            var aim = centre.clone()
              .addScaledVector(right, jx * 0.18)
              .addScaledVector(up, jy * 0.12);
            rc.set(aim.clone().addScaledVector(dir, radius), dir.clone().negate());
            var hits = rc.intersectObjects(targets);
            if (!hits.length) continue;
            var h = hits[0];
            if (!h.face || !per[h.object.name]) continue;
            var wn = h.face.normal.clone().transformDirection(h.object.matrixWorld);
            if (wn.dot(rc.ray.direction) < 0) { per[h.object.name].outside++; outside++; }
            else { per[h.object.name].inside++; inside++; }
          }
        }
      }
    }

    var installed = !!(THREE.Mesh.prototype.__svOuterOnly);
    var result = { installed: installed, root: root.name, meshes: targets.length,
                   inside: inside, outside: outside, per: per };
    if (installed && inside > 0) {
      console.error('SV OUTER SURFACE ONLY: FAILED — ' + inside + ' of ' +
                    (inside + outside) + ' first-hits are still inward-facing. ' +
                    'Badges can be placed inside the garment.', per);
    } else if (installed) {
      console.log('SV OUTER SURFACE ONLY: PASS — 0 of ' + outside +
                  ' first-hits are inward-facing on ' + root.name + '.');
    } else {
      console.warn('SV OUTER SURFACE ONLY: NOT installed — ' + inside + ' of ' +
                   (inside + outside) + ' first-hits are inward-facing.');
    }
    return result;
  };
})();



/* =====================================================================
   SV NO DEBUG ALERT  —  P1: a developer assertion was shown to customers
   in a blocking modal  (2026-08-26)

   SYMPTOM. On the LIVE store, loading the customiser pops a browser dialog:

       🚨 ISSUE DETECTED! Style mismatch:
       Dropdown shows: Jacket
       currentModelState.style: Gilet
       This is the bug! Check console for details.

   Measured on LIVE (theme 197365596497, role "main"): it fired on 3 of 3
   page loads. A paying customer is told, in a modal they must dismiss, that
   the product they are configuring has "the bug".

   SOURCE. `Ge()` in the vendored bundle `jacket-cf.js`:

       const t = document.getElementById("jacket-style");
       if (t && t.value !== R.style) {
         const l = `🚨 ISSUE DETECTED! Style mismatch: ...`;
         console.error(l); alert(l);
       }

   `Ge()` is scheduled ten times at 500ms intervals plus its own re-runs.

   ⚠️ THE ASSERTION IS NOT LYING — IT IS REPORTING A REAL RACE. That is why
   this block removes only the DIALOG and keeps the `console.error`. Silencing
   a true assertion outright would hide the condition from us as well.

   IS THE RACE HARMFUL? Measured, not assumed. One instrumented LIVE load:

       Ge() runs (its own "UPDATING COMPONENT VISIBILITY" banner)  13
       mismatch reports                                             1
       first run  2282ms   -> MISMATCH (dropdown "Jacket", state "Gilet")
       runs 2-13  2730ms .. 8408ms -> all agree, "Gilet"

   The dropdown catches up in under ~450ms and the next twelve checks pass.
   The 3D model itself does not finish loading for 15-25s, so the entire race
   is over long before a customer can place a badge or reach the cart.

   ⚠️ WHY THE RACE STILL MATTERS TO US, even though it is harmless today:
   pricing reads the SAME dropdown the assertion compares against —

       function Pc(){ return document.getElementById("jacket-style")?.value
                             || R?.style || "Jacket" }

   so during that sub-second window a gilet WOULD price as a jacket. Nothing
   calls for a price in that window today. If a future change ever prices
   earlier in the load, this race becomes a money bug. **The console.error is
   deliberately left in place as the tripwire for exactly that.**

   ⛔ NOT FIXED HERE: the underlying startup ordering. That is a change to the
   vendored bundle's initialisation order, it has no customer-visible effect
   today, and it is out of scope for "stop showing customers a debug popup".

   SCOPE — surgical, by design. `jacket-cf.js` contains 37 `alert()` calls.
   They were audited individually before this block was written:
     - most are behind `window.debug*` helpers a customer never invokes;
     - several are legitimate customer messages that MUST keep working, e.g.
       "Please select Gender and Jacket Style before adding to cart." and
       "Sorry, this design could not be found."
   This block therefore matches ONE assertion by its two distinctive tokens
   and passes every other alert straight through untouched.

   SELF-TEST — run in the console at any time:
       window.svDebugAlertReport()
   Returns { installed, suppressed, entries }. Each suppression is recorded
   with a timestamp, so "it never fired" and "the filter stopped matching"
   are distinguishable rather than looking identical.

   ROLLBACK: delete this block. Nothing else references it.
   ===================================================================== */
(function () {
  'use strict';

  if (window.__svNoDebugAlert) return;

  var suppressed = [];
  var origAlert = window.alert;

  /* Both tokens must be present. Matching on one would risk swallowing a
     genuine message that happens to share a word. */
  function isKnownDebugAssertion(text) {
    return text.indexOf('ISSUE DETECTED') > -1 && text.indexOf('Style mismatch') > -1;
  }

  window.alert = function (message) {
    var text = String(message == null ? '' : message);

    if (isKnownDebugAssertion(text)) {
      suppressed.push({ at: new Date().toISOString(), text: text.slice(0, 300) });
      console.warn('SV NO DEBUG ALERT: suppressed a developer assertion that was ' +
                   'about to be shown to the customer. The condition itself is ' +
                   'still reported above by the engine\'s own console.error.\n' + text);
      return undefined;                /* alert() returns undefined normally */
    }

    return origAlert.apply(window, arguments);
  };

  window.__svNoDebugAlert = true;

  window.svDebugAlertReport = function () {
    var report = {
      installed: !!window.__svNoDebugAlert,
      suppressed: suppressed.length,
      entries: suppressed.slice()
    };
    if (!report.installed) {
      console.error('SV NO DEBUG ALERT: NOT installed — customers can still be ' +
                    'shown the "ISSUE DETECTED" modal.');
    } else if (report.suppressed === 0) {
      console.log('SV NO DEBUG ALERT: installed, nothing suppressed on this page ' +
                  'load. Either the race did not occur, or the assertion text ' +
                  'changed and this filter no longer matches it — check the ' +
                  'console for an "ISSUE DETECTED" error with no matching ' +
                  'suppression warning.');
    } else {
      console.log('SV NO DEBUG ALERT: installed, ' + report.suppressed +
                  ' developer assertion(s) kept away from the customer.');
    }
    return report;
  };

  console.log('SV NO DEBUG ALERT: installed — the "ISSUE DETECTED / Style ' +
              'mismatch" modal will no longer reach customers. The underlying ' +
              'condition is still logged by the engine. Verify with ' +
              'window.svDebugAlertReport().');
})();


/* ============================================================================
   SV BASE SWITCH CHOOSER ARM — P5. Badges float on a gender switch made from
   the CHANGE BASE pill, because the existing drop never arms on that route.
   ----------------------------------------------------------------------------
   Pass 38 (2026-08-26). PURE ADDITION. This block writes exactly one variable,
   `window.__svBaseSwitchUntil`, which is `SV BASE SWITCH DROP`'s own contract.
   It adds NO suppression logic of its own and does not touch that block.

   THE BUG, MEASURED ON DEV (199317193041), NOT INFERRED.
   Male Jacket, 2 badges (chest + right sleeve), customisations £15.00.
   CHANGE BASE pill -> Women's Jacket -> "Switch base". After the switch the
   scene group is `jacket-Female` and BOTH badges still carry a
   `targetMeshName` that no longer exists in the scene:

       Male_Denim_Jacket_Sleeve_R   floating 0.0733 m off the Female sleeve
       Male_Denim_Gilet_Front       floating 0.0166 m off the Female front

   The garment is ~1.0 world units tall, so the sleeve badge sits roughly 7% of
   body height clear of the fabric. `calculateCustomizationCosts()` still
   returned 15 — the customer is billed 15.00 for two badges pinned to a
   garment that is not in the scene. That is Sam's P5, and it is money.

   WHY THE EXISTING BLOCK DOES NOT FIRE. `SV BASE SWITCH DROP` arms on a click
   on `#confirm-gender-change` inside `.gender-change-overlay`. The chooser sets
   `window._svChooserApplying = true`, and handleGenderChange reads that flag:

       window._svChooserApplying
         ? (console.log("Skipping gender-change warning — chooser pre-pick is
            authoritative"), l = !0)
         : l = await showGenderChangeConfirmation(...)

   So on the pill route that dialog is NEVER CREATED. Measured across 6 samples
   over 28 s: `.gender-change-overlay` absent throughout, `__svBaseSwitchUntil`
   stayed null, and `restoreBadgePlacements` ran once with n=2 and
   `suppressed: false`. Every step of that chain was measured, not assumed.

   ⛔ THE HANDOFF SAYS THIS ROUTE IS "a full page navigation". IT IS NOT.
   The chooser CTA calls `c(q)`, which uses `window.history.replaceState`. The
   switch is entirely in-place. A fix armed on a navigation would never run.
   Corrected here so the next reader does not rebuild on the wrong premise.

   WHY WE HOOK `_svChooserApplying` AND NOT THE CTA CLICK.
   `sv-price-transparency.liquid` intercepts the FIRST `#sv-chooser-cta` click
   at capture phase, shows the "Switching your base?" interstitial, and only
   re-dispatches `cta.click()` if the customer confirms. A listener on the CTA
   therefore fires on a click that may still be CANCELLED, and arming there
   would open a 20 s window in which a later legitimate restore ("Continue My
   Design") is silently swallowed. `_svChooserApplying` is set as the FIRST
   statement of the chooser's apply function, which runs only on the real,
   confirmed pass. It cannot fire on a cancel.

   ⭐ AND THE ORDERING IS WHAT MAKES THE GENDER TEST POSSIBLE. At the instant
   the flag flips, the apply function has not yet written `#gender`. So the
   select still holds the OLD gender while the checked tile holds the NEW one.
   We compare those two. Read the order in the engine before changing this.

   GENDER ONLY, NEVER STYLE. A Jacket<->Gilet change on the same gender is
   CORRECT today and must not be touched: measured on DEV from a clean state,
   both routes keep the body badge visible, let the engine's `$s()` hide the
   sleeve badge, and drop the price from 15.00 to 7.50 on the way in and back
   to 15.00 on the way out. Arming on a style change would destroy working
   behaviour — which is the exact mistake `SV BADGE GARMENT GUARD` made.
   ========================================================================== */
(function () {
  if (window.__svBaseSwitchChooserArmInit) return; /* Theme Editor re-runs this script */
  window.__svBaseSwitchChooserArmInit = true;

  var WINDOW_MS = 20000;  /* must match SV BASE SWITCH DROP's own window */
  var FLAG = '_svChooserApplying';

  var armed = [];         /* audit trail: every arm decision, kept for svAuditBaseSwitchArm() */

  /* The gender the customer is on RIGHT NOW. Read from the select rather than
     the engine's currentModelState, which is module-local and not exposed. */
  function currentGender() {
    var el = document.getElementById('gender') || document.getElementById('mobile-gender');
    return el && el.value ? el.value : null;
  }

  /* The gender the customer has just PICKED, from the checked chooser tile.
     `data-gender` on `.sv-chooser-tile` is the same attribute the engine's own
     CTA handler reads (`V.dataset.gender`), so we cannot disagree with it. */
  function chosenGender() {
    var input = document.querySelector('input[name="sv-chooser-type"]:checked');
    if (!input || !input.closest) return null;
    var tile = input.closest('.sv-chooser-tile');
    return tile ? (tile.getAttribute('data-gender') || null) : null;
  }

  function onApplyingTrue() {
    var from = currentGender();
    var to = chosenGender();
    var record = { at: Date.now(), from: from, to: to, armed: false, reason: '' };

    if (!to) {
      record.reason = 'no chooser tile checked — not a chooser-driven switch';
    } else if (!from) {
      /* We cannot prove the gender changed, so we do NOT arm. Dropping a
         customer's badges on a guess is worse than the float we are fixing. */
      record.reason = 'current gender unreadable — abstaining';
      console.error('SV BASE SWITCH CHOOSER ARM: 🔴 could not read the current ' +
                    'gender from #gender or #mobile-gender. Not arming. If the ' +
                    'customer just changed gender from the CHANGE BASE pill, ' +
                    'their badges will float on the new garment (P5).');
    } else if (from === to) {
      record.reason = 'style-only change (' + from + ') — badges must be kept';
    } else {
      window.__svBaseSwitchUntil = Date.now() + WINDOW_MS;
      record.armed = true;
      record.reason = 'gender change ' + from + ' -> ' + to;
      console.log('SV BASE SWITCH CHOOSER ARM: gender change ' + from + ' -> ' + to +
                  ' from the chooser — suppressing badge restores for the next ' +
                  (WINDOW_MS / 1000) + 's');
    }

    armed.push(record);
    if (armed.length > 20) armed.shift();
  }

  /* Intercept the ASSIGNMENT rather than polling for it. A 250ms poll can miss
     a flag that is set and cleared inside one turn, and the restore we need to
     beat is scheduled in the same click. Same rationale as the eager install
     recorded in HANDOFF §3. */
  var value = window[FLAG];
  try {
    Object.defineProperty(window, FLAG, {
      configurable: true,
      enumerable: true,
      get: function () { return value; },
      set: function (v) {
        var was = value;
        value = v;
        if (v && !was) {
          try { onApplyingTrue(); }
          catch (e) { console.error('SV BASE SWITCH CHOOSER ARM: arm check threw —', e); }
        }
      }
    });
  } catch (e) {
    console.error('SV BASE SWITCH CHOOSER ARM: 🔴 could not intercept window.' + FLAG +
                  ' — P5 is NOT fixed on this page. Badges will float after a ' +
                  'gender switch made from the CHANGE BASE pill.', e);
    return;
  }

  /* ⛔ ARMING WITHOUT THE SUPPRESSOR DOES NOTHING AT ALL. If `SV BASE SWITCH
     DROP` is ever removed, renamed, or fails to install, this block would go on
     setting a variable that nobody reads and P5 would be silently unfixed.
     Project invariant: a guard you cannot see fail is not a guard. */
  setTimeout(function () {
    if (!window.__svBaseSwitchDropInit) {
      console.error('SV BASE SWITCH CHOOSER ARM: 🔴 SV BASE SWITCH DROP is NOT ' +
                    'installed (window.__svBaseSwitchDropInit is falsy). This block ' +
                    'only sets window.__svBaseSwitchUntil, which that block reads. ' +
                    'With it absent, nothing suppresses the restore and P5 is live: ' +
                    'badges float on the new garment and stay charged.');
      window.__svChooserArmOrphaned = true;
    }
  }, 15000);

  /* Verify in one console line, the same shape as svAuditOuterOnly(). */
  window.svAuditBaseSwitchArm = function () {
    var report = {
      installed: !!window.__svBaseSwitchChooserArmInit,
      dropBlockInstalled: !!window.__svBaseSwitchDropInit,
      orphaned: !!window.__svChooserArmOrphaned,
      flagIntercepted: !!(Object.getOwnPropertyDescriptor(window, FLAG) || {}).get,
      currentGender: currentGender(),
      chosenGender: chosenGender(),
      windowOpenFor: window.__svBaseSwitchUntil
        ? Math.max(0, window.__svBaseSwitchUntil - Date.now())
        : 0,
      decisions: armed.slice()
    };
    if (!report.dropBlockInstalled) {
      console.error('SV BASE SWITCH CHOOSER ARM: 🔴 orphaned — the suppressor is missing.');
    }
    if (!report.flagIntercepted) {
      console.error('SV BASE SWITCH CHOOSER ARM: 🔴 window.' + FLAG +
                    ' is no longer intercepted. P5 is unfixed.');
    }
    console.log('SV BASE SWITCH CHOOSER ARM audit:', report);
    return report;
  };

  console.log('SV BASE SWITCH CHOOSER ARM: installed — a gender change made from ' +
              'the CHANGE BASE pill now drops badges, like the Base Configuration route');
})();


/* ============================================================================
   SV TOOLBAR DONE STEP GATE — "Done placing" stays visible on every step,
   including Base Configuration, where it makes no sense
   ----------------------------------------------------------------------------
   Found by Sam on a real device, DEV, 2026-08-26. With a badge already
   placed, swiping back to Step 1/9 "Base Configuration" still showed the
   floating toolbar's "Done placing" button — a control that implies an
   active placement session on a step that has nothing to do with badges.

   WHY THIS DOES NOT TOUCH SV TOOLBAR GATE. That block (pass 3, P2) pins the
   toolbar's own visibility gate to "badges exist OR placement is armed",
   DELIBERATELY, so Clear All is reachable from every step — quoting its own
   comment: "the reachable lever is l... the semantic the toolbar actually
   wants." That is correct and this block does not change it. Clear All and
   the badge count stay visible everywhere, exactly as designed.

   THE GAP is narrower: "Done placing" specifically only makes sense on the
   two steps the engine itself defines as badge-placement steps —
       c = currentStep === 4 || currentStep === 5
   (S&V Badge Select / Custom Badge Upload, per SV TOOLBAR GATE's own doc).
   `currentStep` is module-scoped and unreachable, same constraint pass 3
   hit. The reachable public signal is the wizard's own DOM:
       .step-content.active[data-step]

   FIX: additive only, same shape as SV TOOLBAR VISIBILITY. Suppress ONLY
   #floating-done-placing-btn — never the whole toolbar — while the active
   step is neither 4 nor 5. Reversible: only ever adds/removes its own
   .sv-toolbar-done-suppressed class; the engine's own display logic takes
   over the instant the class is gone.

   ⚠️ POLLING, NOT requestAnimationFrame. An earlier draft used rAF (matching
   SV TOOLBAR VISIBILITY's own pattern) and it never fired at all while
   under test in a hidden/background browser tab — confirmed by calling the
   apply logic directly and seeing it work perfectly, while the rAF-scheduled
   version never ran. rAF is throttled to near-zero in a backgrounded tab by
   design (browser power-saving), and a customer CAN put this tab in the
   background mid-flow (switching apps, a phone call). A plain interval has
   no such dependency on tab visibility, at the cost of a fixed 200ms
   response instead of “next paint” — a fine trade for a step-change gate.

   VERIFIED on DEV: step 1 (Base Configuration) -> suppressed, hidden.
   Step 4 (S&V Badge Select) -> released, visible. Clear All and the badge
   count chip untouched on both.
   ========================================================================== */
(function () {
  if (window.__svToolbarDoneStepGateInit) return; /* Theme Editor re-runs this script */
  window.__svToolbarDoneStepGateInit = true;

  var BTN_ID = 'floating-done-placing-btn';
  var SUPPRESS = 'sv-toolbar-done-suppressed';
  var POLL_MS = 200;

  function styles() {
    if (document.getElementById('sv-toolbar-done-step-gate-styles')) return;
    var st = document.createElement('style');
    st.id = 'sv-toolbar-done-step-gate-styles';
    /* !important because the engine writes an inline display on this element */
    st.textContent = '#' + BTN_ID + '.' + SUPPRESS + '{display:none !important;}';
    document.head.appendChild(st);
  }

  function activeStep() {
    var el = document.querySelector('.step-content.active[data-step]');
    return el ? el.getAttribute('data-step') : null;
  }

  var lastStep = undefined; /* force the first tick to always evaluate */

  function apply() {
    var btn = document.getElementById(BTN_ID);
    if (!btn) return;
    var step = activeStep();
    if (step === lastStep) return; /* no change since last tick — nothing to do */
    lastStep = step;

    var onPlacementStep = step === '4' || step === '5';
    if (!onPlacementStep) {
      if (!btn.classList.contains(SUPPRESS)) {
        btn.classList.add(SUPPRESS);
        console.log('SV TOOLBAR DONE STEP GATE: hiding "Done placing" — active ' +
                    'step is ' + step + ', not a badge-placement step');
      }
    } else if (btn.classList.contains(SUPPRESS)) {
      btn.classList.remove(SUPPRESS);
      console.log('SV TOOLBAR DONE STEP GATE: releasing "Done placing" — step ' +
                  step + ' is a badge-placement step');
    }
  }

  styles();
  setInterval(apply, POLL_MS);
  apply();

  /* Verify in one console line, same shape as svAuditBaseSwitchArm(). */
  window.svAuditToolbarDoneStepGate = function () {
    var step = activeStep();
    var btn = document.getElementById(BTN_ID);
    var report = {
      installed: !!window.__svToolbarDoneStepGateInit,
      activeStep: step,
      onPlacementStep: step === '4' || step === '5',
      suppressed: btn ? btn.classList.contains(SUPPRESS) : null,
      visible: btn ? getComputedStyle(btn).display !== 'none' : null
    };
    console.log('SV TOOLBAR DONE STEP GATE audit:', report);
    return report;
  };

  console.log('SV TOOLBAR DONE STEP GATE: installed — "Done placing" now hides ' +
              'outside the two badge-placement steps. Clear All and the badge ' +
              'count stay reachable everywhere, unchanged.');
})();


/* ============================================================================
   SV DONE PLACING HIDE — Done placing must actually mean done
   ----------------------------------------------------------------------------
   Reported by Sam Vale, 2026-08-25, testing the ported customiser on a real
   phone: after placing badges and tapping "Done placing", the floating
   toolbar (Clear All · N placed · Done placing) stays on screen.

   NOT a bug in SV TOOLBAR GATE above — that pin is correct and load-bearing,
   see its own comment. The gap is one level up. The engine's own bt() shows
   the toolbar whenever

     (badges placed OR placement armed) AND (#sv-badge-section.expanded OR step 4/5)

   and TOOLBAR GATE deliberately pins the second clause true on mobile so the
   toolbar is reachable at all (see above: the section it pins is hidden by a
   `display:none` ancestor on mobile, so pinning it has no visual effect).
   That means on mobile the toolbar's visibility reduces to "does the jacket
   currently carry any badges" — it cannot go away just because the customer
   tapped Done, because the badges themselves are still on the garment. That
   is correct for keeping Clear All reachable; it is not what "Done placing"
   should mean.

   FIX: same additive suppression pattern as SV TOOLBAR VISIBILITY above, on a
   SEPARATE class. ⚠️ Reusing `sv-toolbar-suppressed` would break silently —
   that block's own apply() removes it the instant nothing else "owns the
   screen", with no idea this block added it for a different reason; the two
   would fight and this fix would never stick. A dedicated class avoids that:
   CSS applies `display:none !important` if EITHER class is present, and
   neither block ever inspects or clears the other's class.

   Suppress on a Done placing tap. Release the moment the badge count changes
   — a new badge placed, or Clear All used — since that is the exact signal
   bt() itself already uses to decide the toolbar is needed again. Never sets
   display to a visible value; only ever adds/removes this one class, so it
   cannot show a toolbar the engine meant to keep hidden.
   ============================================================================ */
(function () {
  if (window.__svDonePlacingHideInit) return; /* Theme Editor re-runs this script */
  window.__svDonePlacingHideInit = true;

  var TOOLBAR_ID = 'floating-badge-toolbar';
  var DONE_BTN_ID = 'floating-done-placing-btn';
  var COUNT_ID = 'floating-badge-count';
  var SUPPRESS = 'sv-done-placing-suppressed'; /* own class, never shared with SV TOOLBAR VISIBILITY */

  var suppressed = false;

  function styles() {
    if (document.getElementById('sv-done-placing-hide-styles')) return;
    var st = document.createElement('style');
    st.id = 'sv-done-placing-hide-styles';
    st.textContent = '#' + TOOLBAR_ID + '.' + SUPPRESS + '{display:none !important;}';
    document.head.appendChild(st);
  }

  function apply() {
    var tb = document.getElementById(TOOLBAR_ID);
    if (!tb) return;
    if (suppressed && !tb.classList.contains(SUPPRESS)) {
      tb.classList.add(SUPPRESS);
      console.log('SV DONE PLACING HIDE: suppressed — Done placing was tapped');
    } else if (!suppressed && tb.classList.contains(SUPPRESS)) {
      tb.classList.remove(SUPPRESS);
      console.log('SV DONE PLACING HIDE: released — badge count changed');
    }
  }

  /* Capture phase, delegated: the toolbar is reparented to <body> by
     SV TOOLBAR REPARENT, so the button is not necessarily where it started
     and a plain addEventListener on the button at load time could miss it. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#' + DONE_BTN_ID);
    if (!btn) return;
    styles();
    /* let the engine's own click handler run first (it toggles state that
       this block does not touch), then apply our suppression on top */
    setTimeout(function () {
      suppressed = true;
      apply();
    }, 0);
  }, true);

  /* Release the moment the badge count changes, exactly as the engine's own
     bt() decides visibility from badge count. Polled getElementById because
     the element is not guaranteed to exist yet when this script runs. */
  var lastCountText = null;
  var tries = 0;
  var watch = setInterval(function () {
    var el = document.getElementById(COUNT_ID);
    if (el) {
      clearInterval(watch);
      lastCountText = el.textContent;
      new MutationObserver(function () {
        var t = el.textContent;
        if (t !== lastCountText) {
          lastCountText = t;
          if (suppressed) {
            suppressed = false;
            apply();
          }
        }
      }).observe(el, { characterData: true, childList: true, subtree: true });
    } else if (++tries > 100) {
      clearInterval(watch); /* ~30s ceiling, same pattern as SV TOOLBAR GATE */
    }
  }, 300);

  console.log('SV DONE PLACING HIDE: installed');
})();


/* ============================================================================
   SV DENIM WASH GATE — Light Denim is selectable on Men's bases, and selecting
   it moves the base price by £10
   ----------------------------------------------------------------------------
   Reported by Sam on his own phone, 2026-08-26: Light Denim shown SELECTED on a
   Men's Gilet at step 2/9, where that wash does not exist as a product.

   ⛔ THE CSS GATE ALREADY EXISTS AND IS CORRECT. Do not "fix" it again.
   jacket.css carries:

       body.sv-gender-male .option-item[data-color="Light Denim"]
         { opacity:.45; filter:saturate(.3); pointer-events:none; cursor:not-allowed }

   On a clean load of a Men's base this fires and the tile is genuinely dead.
   The defect is that the rule hangs entirely on ONE body class, and that class
   goes stale.

   ROOT CAUSE, FROM SOURCE. `sv-gender-male` has exactly ONE writer — `os()` in
   the vendored `jacket-cf.js` — and `os()` has exactly TWO call sites:

       document.addEventListener("change", e =>
         e.target.matches('input[name="ui-gender"]') && os()),   // desktop radio only
       setTimeout(os, 0)                                          // once, at startup

   So the class only updates on a real `change` event from the DESKTOP gender
   radio. Meanwhile `SV GENDER SYNC` (our block, above) re-aligns the radios on a
   250ms poll using:

       function setRadios(name, value) {
         document.querySelectorAll('input[name="'+name+'"]').forEach(function (r) {
           r.checked = (r.value === value);      // assignment only
         });
       }

   **`dispatchEvent` appears ZERO times in that whole block.** Assigning
   `.checked` in JS does not fire `change`. So every time GENDER SYNC corrects
   the gender — its entire purpose — it updates `ui-gender` SILENTLY and `os()`
   never runs. The radio is right; the body class is left behind.

   ⭐ THE ENGINE IS NOT MISSING THE LOGIC. `os()` already toggles both classes
   AND auto-switches a stranded Light Denim selection to Blue, with its own log
   line. It was simply never being told to run. This block does not reimplement
   any of that — it delivers the event the engine is already listening for.
   (Invariant: making ONE function aware of a new state is not the same as the
   SYSTEM being aware. Here the system was fine; the signal was missing.)

   💰 THE MONEY, MEASURED ON DEV — not inferred:
       men's gilet, Blue        -> getCurrentBasePrice()  55
       men's gilet, Light Denim -> getCurrentBaseProduct('Gilet') === null
                                -> getCurrentBasePrice()  65        (+£10.00)
   `ca()` builds the key `mens_gilet_lightblue`; `SV_BASE_PRODUCTS` has no such
   entry (confirmed null, as is `mens_jacket_lightblue`), so `wo()` returns null
   and `Oc()` skips its assignment — the figure falls through to the stale
   `SV_PRICING` theme setting. **An overcharge, on a garment that cannot be made.**

   FIX, two layers, deliberately:

   (1) SIGNAL REPAIR — poll for the body class disagreeing with the real gender
       and, when it does, dispatch a real `change` on the checked `ui-gender`
       radio so the ENGINE'S OWN `os()` runs. Fires only on genuine disagreement,
       so there is no event storm and no fight with GENDER SYNC's own poll.

   (2) BELT AND BRACES — a capture-phase click guard on the Light Denim tile that
       refuses the click on a non-female base. `pointer-events:none` is today the
       ONLY thing preventing selection; there is no `disabled` attribute and the
       engine's own click handler has no gender check. If the class is ever stale
       again for a reason nobody has predicted, the wash still cannot be chosen.
       Layer 1 is the cure; layer 2 is the seatbelt.

   ⚠️ SCOPE. Touches nothing on a Women's base — verified in the audit output.
   Does not alter pricing, does not alter the CSS, does not edit GENDER SYNC.
   ========================================================================== */
(function () {
  if (window.__svDenimWashGateInit) return; /* Theme Editor re-runs this script */
  window.__svDenimWashGateInit = true;

  var POLL_MS = 400;
  var TILE_SEL = '.option-item[data-color="Light Denim"]';
  var repairs = [];   /* audit trail of every signal repair performed */
  var blocked = 0;    /* how many clicks layer 2 had to refuse */

  /* The rendered truth. #gender is the engine's own select and is kept correct
     by GENDER SYNC even when the body class is not. */
  function currentGender() {
    var sel = document.getElementById('gender') || document.getElementById('mobile-gender');
    if (sel && sel.value) return sel.value;
    var radio = document.querySelector('input[name="ui-gender"]:checked');
    return radio ? radio.value : null;
  }

  function isFemaleBase() {
    var g = currentGender();
    return !!(g && String(g).toLowerCase().indexOf('female') === 0);
  }

  /* ---- layer 1: give the engine the event it is already listening for ---- */
  function repairSignal() {
    var g = currentGender();
    if (!g) return;

    var wantMale = (g === 'Male');
    var hasMale = document.body.classList.contains('sv-gender-male');
    var hasFemale = document.body.classList.contains('sv-gender-female');
    if (wantMale === hasMale && (g === 'Male') !== hasFemale) return; /* already agrees */

    /* 2026-09-22 (Women's Gilet): never mid-switch, and never fire a STALE
       radio. Firing the checked radio when it disagreed with #gender turned a
       stale "Male" into a real gender change. Use the radio that matches g. */
    if (window._svChooserApplying || document.body.classList.contains('sv-price-muted')) return;
    var radio = document.querySelector('input[name="ui-gender"][value="' + g + '"]');
    if (radio && !radio.checked) radio.checked = true;
    if (!radio) {
      console.error('SV DENIM WASH GATE: 🔴 body class disagrees with gender "' + g +
                    '" but no input[name="ui-gender"] is checked, so the engine\'s ' +
                    'os() cannot be triggered. Light Denim may be selectable on a ' +
                    'Men\'s base and the base price may be £10 high.');
      return;
    }

    /* The engine's listener is on `change` for this exact radio. Dispatching it
       makes os() run, which fixes the class AND auto-switches a stranded Light
       Denim to Blue using the engine's own code path. */
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    var fixed = document.body.classList.contains('sv-gender-male') === wantMale;
    repairs.push({ at: Date.now(), gender: g, fixed: fixed });
    if (repairs.length > 20) repairs.shift();

    if (fixed) {
      console.log('SV DENIM WASH GATE: body gender class was stale for "' + g +
                  '" — dispatched change on ui-gender, engine os() has corrected it');
    } else {
      console.error('SV DENIM WASH GATE: 🔴 dispatched change on ui-gender but the ' +
                    'body class STILL disagrees with "' + g + '". The engine may have ' +
                    'renamed or unbound os(). Light Denim gating is not working.');
      window.__svDenimGateSignalFailed = true;
    }
  }

  /* ---- layer 2: the seatbelt. CSS is not a permission system. ---- */
  document.addEventListener('click', function (e) {
    var tile = e.target && e.target.closest ? e.target.closest(TILE_SEL) : null;
    if (!tile) return;
    if (isFemaleBase()) return;              /* women's base: entirely untouched */
    e.preventDefault();
    e.stopPropagation();
    blocked++;
    console.warn('SV DENIM WASH GATE: refused a Light Denim selection on a ' +
                 (currentGender() || 'unknown') + ' base — that wash has no product ' +
                 '(SV_BASE_PRODUCTS has no mens_*_lightblue) and selecting it moves ' +
                 'the base price by £10. The CSS gate must have been stale.');
    repairSignal();                          /* fix the underlying cause too */
  }, true);

  setInterval(repairSignal, POLL_MS);
  repairSignal();

  /* Verify in one console line, same shape as the other audits in this file. */
  window.svAuditDenimWashGate = function () {
    var tile = document.querySelector(TILE_SEL);
    var g = currentGender();
    var report = {
      installed: !!window.__svDenimWashGateInit,
      gender: g,
      femaleBase: isFemaleBase(),
      bodyMale: document.body.classList.contains('sv-gender-male'),
      bodyFemale: document.body.classList.contains('sv-gender-female'),
      classAgreesWithGender: g ? (document.body.classList.contains('sv-gender-male') === (g === 'Male')) : null,
      lightDenimPointerEvents: tile ? getComputedStyle(tile).pointerEvents : null,
      denimChecked: (document.querySelector('input[name="properties[Denim Color]"]:checked') || {}).value,
      baseProductResolves: (typeof window.getCurrentBaseProduct === 'function' &&
                            window.getCurrentBaseProduct()) ? true : false,
      basePrice: typeof window.getCurrentBasePrice === 'function' ? window.getCurrentBasePrice() : null,
      signalRepairs: repairs.slice(),
      clicksBlocked: blocked,
      signalFailed: !!window.__svDenimGateSignalFailed
    };
    if (report.classAgreesWithGender === false) {
      console.error('SV DENIM WASH GATE: 🔴 body class does NOT agree with gender — ' +
                    'Light Denim is selectable on a Men\'s base right now.');
    }
    if (!report.baseProductResolves) {
      console.error('SV DENIM WASH GATE: 🔴 the current gender/style/wash combination ' +
                    'resolves to NO product. The displayed base price is a fallback, ' +
                    'not this garment\'s price.');
    }
    console.log('SV DENIM WASH GATE audit:', report);
    return report;
  };

  console.log('SV DENIM WASH GATE: installed — the engine\'s own gender class is kept ' +
              'in sync, and Light Denim cannot be selected on a Men\'s base even if it is not.');
})();

/* ============================================================================
   SV PHANTOM SAVED SESSION — every visitor is shown a full-screen "Continue
   Your Design" prompt for a design that contains nothing
   ----------------------------------------------------------------------------
   Found 2026-08-27 while trying to reach step 4 on DEV. The prompt blocked the
   wizard and I could not get past it. Sam hit the same wall on his phone.

   ⛔ THIS IS NOT A STALE-STATE ARTEFACT. It fires on a COLD load with empty
   storage. Measured on DEV, fresh navigation, nothing in localStorage:

       jacket-autosave-design            absent
       jacket-cart-designs               absent
       designStateManager.savedDesigns   { "Male-Jacket": {...},
                                           "Male-Gilet": null,
                                           "Female-Jacket": null,
                                           "Female-Gilet": null }

   and that one live entry read:

       studs 0 · badges 0 · customText "" · savedAt 2026-08-26T23:58:03.829Z

   `savedAt` is ONE SECOND after the navigation. The engine writes an empty
   design into its own in-memory store during boot, then asks the customer
   whether they would like to carry on with it.

   THE CHAIN, FROM SOURCE. Three links, and the middle one is the defect:

     1. something calls `X.saveDesignForType('Male','Jacket')` ~1s into boot.
     2. `getDesignSummary()` returns `hasDesign: !0` for ANY non-null entry:

            const n = this.savedDesigns[o];
            return n ? { hasDesign:!0, studCount:n.activeStuds.length, ... }
                     : { hasDesign:!1, summary:"No customizations" };

        It reports the stud count but never asks whether the count is zero.
        Non-null is treated as "has a design". An empty object passes.
     3. `Ls()` ("Checking for saved design on page load") filters on exactly
        that flag — `Object.keys(e).filter(p => e[p].hasDesign)` — finds 1, and
        appends the full-viewport modal.

   ⭐ THE ENGINE ALREADY KNOWS THE RIGHT TEST. `saveDesignForType` itself gates
   on `activeStuds.length > 0 || badges.length > 0 || customText.text`. That is
   the correct definition of "a design". `getDesignSummary` simply does not
   apply it. This block applies the engine's own rule at the point where the
   decision is actually made. It invents no new policy.

   💥 WHAT IT COSTS, beyond the block. The phantom is keyed `Male-Jacket`. On
   the same load `sv-chooser-pick` read `{"gender":"Male","style":"Gilet"}`.
   So "Continue Design" swaps a customer off the Gilet they chose and onto a
   Jacket, to restore nothing — and a garment swap is the exact condition that
   replays badge world-coordinates onto the wrong mesh (see the floating-badge
   note in the ledger). A prompt for an empty design is not merely noise; it is
   a one-tap route to a wrong garment.

   ⚠️ SCOPED TO ONE OF THE TWO MODALS, DELIBERATELY. The engine ships two
   different saved-session dialogs and they are not interchangeable:

       A  id="continue-design-overlay", className="svm-overlay"
          built by `Sa(e)`, driven by the autosave, RETURNS A PROMISE that its
          own buttons resolve. Removing it from outside would leave that promise
          pending forever. NEVER TOUCHED BY THIS BLOCK.

       B  className="continue-design-overlay svm-overlay", NO id
          built by `Ls()`, driven by savedDesigns, renders one
          `.saved-design-item` per design, resolves nothing.

   `.saved-design-item` exists only in B, so that is the discriminator used
   here. Note that our earlier blocks (`SV MODAL DISMISS`, `SV AUTOSAVE
   COVERAGE`) address B's twin by `getElementById('continue-design-overlay')`
   and are therefore blind to B entirely — B has no id. That gap is why this
   was never caught before. Do not "tidy" those blocks to share a selector:
   A and B need different handling, which is the whole point of this comment.

   FAILS OPEN, ALWAYS. If `designStateManager` is missing, or an entry cannot be
   read, or ANY listed design has real content, the modal is left exactly as the
   engine built it. This block only ever removes a prompt that is offering
   nothing, and it says so in the console when it does.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__svPhantomSavedSessionInit) return; /* Theme Editor re-runs this script */
  window.__svPhantomSavedSessionInit = true;

  var MODAL = '.continue-design-overlay';
  var ITEM  = '.saved-design-item';
  var removedCount = 0;
  var lastReport = null;

  /* The engine's own definition of "a design", lifted from saveDesignForType.
     Kept as one function so there is a single place to correct if the engine's
     rule ever changes. uploadedImages is included because a customer who has
     uploaded artwork and nothing else has unquestionably done work. */
  function hasRealContent(d) {
    if (!d) return false;
    if (d.activeStuds && d.activeStuds.length > 0) return true;
    if (d.badges && d.badges.length > 0) return true;
    if (d.customText && d.customText.text) return true;
    if (d.uploadedImages && d.uploadedImages.length > 0) return true;
    return false;
  }

  function store() {
    var X = window.designStateManager;
    return (X && X.savedDesigns) ? X : null;
  }

  /* Returns null when we cannot judge — the caller then leaves the modal be. */
  function judge(ov) {
    var X = store();
    if (!X) return null;
    var items = ov.querySelectorAll(ITEM);
    if (!items.length) return null; /* not modal B, or nothing listed */

    var real = [], empty = [];
    for (var i = 0; i < items.length; i++) {
      var key = items[i].getAttribute('data-design-key');
      if (!key) return null;                    /* unexpected shape — bail out */
      if (!(key in X.savedDesigns)) return null; /* not ours to judge */
      (hasRealContent(X.savedDesigns[key]) ? real : empty).push(key);
    }
    return { real: real, empty: empty };
  }

  function apply(ov) {
    if (!ov || !ov.parentNode) return;
    var v = judge(ov);
    if (!v) return;                 /* fail open */
    if (v.real.length > 0) {
      /* Genuine designs are on offer. Leave the customer's dialog alone —
         removing an empty ROW here would renumber "We found N", and a wrong
         count is worse than an extra row. */
      return;
    }

    /* Nothing on offer has any content. Null the empty slots so the engine's
       own count badge and any later Ls() agree with what we just did, then
       take the prompt off the screen. */
    var X = store();
    v.empty.forEach(function (k) { X.savedDesigns[k] = null; });
    if (typeof X.updateDesignIndicators === 'function') {
      try { X.updateDesignIndicators(); } catch (e) {}
    }
    ov.remove();
    removedCount++;
    lastReport = { at: Date.now(), cleared: v.empty.slice() };
    console.log('SV PHANTOM SAVED SESSION: removed a "Continue Your Design" ' +
                'prompt offering ' + v.empty.length + ' design(s) with no studs, ' +
                'no badges, no text and no uploads — [' + v.empty.join(', ') + ']. ' +
                'The customer was being asked to resume nothing.');
  }

  function sweep() {
    document.querySelectorAll(MODAL).forEach(apply);
  }

  /* Ls() appends the modal with document.body.appendChild, so childList on body
     catches it on arrival. The engine also re-runs the check after a restore,
     so this must stay live for the whole session rather than firing once. */
  if (document.body) {
    new MutationObserver(sweep).observe(document.body, { childList: true });
  }
  sweep(); /* it may already be up by the time this file runs */

  /* Verify in one console line, same shape as the other audits in this file. */
  window.svAuditPhantomSavedSession = function () {
    var X = store();
    var modal = document.querySelector(MODAL);
    var report = {
      installed: !!window.__svPhantomSavedSessionInit,
      designStateManagerPresent: !!X,
      savedDesigns: X ? (function () {
        var o = {};
        Object.keys(X.savedDesigns).forEach(function (k) {
          var d = X.savedDesigns[k];
          o[k] = d ? {
            studs: (d.activeStuds || []).length,
            badges: (d.badges || []).length,
            text: !!(d.customText && d.customText.text),
            uploads: (d.uploadedImages || []).length,
            real: hasRealContent(d)
          } : null;
        });
        return o;
      })() : null,
      modalOnScreen: !!modal,
      modalIsTypeB: !!(modal && modal.querySelectorAll(ITEM).length),
      promptsRemoved: removedCount,
      lastRemoval: lastReport
    };
    console.log('SV PHANTOM SAVED SESSION audit:', report);
    return report;
  };

  console.log('SV PHANTOM SAVED SESSION: installed — a saved-session prompt is ' +
              'now removed when every design it offers is empty. A prompt with ' +
              'any real design in it is left untouched.');
})();

/* ============================================================================
   SV FRESH START DEDUPE  —  P1: "Start Fresh" asks the same question twice.

   Sam, 2026-08-27: "I have to click four buttons, four pop-ups before I can
   make a clean start."

   Measured on DEV at 393x852 with a saved Jacket design:

     1  #continue-design-overlay      "Start Fresh" / "Continue My Design"
     2  .sv-base-switch-overlay       "Discard your saved design?"
                                      "Keep my design" / "Start fresh"

   Two dialogs, one decision. The customer taps Start Fresh and is immediately
   asked to confirm the same thing in different words. Prompt 1 is not even
   removed when prompt 2 opens — it was measured still in the DOM at z 10000
   underneath, so the app stacks rather than replaces.

   THE FIX. When the customer clicks Start Fresh we open a short window. If the
   discard dialog appears inside that window, we answer it with the answer the
   customer has already given, by clicking its own confirm button.

   ⛔ We CLICK the dialog's own button. We do NOT remove the dialog from the
   DOM. `SESSION_LOG_2026-08-27.md` §2 records why: these dialogs settle a
   promise from their own handlers, and tearing one out from outside leaves
   that promise pending forever.

   ⛔ Scoped three ways so a genuine base switch is never auto-answered:
     - only inside the window opened by a real Start Fresh click,
     - only for a dialog whose text is the discard wording,
     - once per window, then the window closes.

   A base switch that would discard work the customer has NOT been warned
   about still shows its dialog normally. That is a different question and it
   keeps its prompt.

   Fails open. If anything throws, or the confirm button is missing, the dialog
   is left exactly as it is and the customer can answer it by hand.

   Verify in one line: svAuditFreshStartDedupe()
   ========================================================================== */
(function () {
  'use strict';

  var WINDOW_MS = 6000;
  var DISCARD_RE = /discard your saved design/i;

  var openUntil = 0;
  var observer = null;
  var report = { installed: false, windowsOpened: 0, dialogsAnswered: 0, dialogsLeft: 0, lastAction: null };

  function windowOpen() {
    return Date.now() < openUntil;
  }

  function looksLikeDiscardDialog(el) {
    if (!el || !el.querySelector) return false;
    var txt = '';
    try { txt = (el.textContent || '').replace(/\s+/g, ' '); } catch (e) { return false; }
    return DISCARD_RE.test(txt);
  }

  function tryAnswer(el) {
    if (!windowOpen()) return false;
    if (!looksLikeDiscardDialog(el)) {
      report.dialogsLeft++;
      report.lastAction = 'left a base-switch dialog alone (wording did not match the discard prompt)';
      return false;
    }
    var confirmBtn = null;
    try { confirmBtn = el.querySelector('.sv-bs-confirm'); } catch (e) {}
    if (!confirmBtn) {
      report.dialogsLeft++;
      report.lastAction = 'discard dialog had no .sv-bs-confirm — left for the customer';
      console.warn('SV FRESH START DEDUPE: discard dialog has no confirm button, leaving it alone');
      return false;
    }
    openUntil = 0;
    try {
      confirmBtn.click();
      report.dialogsAnswered++;
      report.lastAction = 'answered the duplicate discard prompt with the customer’s own Start Fresh choice';
      console.log('SV FRESH START DEDUPE: duplicate discard prompt answered automatically — ' +
                  'the customer already chose Start Fresh');
      return true;
    } catch (e) {
      report.dialogsLeft++;
      report.lastAction = 'confirm click threw — dialog left for the customer';
      console.error('SV FRESH START DEDUPE: confirm click threw', e);
      return false;
    }
  }

  function scanNow() {
    if (!windowOpen()) return;
    var nodes;
    try { nodes = document.querySelectorAll('.sv-base-switch-overlay'); } catch (e) { return; }
    for (var i = 0; i < nodes.length; i++) {
      if (tryAnswer(nodes[i])) return;
    }
  }

  function openWindow() {
    openUntil = Date.now() + WINDOW_MS;
    report.windowsOpened++;
    console.log('SV FRESH START DEDUPE: Start Fresh chosen — watching ' + WINDOW_MS +
                'ms for the duplicate discard prompt');
    scanNow();
    var ticks = 0;
    var poll = setInterval(function () {
      ticks++;
      if (!windowOpen() || ticks > 60) { clearInterval(poll); return; }
      scanNow();
    }, 100);
  }

  function isStartFresh(el) {
    if (!el || !el.closest) return false;
    try {
      if (el.closest('#start-fresh-btn')) return true;
      var btn = el.closest('button');
      if (!btn) return false;
      if (btn.id === 'start-fresh-btn') return true;
      var host = btn.closest('#continue-design-overlay, .continue-design-overlay');
      if (!host) return false;
      return /start\s*fresh/i.test((btn.textContent || '').replace(/\s+/g, ' '));
    } catch (e) { return false; }
  }

  function onClick(ev) {
    try {
      if (isStartFresh(ev.target)) openWindow();
    } catch (e) {
      console.error('SV FRESH START DEDUPE: click handler threw', e);
    }
  }

  try {
    document.addEventListener('click', onClick, true);

    if (typeof MutationObserver === 'function') {
      observer = new MutationObserver(function (muts) {
        if (!windowOpen()) return;
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('sv-base-switch-overlay')) {
              if (tryAnswer(n)) return;
            } else if (n.querySelector) {
              var inner = n.querySelector('.sv-base-switch-overlay');
              if (inner && tryAnswer(inner)) return;
            }
          }
        }
      });
      observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }

    report.installed = true;
    console.log('SV FRESH START DEDUPE: installed — Start Fresh is now one decision, not two');
  } catch (e) {
    console.error('SV FRESH START DEDUPE: NOT installed — the duplicate discard prompt will ' +
                  'still appear', e);
  }

  window.svAuditFreshStartDedupe = function () {
    var out = {
      installed: report.installed,
      observing: !!observer,
      windowsOpened: report.windowsOpened,
      dialogsAnswered: report.dialogsAnswered,
      dialogsLeftForCustomer: report.dialogsLeft,
      windowOpenNow: windowOpen(),
      lastAction: report.lastAction
    };
    if (!out.installed) {
      console.error('SV FRESH START DEDUPE: not installed — customers still get asked twice');
    }
    console.log('SV FRESH START DEDUPE audit:', out);
    return out;
  };
})();

/* ============================================================================
   SV TIP TARGET SIZE  —  P2: the onboarding tip controls are too small to tap.

   Measured on DEV at 393x852:

     .sv-tip-close   22 x 22 px    the × that dismisses a tip bubble
     .sv-tip-btn     26 x 26 px    the ⓘ in each step header that opens one

   Both are under the 44 px minimum touch target, on the very controls the
   customer is meant to tap. `.sv-tip-btn` is not a floating control: there is
   one per wizard section, inside that section's `.section-header`, and only
   the active step's is rendered (27 in the DOM, 1 with a box).

   THE FIX. Grow the HIT AREA only. Each control gets a transparent, centred
   44 x 44 pseudo-element, so the glyph the customer sees does not move or
   change size — only the tappable area around it grows.

   ⛔ CSS, not JS, and deliberately so. The engine creates and destroys these
   tips as the customer moves through the steps, and the tip bubble changes
   position between tips (measured at both `(10, 796)` and `(22, 30)` in one
   session). A one-shot JS pass would fix the first tip and miss every one
   after it. A stylesheet applies to every instance, including later ones.

   ⚠️ MEASURING THIS CORRECTLY — two traps, both of which produce a FALSE
   "this control is broken" reading:

     1. `.sv-tip-bubble` sits at `opacity: 0` when faded. Audited in that
        state, the close button scores 0/4 and the bottom sheet appears to be
        on top of it. That is NOT occlusion. Only audit `.sv-tip-close` while
        the bubble computes `opacity: 1`.

     2. The bottom sheet is `position: fixed` and COLLAPSES by transform, not
        by scrolling — measured `translateY(399px)` in the peek state. While it
        is collapsed the active step's content sits below the fold, and
        `scrollIntoView` cannot move it because nothing is scrolling. An
        earlier pass read that as `.sv-tip-btn` being "clipped 9 px off the
        bottom of the screen" and biased this hit area upward to compensate.
        That was wrong. It is the collapsed drawer, exactly as the
        "Swipe up to customise" hint says. Swipe the sheet up and the button
        sits at y 522 of 852, fully on screen, scoring 4/4.

   The upward bias has therefore been REMOVED and the hit area is centred.
   ⛔ Do not re-add it. If a tip control looks off-screen, expand the drawer
   before concluding anything.

   Verify in one line: svAuditTipTargets()
   ========================================================================== */
(function () {
  'use strict';

  var MIN = 44;
  var STYLE_ID = 'sv-tip-target-size';

  var CSS = [
    /* the visible glyph is untouched — only a transparent hit area is added */
    '.sv-tip-close, .sv-tip-btn { position: relative; }',
    '.sv-tip-close::after, .sv-tip-btn::after {',
    '  content: "";',
    '  position: absolute;',
    '  left: 50%;',
    '  top: 50%;',
    '  width: ' + MIN + 'px;',
    '  height: ' + MIN + 'px;',
    '  transform: translate(-50%, -50%);',
    '  border-radius: 50%;',
    '  background: transparent;',
    '  pointer-events: auto;',
    '}'
  ].join('\n');

  function install() {
    var existing = document.getElementById(STYLE_ID);
    if (existing) existing.remove();
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return false;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.type = 'text/css';
    el.appendChild(document.createTextNode(CSS));
    head.appendChild(el);
    return true;
  }

  try {
    if (install()) {
      console.log('SV TIP TARGET SIZE: installed — tip controls now have a centred ' + MIN +
                  'px hit area, glyphs unchanged');
    } else {
      console.error('SV TIP TARGET SIZE: NOT installed — no <head> to attach to; ' +
                    'tip controls stay at 22px and 26px');
    }
  } catch (e) {
    console.error('SV TIP TARGET SIZE: NOT installed — tip controls stay too small', e);
  }

  window.svAuditTipTargets = function () {
    var rows = [];
    try {
      ['.sv-tip-close', '.sv-tip-btn'].forEach(function (sel) {
        var nodes = document.querySelectorAll(sel);
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          var r = n.getBoundingClientRect();
          if (!r.width) continue;
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          var off = (MIN / 2) - 3;
          var pts = [[cx - off, cy], [cx + off, cy], [cx, cy - off], [cx, cy + off]];
          var hits = 0;
          for (var p = 0; p < pts.length; p++) {
            var t = document.elementFromPoint(pts[p][0], pts[p][1]);
            if (t && (t === n || n.contains(t) || (t.closest && t.closest(sel) === n))) hits++;
          }
          var bubble = n.closest ? n.closest('.sv-tip-bubble') : null;
          var faded = false;
          try { faded = !!(bubble && parseFloat(getComputedStyle(bubble).opacity) < 0.05); } catch (e2) {}
          rows.push({
            selector: sel,
            visualSize: Math.round(r.width) + 'x' + Math.round(r.height),
            hitPointsPassing: hits + '/4',
            onScreen: r.bottom <= window.innerHeight && r.top >= 0,
            /* a faded bubble or a collapsed drawer makes the score meaningless */
            scoreMeaningful: !faded && r.bottom <= window.innerHeight && r.top >= 0,
            note: faded ? 'bubble is faded (opacity 0) — score not meaningful'
                        : (r.bottom > window.innerHeight ? 'below the fold — expand the drawer first' : null)
          });
        }
      });
    } catch (e) {
      console.error('SV TIP TARGET SIZE audit threw', e);
    }
    var out = { styleInstalled: !!document.getElementById(STYLE_ID), minTarget: MIN, controls: rows };
    if (!out.styleInstalled) console.error('SV TIP TARGET SIZE: stylesheet missing');
    if (!rows.length) console.log('SV TIP TARGET SIZE: no tip controls on screen right now');
    console.log('SV TIP TARGET SIZE audit:', out);
    return out;
  };
})();

/* ============================================================================
   SV GENDER CONFIRM DEDUPE  —  P1: the gender pill needs three or four taps.

   Sam, 2026-08-27: "I press the same button and it turns from black to green
   to black, and then it switches. I press it like three or four times."

   MEASURED on DEV, iPhone-emulated (`hover: none`, `pointer: coarse`):

     one `change` on the gender input  ->  handleGenderChange called 3x
                                       ->  THREE .gender-change-overlay dialogs

   Three duplicate listeners are bound to the same input — re-attached on each
   render without being removed — so one tap opens three identical
   "Switch to Women's?" confirmations, stacked exactly on top of each other.
   The customer confirms the top one, the next identical dialog is revealed
   underneath, and they confirm again. That is the three-or-four taps.

   ⛔ The duplicate dialogs carry DUPLICATE ids (`confirm-gender-change`), so
   `document.getElementById` only ever finds the first one. Query inside each
   overlay by class (`.svm-btn--primary` / `.svm-btn--secondary`) instead.

   THE FIX. Show ONE dialog. When a duplicate opens while one is already up,
   hide the duplicate and remember it. When the customer answers the visible
   one, give the SAME answer to each hidden duplicate by clicking ITS OWN
   button, so every pending handler resolves the same way.

   ⛔ We CLICK each duplicate's own button and never just remove it.
   `SESSION_LOG_2026-08-27.md` §2 records why: these dialogs resolve a Promise
   from their own handlers, and tearing one out leaves that promise pending
   forever.

   ⛔ We do NOT auto-answer the dialog the customer can see. Confirming for
   them would switch the base — and a gender switch drops badges and changes
   the price — without consent. Only the surplus copies are answered, and only
   with the answer the customer just gave.

   Fails open: if anything throws, every dialog is left exactly as it is and
   the customer can still answer them by hand, as they do today.

   Verify in one line: svAuditGenderConfirmDedupe()
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '.gender-change-overlay';
  var PRIMARY = '.svm-btn--primary';
  var SECONDARY = '.svm-btn--secondary';

  var hidden = [];          /* surplus dialogs we have hidden */
  var report = { installed: false, dialogsHidden: 0, dialogsForwarded: 0, lastAnswer: null };

  function visibleDialogs() {
    var out = [];
    try {
      var all = document.querySelectorAll(SEL);
      for (var i = 0; i < all.length; i++) {
        if (hidden.indexOf(all[i]) === -1) out.push(all[i]);
      }
    } catch (e) {}
    return out;
  }

  function hideSurplus(node) {
    try {
      if (hidden.indexOf(node) !== -1) return;
      node.setAttribute('data-sv-surplus', '1');
      node.style.display = 'none';
      node.style.pointerEvents = 'none';
      hidden.push(node);
      report.dialogsHidden++;
      console.log('SV GENDER CONFIRM DEDUPE: hid a duplicate confirmation (' +
                  hidden.length + ' surplus now pending)');
    } catch (e) {
      console.error('SV GENDER CONFIRM DEDUPE: could not hide a duplicate', e);
    }
  }

  /* give every hidden duplicate the same answer the customer just gave */
  function forwardAnswer(isConfirm) {
    var list = hidden.slice();
    hidden.length = 0;
    report.lastAnswer = isConfirm ? 'confirm' : 'cancel';
    for (var i = 0; i < list.length; i++) {
      var node = list[i];
      try {
        /* stays hidden — .click() still runs its handlers, and un-hiding it
           flashes a leftover dialog at the customer (measured 2026-08-27) */
        var btn = node.querySelector(isConfirm ? PRIMARY : SECONDARY);
        if (btn) {
          btn.click();
          report.dialogsForwarded++;
          /* its promise is settled by the click; drop the node so it can never
             be revealed by a later re-render */
          (function (n) { setTimeout(function () { try { if (n && n.parentNode) n.remove(); } catch (e) {} }, 400); })(node);
        } else {
          console.warn('SV GENDER CONFIRM DEDUPE: duplicate had no ' +
                       (isConfirm ? 'confirm' : 'cancel') + ' button — left alone');
        }
      } catch (e) {
        console.error('SV GENDER CONFIRM DEDUPE: forwarding to a duplicate threw', e);
      }
    }
    if (list.length) {
      console.log('SV GENDER CONFIRM DEDUPE: forwarded "' + report.lastAnswer +
                  '" to ' + list.length + ' duplicate confirmation(s)');
    }
  }

  function onClick(ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      var overlay = t.closest(SEL);
      if (!overlay) return;
      if (overlay.getAttribute('data-sv-surplus') === '1') return;  /* our own forwarded click */
      var btn = t.closest('button');
      if (!btn) return;
      if (btn.matches(PRIMARY)) forwardAnswer(true);
      else if (btn.matches(SECONDARY)) forwardAnswer(false);
    } catch (e) {
      console.error('SV GENDER CONFIRM DEDUPE: click handler threw', e);
    }
  }

  try {
    /* run AFTER the dialog's own handler, so the customer's answer lands first */
    document.addEventListener('click', onClick, false);

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (!n || n.nodeType !== 1) continue;
            var node = (n.classList && n.classList.contains('gender-change-overlay'))
                        ? n : (n.querySelector ? n.querySelector(SEL) : null);
            if (!node) continue;
            /* the FIRST dialog stays visible; anything beyond it is surplus */
            if (visibleDialogs().length > 1) hideSurplus(node);
          }
        }
      }).observe(document.body || document.documentElement, { childList: true, subtree: true });
    }

    report.installed = true;
    console.log('SV GENDER CONFIRM DEDUPE: installed — one gender confirmation per tap');
  } catch (e) {
    console.error('SV GENDER CONFIRM DEDUPE: NOT installed — the gender pill will ' +
                  'still stack duplicate confirmations', e);
  }

  window.svAuditGenderConfirmDedupe = function () {
    var out = {
      installed: report.installed,
      dialogsOnScreenNow: document.querySelectorAll(SEL).length,
      surplusPendingNow: hidden.length,
      dialogsHidden: report.dialogsHidden,
      dialogsForwarded: report.dialogsForwarded,
      lastAnswer: report.lastAnswer
    };
    if (!out.installed) {
      console.error('SV GENDER CONFIRM DEDUPE: not installed — customers still tap 3-4 times');
    }
    console.log('SV GENDER CONFIRM DEDUPE audit:', out);
    return out;
  };
})();

/* ============================================================================
   SV LOADING SCREEN FULL BLEED  —  P2: the black loading screen only covers
   part of the phone screen.

   Sam, 2026-08-27, real iPhone on the DEV preview: switching base showed
   "Crafting your women's gilet… 92%" with the black panel filling only the
   canvas area. The site header stayed visible above it and a white band sat
   below it, where the bottom sheet had been hidden by:

       body:has(.loading-spinner.show) .nike-bottom-sheet { visibility: hidden }

   The overlay is styled `position: fixed; inset: 0; width: 100vw; height: 100vh`
   (sections/jacket.liquid), so it SHOULD cover the screen — and in an emulated
   iPhone at 393x852 it measures exactly `[0,0,393,852]` with no transformed
   ancestors. It does not misbehave there.

   ⚠️ NOT REPRODUCED on this harness. This is a robustness fix aimed at the one
   mechanism that produces exactly this symptom: **`position: fixed` escapes to
   the viewport only if no ancestor forms a containing block.** Any ancestor
   with a transform, filter, backdrop-filter, perspective, `contain`, or
   `will-change: transform` traps it, and it is then sized and positioned
   against that ancestor — which here is the canvas box, exactly what Sam saw.

   THE FIX, two parts:
     1. Re-parent `#loading-spinner` to <body>, so no ancestor can ever form a
        containing block for it.
     2. Force `height: 100dvh`. On mobile Safari `100vh` is the LARGE viewport
        height and does not track the browser chrome; `dvh` does. `100vh` is
        kept as the first declaration so older engines still get a value.

   ⛔ Re-parenting is safe here and was checked: every other rule for this
   element is either on `.loading-spinner` itself or a DESCENDANT of it
   (`.loading-spinner .loading-text`, `.loading-progress-bar`, …), so none of
   them depend on where it sits. The one ancestor-scoped rule,
   `body:has(.loading-spinner.show) .nike-bottom-sheet`, still matches — the
   element stays inside <body> either way. The engine finds it with
   `getElementById`, which does not care about position in the tree.

   ⛔ Do NOT "fix" this by removing the transform/filter from whichever ancestor
   causes it. That ancestor is doing layout work (the sheet and viewer animate),
   and the loader should not depend on it either way.

   Verify in one line: svAuditLoadingScreen()
   ========================================================================== */
(function () {
  'use strict';

  var ID = 'loading-spinner';
  var STYLE_ID = 'sv-loading-fullbleed';
  var report = { installed: false, reparented: false, reparentCount: 0 };

  var CSS = [
    '#' + ID + ' {',
    '  position: fixed !important;',
    '  inset: 0 !important;',
    '  width: 100vw !important;',
    '  height: 100vh !important;',   /* fallback first */
    '  height: 100dvh !important;',  /* correct on mobile Safari */
    '  max-height: none !important;',
    '}'
  ].join('\n');

  function installCss() {
    if (document.getElementById(STYLE_ID)) return true;
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return false;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.appendChild(document.createTextNode(CSS));
    head.appendChild(el);
    return true;
  }

  function reparent() {
    try {
      var el = document.getElementById(ID);
      if (!el) return false;
      if (el.parentNode === document.body) return true;
      document.body.appendChild(el);
      report.reparented = true;
      report.reparentCount++;
      console.log('SV LOADING SCREEN FULL BLEED: moved the loading overlay to <body> so no ' +
                  'ancestor can trap it');
      return true;
    } catch (e) {
      console.error('SV LOADING SCREEN FULL BLEED: re-parent failed — the overlay may still ' +
                    'be confined to the canvas', e);
      return false;
    }
  }

  try {
    installCss();
    if (!reparent()) {
      /* the element is in the section markup, but do not assume it is parsed yet */
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (reparent() || tries > 40) clearInterval(poll);
      }, 250);
    }
    report.installed = true;
    console.log('SV LOADING SCREEN FULL BLEED: installed');
  } catch (e) {
    console.error('SV LOADING SCREEN FULL BLEED: NOT installed — the loading screen may cover ' +
                  'only part of the screen', e);
  }

  window.svAuditLoadingScreen = function () {
    var el = document.getElementById(ID);
    var out = { installed: report.installed, styleInstalled: !!document.getElementById(STYLE_ID),
                found: !!el, reparented: report.reparented };
    if (el) {
      var r = el.getBoundingClientRect();
      var cs = getComputedStyle(el);
      out.parentIsBody = el.parentNode === document.body;
      out.position = cs.position;
      out.rect = [Math.round(r.x), Math.round(r.y), Math.round(r.width), Math.round(r.height)];
      out.viewport = [window.innerWidth, window.innerHeight];
      out.coversScreen = Math.round(r.width) >= window.innerWidth - 2 &&
                         Math.round(r.height) >= window.innerHeight - 2 &&
                         Math.round(r.y) <= 0;
      /* any ancestor that would trap a fixed element */
      var bad = [], n = el.parentElement, i = 0;
      while (n && i++ < 12) {
        var c = getComputedStyle(n);
        if (c.transform !== 'none' || c.filter !== 'none' || c.perspective !== 'none' ||
            c.backdropFilter !== 'none' || c.contain !== 'none' || /transform|filter/.test(c.willChange)) {
          bad.push((n.id || n.className || n.tagName).toString().slice(0, 30));
        }
        n = n.parentElement;
      }
      out.trappingAncestors = bad;
      if (!out.coversScreen) {
        console.error('SV LOADING SCREEN FULL BLEED: overlay does NOT cover the screen', out);
      }
    }
    console.log('SV LOADING SCREEN FULL BLEED audit:', out);
    return out;
  };
})();


/* ============================================================================
   SV DENIM STEP MIRROR — step 2 shows the wash the customer already picked at
   the base chooser
   ----------------------------------------------------------------------------
   Reported by Sam, 2026-08-27: "if we use the change base pill, and we choose a
   colour of a jacket, when we go into denim colour in the menu bar, it should
   automatically reflect what has been selected, whether it's male or female."

   REPRODUCED on DEV at 393x852 from a clean load. Chooser -> Men's Jacket /
   Black / Medium -> Start Customising, then step 2/9:

       localStorage sv-chooser-pick   { denim: "Black" }          correct
       desktop radio #black-denim     checked, .color-option.active  correct
       #denim-color-summary           "Black"                     correct
       .option-item[data-color] x3    selected: false, false, false   <-- WRONG

   The customer chose Black and the step shows NOTHING selected.

   ⛔ THE GENDER HALF OF THE REPORT IS ALREADY FIXED. Do not build it again.
   `SV DENIM WASH GATE` (block above, 2026-08-26) keeps `body.sv-gender-male`
   honest, and jacket.css then greys the Light Denim tile and prints "Women's
   only". Measured on the same run: opacity 0.45, pointer-events none, with the
   male body class present. That part works.

   ROOT CAUSE, FROM SOURCE. The chooser's apply function `S(F)` in jacket.js
   ends with:

       const q = {"Light Denim":"light-denim", Blue:"blue-denim", Black:"black-denim"},
             ne = document.getElementById(q[F.denim]);
       if (ne) { ne.checked = !0; ne.dispatchEvent(new Event("change",{bubbles:!0}));
                 const K = ne.closest(".color-option"); K && K.click(); }

   Every one of those touches the DESKTOP control. The mobile step-2 grid is a
   separate set of `.option-item[data-color]` divs whose only "selected" writers
   are `Il()` (the mobile tap handler) and `js()` / syncDenimColorUI. `S(F)`
   calls neither, so the tiles are never marked.

   `js()` IS called on a gender change and on a style change — but `S(F)`
   dispatches the gender change BEFORE it applies the denim, so that call syncs
   to the PREVIOUS wash. The one pass that could have saved it runs too early.

   ⭐ WHY THIS BLOCK MIRRORS RATHER THAN PATCHING THE CHOOSER. `S(F)` is one of
   at least four routes that set the wash (chooser apply, URL params on load,
   desktop radio, mobile tap) and `os()` silently rewrites it again when a
   stranded Light Denim is switched to Blue on a Men's base. Teaching ONE of
   those about the mobile tiles is the "made one function aware of the new
   state, not the system" mistake this project has now paid for six times. So
   the block treats the checked cart radio as the single source of truth and
   keeps the tiles agreeing with it, whoever moved it.

   ⚠️ AN EVENT LISTENER ALONE IS NOT ENOUGH, for the reason already recorded in
   `SV DENIM WASH GATE`: `js()` sets `t.checked = !0` with NO dispatchEvent, so
   the gender-change route moves the radio silently. Hence the 500ms poll. It
   only WRITES when the DOM disagrees, so it never fights the customer's finger
   and never churns the DOM on an idle page.

   THE CLASS IS THE WHOLE VISUAL — no inline styles needed. jacket.css carries

       .option-item.selected { border-color:#000 !important; background:#f9fafb !important }
       .option-grid .option-item.selected > div:first-child
         { box-shadow: 0 0 0 3px #1a1a1a, 0 0 0 6px white, ... !important }

   and those !important rules beat the engine's inline styles. Measured on the
   served page with and without the inline `border:2px solid #3b82f6` that the
   tap handler writes: computed border-color rgb(0,0,0), background
   rgb(249,250,251), width 2px — IDENTICAL both ways. So when this block writes
   it also clears the inline styles, because the engine writes two different
   inline looks for the same state (#3b82f6 from `Il()`, #333 from `js()`) and
   one look is better than two.

   Verify in one line: svAuditDenimStepMirror()
   ============================================================================ */
(function () {
  'use strict';

  var TILES = '.option-item[data-color]';
  var RADIO = 'input[name="properties[Denim Color]"]';
  var POLL_MS = 500;

  var writes = 0;
  var lastWash = null;
  var lastReason = null;

  /* The wash that is actually going into the cart. */
  function currentWash() {
    var r = document.querySelector(RADIO + ':checked');
    if (r && r.value) return r.value;
    /* Nothing checked at all — fall back to the chooser's own record so the
       step is still right during the gap before the radios are wired. */
    try {
      var p = JSON.parse(localStorage.getItem('sv-chooser-pick') || 'null');
      if (p && p.denim) return p.denim;
    } catch (e) {}
    return null;
  }

  function tiles() {
    return document.querySelectorAll(TILES);
  }

  /* True when every tile already carries the right state. */
  function agrees(wash) {
    var t = tiles();
    if (!t.length) return true;              /* nothing to mirror yet */
    for (var i = 0; i < t.length; i++) {
      var want = t[i].getAttribute('data-color') === wash;
      if (t[i].classList.contains('selected') !== want) return false;
    }
    return true;
  }

  function hasTileFor(wash) {
    var t = tiles();
    for (var i = 0; i < t.length; i++) {
      if (t[i].getAttribute('data-color') === wash) return true;
    }
    return false;
  }

  function mirror(reason) {
    var wash = currentWash();
    if (!wash) return false;
    if (!hasTileFor(wash)) return false;
    if (agrees(wash)) return false;

    var t = tiles();
    for (var i = 0; i < t.length; i++) {
      if (t[i].getAttribute('data-color') === wash) {
        t[i].classList.add('selected');
      } else {
        t[i].classList.remove('selected');
      }
      t[i].style.background = '';
      t[i].style.border = '';
    }

    writes++;
    lastWash = wash;
    lastReason = reason;
    console.log('SV DENIM STEP MIRROR: step 2 now shows "' + wash + '" (' + reason + ')');
    return true;
  }

  /* The routes that DO fire an event. Cheap, and makes the common case instant
     rather than up to 500ms late. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(RADIO)) setTimeout(function () { mirror('radio change'); }, 0);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('#sv-chooser-cta') || t.closest('.sv-chooser-wash')) {
      setTimeout(function () { mirror('chooser'); }, 400);
      setTimeout(function () { mirror('chooser'); }, 1400);
    }
  }, true);

  /* The silent route: `js()` assigns .checked with no dispatch. Only a poll
     catches that one. Writes only on disagreement. */
  setInterval(function () { mirror('poll'); }, POLL_MS);

  /* First paint — the chooser can apply before this block's listeners exist. */
  [0, 300, 900, 2000, 4000].forEach(function (ms) {
    setTimeout(function () { mirror('startup'); }, ms);
  });

  window.svAuditDenimStepMirror = function () {
    var wash = currentWash();
    var report = {
      installed: true,
      washInCart: wash,
      chooserPick: (function () {
        try { return (JSON.parse(localStorage.getItem('sv-chooser-pick') || 'null') || {}).denim || null; }
        catch (e) { return null; }
      })(),
      gender: (document.getElementById('gender') || {}).value || null,
      bodyGenderClass: /sv-gender-female/.test(document.body.className) ? 'female'
                     : /sv-gender-male/.test(document.body.className) ? 'male' : 'none',
      writes: writes,
      lastWash: lastWash,
      lastReason: lastReason,
      tiles: []
    };
    var t = tiles();
    for (var i = 0; i < t.length; i++) {
      var cs = getComputedStyle(t[i]);
      report.tiles.push({
        colour: t[i].getAttribute('data-color'),
        selected: t[i].classList.contains('selected'),
        disabled: cs.pointerEvents === 'none',
        borderColor: cs.borderColor
      });
    }
    report.agrees = agrees(wash);
    if (!report.agrees) {
      console.error('SV DENIM STEP MIRROR: 🔴 step 2 does NOT show the wash in the cart', report);
    }
    console.log('SV DENIM STEP MIRROR audit:', report);
    return report;
  };

  console.log('SV DENIM STEP MIRROR: installed — the Denim Colour step follows the ' +
              'wash in the cart, whichever control moved it.');
})();


/* ============================================================================
   SV CHOOSER WASH AUTHORITY — the wash picked at CHANGE BASE survives the
   gender switch instead of being reverted to the old one
   ----------------------------------------------------------------------------
   Found while fixing `SV DENIM STEP MIRROR` (block above), 2026-08-27. This is
   a MONEY defect, not a display one, and it is pre-existing: it reproduces with
   no owner-fix block of ours on the page.

   REPRODUCED on DEV at 393x852, twice, from a clean load:

     Men's Jacket / Black  ->  CHANGE BASE  ->  Women's Jacket / Light Denim
       localStorage sv-chooser-pick   denim: "Light Denim"     the customer's choice
       URL                            colour=lightblue         the customer's choice
       properties[Denim Color]        "Black"                  <-- WRONG
       #denim-color-summary           "Black"                  <-- WRONG
       the 3D model                   dark, not light denim    <-- WRONG

   The customer chooses a Women's LIGHT DENIM jacket and gets a black one, in
   the cart line item as well as on screen.

   ⭐ IT IS THE GENDER CHANGE, NOT THE CHANGE BASE ROUTE. Proved by holding the
   gender still: Men's Jacket / Black -> CHANGE BASE -> Men's Jacket / BLUE ends
   with the radio and the summary both reading "Blue". Correct. Only a switch
   that ALSO changes gender loses the wash.

   ROOT CAUSE, FROM THE CONSOLE RECORD OF THAT RUN (timestamps verbatim):

       93798ms  Desktop: Denim color changed to: Light Denim
       93826ms  🧱 Chooser applied: Female / Jacket / Light Denim
       95297ms  🎨 [syncDenimColorUI] Syncing UI to: Black      <-- reverted here
       98695ms  DEBUG updateDenimColor: color = Black           <-- model repainted

   The wash IS applied. 1.5s later it is undone. `handleGenderChange` opens with

       xe = document.querySelector('input[name="properties[Denim Color]"]:checked')?.value || null;
       console.log(`🎨 [handleGenderChange] Preserved denim color: ${xe}`)

   and its completion callback ends with `xe && js(xe)`. That snapshot-and-
   restore is CORRECT for a plain gender flip — a customer switching Men's to
   Women's should keep their Black. ⛔ Do not remove it.

   The bug is the ORDER on the chooser route. `S(F)` dispatches the gender
   change FIRST, which snapshots the OLD wash, and applies the NEW wash after.
   The gender change then finishes and restores its snapshot over the top. On
   this one route the snapshot is stale by construction.

   ⛔ `Be()` (updateDenimColor) NEVER ASSIGNS `xe`. It paints meshes and
   returns. Checked the whole function body. So "the wash was applied" can never
   refresh the snapshot, and no amount of waiting fixes it.

   WHAT THIS BLOCK DOES. For a bounded window after a chooser apply, the
   chooser's own pick is authoritative: if the cart radio drifts away from it,
   the radio is put back and a `change` is dispatched — the same event the
   engine's own handler listens for, so the model repaints through the engine's
   normal path. It does not touch `handleGenderChange`, `js()` or `xe`.

   ⚠️ THIS BLOCK CHAINS `_svChooserApplying`; IT MUST NOT REPLACE IT.
   `SV BASE SWITCH CHOOSER ARM` (block above) already redefines that property
   with `configurable: true`. Redefining it again would silently drop that
   block's setter and un-fix P5 — badges would float after a gender switch. So
   this block reads the existing descriptor and wraps it, and refuses to install
   if the descriptor it expects is not there.

   FOUR BOUNDS, so this can never fight the customer or spin:
     1. Only inside a 12s window opened by a chooser apply.
     2. Stops the moment the customer touches any denim control themselves,
        detected by `event.isTrusted` — a real tap is trusted, our dispatch is
        not. No bookkeeping, no way for the two to be confused.
     3. Abandons if the intended wash is not selectable on the resulting gender
        (`pointer-events: none`), so it never fights `SV DENIM WASH GATE`'s
        legitimate Light-Denim-on-Men's block.
     4. At most 6 corrections per window, then it stops and logs an error.
        A guard you cannot see fail is not a guard.

   Verify in one line: svAuditChooserWashAuthority()
   ============================================================================ */
(function () {
  'use strict';

  if (window.__svChooserWashAuthorityInit) return;  /* Theme Editor re-runs this script */
  window.__svChooserWashAuthorityInit = true;

  var FLAG = '_svChooserApplying';
  var WINDOW_MS = 12000;
  var POLL_MS = 250;
  var MAX_CORRECTIONS = 6;

  var windowUntil = 0;
  var intended = null;
  var overridden = false;
  var corrections = 0;
  var history = [];
  var abandoned = '';

  function pickedWash() {
    try {
      var p = JSON.parse(localStorage.getItem('sv-chooser-pick') || 'null');
      return p && p.denim ? p.denim : null;
    } catch (e) { return null; }
  }

  function radioFor(wash) {
    return document.querySelector('input[name="properties[Denim Color]"][value="' + wash + '"]');
  }

  function checkedWash() {
    var r = document.querySelector('input[name="properties[Denim Color]"]:checked');
    return r ? r.value : null;
  }

  /* The step-2 tile for this wash, if the wash gate has killed it for the
     current gender we must not force it. */
  function washBlockedForGender(wash) {
    var tile = document.querySelector('.option-item[data-color="' + wash + '"]');
    if (!tile) return false;
    return getComputedStyle(tile).pointerEvents === 'none';
  }

  function openWindow() {
    var wash = pickedWash();
    var record = { at: Date.now(), wash: wash, opened: false, reason: '' };

    if (!wash) {
      record.reason = 'no wash in sv-chooser-pick — abstaining';
    } else {
      intended = wash;
      overridden = false;
      corrections = 0;
      abandoned = '';
      windowUntil = Date.now() + WINDOW_MS;
      record.opened = true;
      record.reason = 'chooser applied "' + wash + '" — holding it for ' + (WINDOW_MS / 1000) + 's';
      console.log('SV CHOOSER WASH AUTHORITY: holding "' + wash + '" against the ' +
                  'gender-change restore for the next ' + (WINDOW_MS / 1000) + 's');
    }

    history.push(record);
    if (history.length > 20) history.shift();
  }

  function tick() {
    if (!intended) return;
    if (Date.now() > windowUntil) return;
    if (overridden || abandoned) return;

    var now = checkedWash();
    if (now === intended) return;

    if (washBlockedForGender(intended)) {
      abandoned = 'wash "' + intended + '" is not available on this gender';
      console.warn('SV CHOOSER WASH AUTHORITY: standing down — ' + abandoned +
                   '. Leaving the engine\'s own choice (' + now + ') alone.');
      return;
    }

    if (corrections >= MAX_CORRECTIONS) {
      abandoned = 'hit the ' + MAX_CORRECTIONS + '-correction ceiling';
      console.error('SV CHOOSER WASH AUTHORITY: 🔴 something keeps reverting the wash. ' +
                    'Stopped after ' + MAX_CORRECTIONS + ' corrections. The cart now says "' +
                    now + '" but the customer chose "' + intended + '".');
      return;
    }

    var r = radioFor(intended);
    if (!r) {
      abandoned = 'no radio for "' + intended + '"';
      console.error('SV CHOOSER WASH AUTHORITY: 🔴 no denim radio with value "' +
                    intended + '" — cannot restore the customer\'s choice.');
      return;
    }

    r.checked = true;
    r.dispatchEvent(new Event('change', { bubbles: true }));
    corrections++;
    console.log('SV CHOOSER WASH AUTHORITY: restored "' + intended +
                '" over "' + now + '" (correction ' + corrections + ')');
  }

  /* A real tap by the customer ends our authority immediately. `isTrusted` is
     false on the event WE dispatch, so this can never trip on our own work. */
  function noteCustomerTouch(e) {
    if (!e.isTrusted || !intended || overridden) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.option-item[data-color]') ||
        t.closest('#denim-color-section') ||
        t.closest('.color-option')) {
      overridden = true;
      console.log('SV CHOOSER WASH AUTHORITY: customer picked a wash themselves — standing down.');
    }
  }
  document.addEventListener('click', noteCustomerTouch, true);
  document.addEventListener('change', noteCustomerTouch, true);

  /* ⚠️ CHAIN the existing descriptor, never replace it. See the header. */
  var d = Object.getOwnPropertyDescriptor(window, FLAG);
  if (!d || typeof d.set !== 'function') {
    console.error('SV CHOOSER WASH AUTHORITY: 🔴 window.' + FLAG + ' is not an ' +
                  'accessor property. SV BASE SWITCH CHOOSER ARM should have made ' +
                  'it one. NOT installing — the wash picked at CHANGE BASE will ' +
                  'still be reverted to the previous one on a gender switch.');
    window.__svChooserWashAuthorityOrphaned = true;
  } else if (!d.configurable) {
    console.error('SV CHOOSER WASH AUTHORITY: 🔴 window.' + FLAG + ' is not ' +
                  'configurable — cannot chain onto it. NOT installing.');
    window.__svChooserWashAuthorityOrphaned = true;
  } else {
    var priorGet = d.get, priorSet = d.set;
    try {
      Object.defineProperty(window, FLAG, {
        configurable: true,
        enumerable: true,
        get: function () { return priorGet.call(window); },
        set: function (v) {
          var was = priorGet.call(window);
          priorSet.call(window, v);          /* the other block runs FIRST, unchanged */
          if (v && !was) {
            try { openWindow(); }
            catch (e) { console.error('SV CHOOSER WASH AUTHORITY: window open threw —', e); }
          }
        }
      });
    } catch (e) {
      console.error('SV CHOOSER WASH AUTHORITY: 🔴 could not chain window.' + FLAG + ' —', e);
      window.__svChooserWashAuthorityOrphaned = true;
    }
  }

  setInterval(tick, POLL_MS);

  window.svAuditChooserWashAuthority = function () {
    var report = {
      installed: !window.__svChooserWashAuthorityOrphaned,
      chooserPick: pickedWash(),
      washInCart: checkedWash(),
      intended: intended,
      windowOpenNow: Date.now() < windowUntil,
      msLeft: Math.max(0, windowUntil - Date.now()),
      corrections: corrections,
      customerOverrode: overridden,
      abandoned: abandoned || null,
      gender: (document.getElementById('gender') || {}).value || null,
      history: history.slice(-5)
    };
    report.agrees = !report.chooserPick || report.chooserPick === report.washInCart ||
                    report.customerOverrode;
    if (!report.agrees) {
      console.error('SV CHOOSER WASH AUTHORITY: 🔴 the cart wash does NOT match the ' +
                    'wash the customer chose at the chooser', report);
    }
    console.log('SV CHOOSER WASH AUTHORITY audit:', report);
    return report;
  };

  console.log('SV CHOOSER WASH AUTHORITY: installed — a wash chosen at CHANGE BASE ' +
              'now survives the gender switch.');
})();


/* ============================================================================
   SV GENDER SWITCH COALESCE — one tap on the gender pill loads the 3D model
   ONCE instead of three times
   ----------------------------------------------------------------------------
   Built 2026-08-27, after `SV GENDER CONFIRM DEDUPE` (block 34). That block
   fixed what the CUSTOMER SEES — one dialog per tap instead of three. This one
   fixes what the DEVICE DOES behind it.

   ⛔ THIS IS NOT A RE-FIX OF BLOCK 34. Block 34 stays and is still required.
   It hides the surplus dialogs and forwards the customer's answer to them.
   The cost of forwarding is that ALL THREE handlers then proceed to switch the
   model. This block stops the surplus two before they ever build a dialog, so
   block 34 has nothing left to hide and becomes a quiet safety net.

   MEASURED ON DEV AT 393x852, ONE REAL TAP ON "Women's" (iPhone-emulated
   context, `hover: none`, `pointer: coarse`):

       handleGenderChange CALLED          x3
       [handleGenderChange] Transition started   x3   at +0ms, +47ms, +87ms
       Loading 3D model for: Male ...     x3

   The gender is correct at the end. The model is simply loaded three times —
   three times the heaviest operation in the customiser, on a phone, on the
   money path.

   ⭐ WHY GENDER AND NOT STYLE. The duplicate listeners sit on BOTH controls.
   Measured on the same page, one tap on "Gilet": ONE transition, ONE model
   load. The style path's `R.style !== newStyle` guard is reached synchronously,
   so duplicates 2 and 3 find the state already changed and short-circuit with
   "No actual change detected". The gender path AWAITS the confirmation dialog
   BEFORE the state moves, so all three duplicates pass the same guard and all
   three proceed. The bug is not the duplicate listeners; it is that an `await`
   sits between the guard and the state write.

   ⛔ THE ROOT DUPLICATION IS STILL THERE AND IS NOT FIXED HERE. The engine
   binds its gender handler three times (1 on a fresh page, 3 after the customer
   navigates a few steps). Repairing that means editing `jacket-cf.js`, 776,591
   bytes of minified engine, on the switch that drops badges and changes price.
   An engine patch to that file was built and REVERTED earlier in this same
   session for resting on a wrong premise. This block does not touch it.

   ⛔ THE CHANGE BASE ROUTE IS NOT AFFECTED AND IS NOT COVERED. Measured: a
   cross-gender CHANGE BASE gives ONE model load. That route navigates to
   `?style=...&gender=...&colour=...`, so the page reloads and the listeners are
   fresh. It also skips the dialog entirely (`_svChooserApplying` short-circuits
   it), so this block never sees it. Both facts are fine — there is nothing to
   coalesce there.

   HOW IT WORKS. `window.genderChangeWarning.showGenderChangeConfirmation` is
   the one await point every duplicate must pass through. The first call in a
   burst is delegated to the engine untouched. A call with the SAME from|to key
   inside the burst window is handed a promise that never settles, so that
   duplicate handler stops at its `await` and never runs again.

   ⭐ NEVER-SETTLING IS DELIBERATE, AND IT IS THE SAFE CHOICE HERE.
   - Resolving `false` is WRONG: the engine's cancel branch writes the OLD
     gender back into `#gender` and `#mobile-gender`, which would fight the one
     handler that is legitimately proceeding.
   - Rejecting is WRONG: the await is not guarded, so it would surface as an
     unhandled rejection.
   - Hanging abandons the duplicate BEFORE "Transition started", so it never
     sets a transition flag and leaves nothing to clean up. Verified from the
     engine's own ordering: the await precedes the transition. The cost is two
     abandoned async frames per switch — closures only, no timers, no DOM.

   FOUR BOUNDS, so this can never swallow a decision the customer made:
     1. The FIRST call of any burst is never suppressed.
     2. Suppression needs an EXACT from|to match. Any other switch is a new
        decision and always goes through.
     3. The window is 600 ms. The duplicates arrive within 90 ms; a human cannot
        tap, read a dialog, and tap again inside 600 ms.
     4. At most 6 suppressions per burst, then it stops and logs a console.error.
        A guard you cannot see fail is not a guard.

   Verify in one line: svAuditGenderSwitchCoalesce()
   ============================================================================ */
(function () {
  'use strict';

  if (window.__svGenderCoalesceInit) return;   /* Theme Editor re-runs this script */
  window.__svGenderCoalesceInit = true;

  var COALESCE_MS = 600;
  var MAX_SUPPRESSED_PER_BURST = 6;

  var windowKey = null;
  var windowUntil = 0;
  var suppressedThisBurst = 0;

  var firstCalls = 0;
  var suppressedTotal = 0;
  var abandoned = '';
  var history = [];

  function record(entry) {
    history.push(entry);
    if (history.length > 20) history.shift();
  }

  var W = window.genderChangeWarning;

  if (!W || typeof W.showGenderChangeConfirmation !== 'function') {
    console.error('SV GENDER SWITCH COALESCE: 🔴 window.genderChangeWarning.' +
                  'showGenderChangeConfirmation is not a function. NOT installing — ' +
                  'one tap on the gender pill will keep loading the 3D model three times.');
    window.__svGenderCoalesceOrphaned = true;
  } else {
    var original = W.showGenderChangeConfirmation.bind(W);

    W.showGenderChangeConfirmation = function (from, to, state) {
      var key = String(from) + '|' + String(to);
      var now = Date.now();

      if (windowKey === key && now < windowUntil) {
        if (suppressedThisBurst >= MAX_SUPPRESSED_PER_BURST) {
          abandoned = 'more than ' + MAX_SUPPRESSED_PER_BURST + ' duplicates in one burst';
          console.error('SV GENDER SWITCH COALESCE: 🔴 ' + key + ' fired more than ' +
                        MAX_SUPPRESSED_PER_BURST + ' times in ' + COALESCE_MS + 'ms. ' +
                        'Standing down and letting this one through — the duplicate ' +
                        'binding has got worse than 3x.');
          record({ at: now, key: key, action: 'ceiling-hit-passed-through' });
          return original(from, to, state);
        }
        suppressedThisBurst++;
        suppressedTotal++;
        record({ at: now, key: key, action: 'suppressed', n: suppressedThisBurst });
        /* Abandon this duplicate at its await. See the header for why hanging
           is correct and resolving/rejecting are not. */
        return new Promise(function () {});
      }

      windowKey = key;
      windowUntil = now + COALESCE_MS;
      suppressedThisBurst = 0;
      firstCalls++;
      record({ at: now, key: key, action: 'passed-through (first of burst)' });
      return original(from, to, state);
    };

    console.log('SV GENDER SWITCH COALESCE: installed — one tap on the gender pill ' +
                'now loads the 3D model once, not three times.');
  }

  window.svAuditGenderSwitchCoalesce = function () {
    var report = {
      installed: !window.__svGenderCoalesceOrphaned,
      coalesceWindowMs: COALESCE_MS,
      switchesSeen: firstCalls,
      duplicatesSuppressed: suppressedTotal,
      duplicatesPerSwitch: firstCalls ? Math.round((suppressedTotal / firstCalls) * 100) / 100 : 0,
      burstOpenNow: Date.now() < windowUntil,
      burstKey: windowKey,
      abandoned: abandoned || null,
      dialogsOnScreenNow: document.querySelectorAll('.gender-change-overlay').length,
      history: history.slice(-6)
    };
    /* With this block working, one tap creates exactly one dialog. Block 34
       then has nothing to hide. More than one on screen means this block is
       not catching the duplicates. */
    if (report.dialogsOnScreenNow > 1) {
      console.error('SV GENDER SWITCH COALESCE: 🔴 ' + report.dialogsOnScreenNow +
                    ' gender dialogs are on screen at once — the duplicates are ' +
                    'getting past this block.', report);
    }
    console.log('SV GENDER SWITCH COALESCE audit:', report);
    return report;
  };
})();


/* ===========================================================================
   SV SHEET TOGGLE ABOVE 768  —  P0: on every iPad except the mini, in
   portrait, the bottom sheet is the ONLY control surface and it cannot be
   opened at all (2026-08-27)

   ROOT CAUSE, proven not guessed. jacket-cf.js wraps its entire bottom-sheet
   module in a single gate:

       (function () {
         if (window.innerWidth > 768) return;
         console.log("📱 MOBILE: Initializing Nike-style bottom sheet ...");
         ...  every sheet handler is bound in here  ...
       })();

   Everything the sheet needs lives inside that IIFE: the handle's click
   toggle, the touch swipe on the handle and the step title, the click-to-open
   on a collapsed sheet, and the MutationObserver that keeps aria-expanded and
   the "Swipe up to customise" hint in step.

   But the CSS shows the sheet all the way to 1024:
       @media (min-width: 769px) and (max-width: 1024px)  -> sheet block, panel none
   So from 769px to 1024px in portrait the theme presents a control surface
   that has no handlers attached to it. Confirmed from the console on real
   loads — the module's own init line is present at 390 and absent at 769
   and 1024:

       innerWidth=390   "MOBILE: Initializing Nike-style bottom sheet"  x1
       innerWidth=769   (absent)
       innerWidth=1024  (absent)

   Measured at 820x1180 (iPad 10th gen / iPad Air 11" portrait) on DEV:
   sheet display block, panel display none, and the sheet top stays at 1108
   after a tap AND after a real 120px touch swipe. Neither input does
   anything, so the customer cannot reach any customisation step.

   ⛔ PRE-EXISTING. Reproduced identically on LIVE (role "main", 197365596497)
   at 769x1024. It is not the garment-fit block and not the tablet-landscape
   CSS column fix.

   Affected in portrait: iPad 10th gen and Air 11" (820), iPad Pro 11" (834),
   iPad Pro 12.9"/13" (1024). iPad mini (744) is BELOW the gate and works.
   The same gate also explains the resize path: load at a desktop width and
   narrow the window, and the sheet is dead because the IIFE already returned
   and nothing re-runs it.

   FIX: bind the missing handlers here, and ONLY when the engine did not.
   The engine itself is not edited — it is minified and every SV fix in this
   file is an additive runtime patch.

   ⚠️ THE GATE BELOW IS A MIRROR, NOT A POLICY. It reproduces the engine's own
   `innerWidth > 768` test, read at the same moment the engine read it, purely
   to answer "did the engine already bind?". If the engine bound, this block
   must stay completely out of the way — two handlers on one tap toggle twice
   and the sheet never moves. That is the same class of defect as the gender
   pill double-tap. Do NOT "improve" this number to 1024 to match the CSS: it
   is not describing a breakpoint, it is describing what another script did.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svSheetToggleInit) return; /* Theme Editor re-runs this script */
  window.__svSheetToggleInit = true;

  /* jacket-cf.js is a plain <script>; this file is `defer`, so the engine has
     already executed and both reads observe the same width. */
  var ENGINE_BOUND = window.innerWidth <= 768;
  window.__svSheetToggleEngineBound = ENGINE_BOUND;

  function sheet() {
    return document.getElementById('nike-bottom-sheet') ||
           document.querySelector('.nike-bottom-sheet');
  }
  function handle() { return document.getElementById('sv-sheet-handle-area'); }

  /* Parity with the engine's own d(): aria-expanded on the handle, the chevron
     direction, and the hint wording. Same strings and the same polyline points
     the engine uses, so the two paths are indistinguishable to a customer. */
  function sync() {
    var s = sheet();
    if (!s) return;
    var open = s.classList.contains('expanded');
    var h = handle();
    if (h) h.setAttribute('aria-expanded', open ? 'true' : 'false');
    var hint = document.querySelector('.sv-swipe-hint');
    if (!hint) return;
    var svg = hint.querySelector('svg');
    var poly = svg && svg.querySelector('polyline');
    if (poly) poly.setAttribute('points', open ? '6 9 12 15 18 9' : '18 15 12 9 6 15');
    var texts = Array.prototype.filter.call(hint.childNodes, function (n) {
      return n.nodeType === 3;
    });
    if (texts.length) {
      texts[texts.length - 1].textContent = open ? ' Swipe down to close' : ' Swipe up to customise';
    }
    hint.classList.toggle('hidden', false);
  }

  function setOpen(open) {
    var s = sheet();
    if (!s) return;
    if (open) s.classList.add('expanded'); else s.classList.remove('expanded');
    s.style.transform = ''; /* the swipe path leaves inline transforms behind */
    sync();
  }
  function toggle() {
    var s = sheet();
    if (s) setOpen(!s.classList.contains('expanded'));
  }

  /* Swipe: the engine's 50px threshold and the same live drag feedback
     (down clamped to 200px, up to 100px), so the gesture feels identical.

     ONE deliberate difference. The engine's axis test reads
         Math.abs(dy) > Math.abs(touch.clientX - startY)
     which measures an X coordinate against a Y baseline — a typo, not an
     intention, and it makes the test depend on where the finger sits
     horizontally. This tracks startX properly and compares |dy| > |dx|.
     Nothing regresses: at 768 and below the engine's own copy still runs and
     is untouched by this block. */
  function bindSwipe(el) {
    if (!el || el.__svSheetSwipeBound) return;
    el.__svSheetSwipeBound = true;
    var startX = 0, startY = 0, lastY = 0, active = false;

    el.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      startY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
      lastY = startY;
      active = true;
      e.stopPropagation();
    }, { passive: false });

    el.addEventListener('touchmove', function (e) {
      if (!active || !e.touches || !e.touches.length) return;
      lastY = e.touches[0].clientY;
      var dy = lastY - startY;
      var dx = e.touches[0].clientX - startX;
      if (Math.abs(dy) <= Math.abs(dx)) return; /* horizontal drag — not ours */
      e.preventDefault();
      e.stopPropagation();
      var s = sheet();
      if (!s) return;
      s.style.transform = 'translateY(' + (dy > 0 ? Math.min(dy, 200) : Math.max(dy, -100)) + 'px)';
    }, { passive: false });

    el.addEventListener('touchend', function () {
      if (!active) return;
      active = false;
      var s = sheet();
      if (!s) return;
      var dy = lastY - startY, THRESH = 50;
      if (dy > THRESH) setOpen(false);
      else if (dy < -THRESH) setOpen(true);
      else s.style.transform = '';
    }, { passive: false });
  }

  function bind() {
    var h = handle();
    if (h && !h.__svSheetTapBound) {
      h.__svSheetTapBound = true;
      h.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      });
    }
    var s = sheet();
    if (s && !s.__svSheetTapBound) {
      s.__svSheetTapBound = true;
      /* Engine parity: a tap anywhere on a COLLAPSED sheet opens it. Taps on an
         already-open sheet must fall through to the controls inside it. */
      s.addEventListener('click', function (e) {
        if (this.classList.contains('expanded')) return;
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
      });
    }
    bindSwipe(h);
    bindSwipe(document.querySelector('.step-title'));
    return !!(h && s);
  }

  if (!ENGINE_BOUND) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bind(); sync(); });
    } else {
      bind();
      sync();
    }
    /* The sheet markup is server-rendered, but the hint and step title are not
       always present on the first tick. Retry, then stop. */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (bind()) { sync(); clearInterval(iv); }
      else if (tries > 120) clearInterval(iv); /* ~30s ceiling */
    }, 250);
  }

  /* A guard you cannot see fail is not a guard. This reports what is actually
     bound right now, and shouts if the sheet is the visible control surface
     with nothing listening to it. */
  window.svAuditSheetToggle = function () {
    var s = sheet(), h = handle();
    var panel = document.getElementById('desktop-config-panel');
    var report = {
      engineBoundAtLoad: ENGINE_BOUND,
      blockActive: !ENGINE_BOUND,
      widthNow: window.innerWidth,
      orientation: window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait',
      sheetPresent: !!s,
      sheetDisplay: s ? window.getComputedStyle(s).display : null,
      panelDisplay: panel ? window.getComputedStyle(panel).display : null,
      tapBound: !!(h && h.__svSheetTapBound),
      swipeBound: !!(h && h.__svSheetSwipeBound),
      expandedNow: !!(s && s.classList.contains('expanded')),
      ariaExpanded: h ? h.getAttribute('aria-expanded') : null
    };
    report.sheetIsTheSurface = report.sheetDisplay !== 'none' && report.panelDisplay === 'none';
    report.reachable = report.sheetIsTheSurface
      ? (ENGINE_BOUND || (report.tapBound && report.swipeBound))
      : true;

    if (!report.reachable) {
      console.error('SV SHEET TOGGLE: 🔴 the sheet is the only control surface and ' +
                    'nothing is bound to it — the customer cannot open it.', report);
    } else {
      console.log('SV SHEET TOGGLE audit:', report);
    }
    return report;
  };
})();

(function () {
  'use strict';
  if (window.__svOneTapInit) return; /* Theme Editor re-runs this script */
  window.__svOneTapInit = true;

  var GHOST_MS = 800;   /* browsers emit the synthetic click ~300ms after touchend */
  var GHOST_PX = 40;    /* and at essentially the same point */

  var lastTouchAt = 0;
  var lastTouchX = 0, lastTouchY = 0;
  var suppressed = 0;
  var touchesSeen = 0;
  var log = [];

  function canvas() { return document.getElementById('3d-preview-canvas'); }
  function onCanvas(t) { var c = canvas(); return !!(c && t && (t === c || (c.contains && c.contains(t)))); }

  /* Record every real touch that ends on the canvas. Passive: we never block
     the touch itself, only the phantom click that trails it. */
  document.addEventListener('touchend', function (e) {
    if (!onCanvas(e.target)) return;
    var t = (e.changedTouches && e.changedTouches[0]) || null;
    if (!t) return;
    lastTouchAt = Date.now();
    lastTouchX = t.clientX;
    lastTouchY = t.clientY;
    touchesSeen++;
    log.push({ what: 'touchend', at: lastTouchAt, x: Math.round(lastTouchX), y: Math.round(lastTouchY) });
    if (log.length > 30) log.shift();
  }, { capture: true, passive: true });

  /* Capture on `document` runs before the canvas's own capture listener and
     before the body fallback, so stopImmediatePropagation() kills both. */
  document.addEventListener('click', function (e) {
    if (!onCanvas(e.target)) return;
    if (!lastTouchAt) return;
    var dt = Date.now() - lastTouchAt;
    if (dt > GHOST_MS) return;
    var dx = Math.abs(e.clientX - lastTouchX);
    var dy = Math.abs(e.clientY - lastTouchY);
    if (dx > GHOST_PX || dy > GHOST_PX) return;

    suppressed++;
    log.push({ what: 'suppressed ghost click', dtMs: dt, dx: Math.round(dx), dy: Math.round(dy) });
    if (log.length > 30) log.shift();
    e.stopImmediatePropagation();
    e.preventDefault();
  }, true);

  /* A guard you cannot see fail is not a guard. */
  window.svAuditOneTap = function () {
    var n = 0;
    try { window.threeScene.traverse(function (o) { if (o.userData && o.userData.badge) n++; }); } catch (e) {}
    var cost = null;
    try { cost = window.calculateCustomizationCosts(); } catch (e) {}
    var report = {
      touchendsOnCanvas: touchesSeen,
      ghostClicksSuppressed: suppressed,
      badgesInSceneNow: n,
      customisationCostNow: cost,
      windowMs: GHOST_MS, windowPx: GHOST_PX,
      recent: log.slice(-8)
    };
    /* One suppression per touch placement is the expected shape. Zero touches
       with suppressions, or badges climbing two at a time, both mean trouble. */
    if (touchesSeen > 0 && suppressed === 0) {
      console.warn('SV ONE TAP ONE BADGE: touches seen but no ghost click suppressed — ' +
                   'either this device does not emit them, or the window is too tight.', report);
    } else {
      console.log('SV ONE TAP ONE BADGE audit:', report);
    }
    return report;
  };
})();


/* ===========================================================================
   SV GARMENT FIT SILHOUETTE  —  the fit rewrite: measure what is DRAWN, and
   run AFTER the engine has finished moving the camera (2026-08-27)

   WHY THE EXISTING `SV GARMENT FIT` BLOCK IS REPLACED, not tuned. Two faults,
   both measured on DEV/LIVE earlier today:

   1. IT SOLVES THE WRONG SHAPE. `maxNDCAt` projects the 8 corners of the
      garment's BOUNDING BOX. The box is 1.71 x 1.08 x 0.63 — it has real
      depth — and the camera sits at ~23 degrees elevation, so the near-bottom
      corners project well outside the garment's actual silhouette. It frames
      the box that contains the jacket, not the jacket. Measured at 769x1024:

          camera at 1.438 (where the engine leaves it)   garment 85.3% wide
          camera at 1.939 (what the box solve asks for)  garment 64.8% wide

      The "fix" pulled back until 135px of dead space sat on each side. Its
      `ndcBefore: 1.19` did NOT mean the garment was clipped — it meant a
      corner of an invisible box was outside the frame. Nothing was clipped at
      any viewport.

   2. IT RUNS DURING THE ENGINE'S OWN CAMERA CHOREOGRAPHY AND LOSES. The engine
      logs, on one load: five `Camera reset to Male front view position` between
      1.26s and 4.06s, plus `CINEMATIC: Flying to front...` at 3.25s. The old
      block fires once at model-ready, inside that window, and is simply
      overwritten. `__svFitLast.at` never changes afterwards, so it never
      retries. Whether it survives is a RACE — measured surviving at 390 and
      1024, losing at 768, 769 and 1440.

   THE REWRITE, in one sentence: wait until the camera stops moving, then solve
   from the RENDERED SILHOUETTE in canvas pixels instead of from box corners.

   ⭐ WHY PIXELS. The silhouette is the only measurement that answers the
   question a customer actually has — "how much of the frame is jacket?" A
   projection can disagree with the screen, and today it did, repeatedly. This
   block reads the drawn frame back and never touches the camera while
   measuring, so it cannot report what framing WOULD be after a successful fit.
   (That false-pass is exactly what the old block's `maxNDCAt` did.)

   ⚠️ IT DOES NOT DISABLE THE OLD BLOCK. That block is left in place and simply
   loses on timing: it fires inside the first ~4s, this one fires after the
   camera has been still for SETTLE_MS. Removing it is a separate change with
   its own verification, and stacking one deterministic late adjustment on top
   of an early one is safe — the late one is idempotent and re-measures.

   ⛔ IT WILL NOT FIT WHAT IS NOT CLIPPED. If the garment already sits within
   TARGET_MIN..TARGET_MAX of the frame, the block does nothing at all. Today's
   measurements showed 0.395 (768x1024, far too small) through 0.853 (769x1024,
   good). Only the first needs correcting.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svFitSilhouetteInit) return; /* Theme Editor re-runs this script */
  window.__svFitSilhouetteInit = true;

  var TARGET      = 0.82;  /* aim: the garment's larger dimension fills this much of the canvas */
  var TARGET_MIN  = 0.62;  /* below this it looks lost in the frame -> pull in  */
  var TARGET_MAX  = 0.94;  /* above this it crowds the edges        -> push out */
  var SETTLE_MS   = 1200;  /* the camera must be still this long before we act */
  var MIN_START_MS = 5000; /* never act before the engine's choreography is done */
  var MAX_STEPS   = 3;
  var last = null;

  function cam() { return window.threeCamera; }
  function canvasEl() { return document.getElementById('3d-preview-canvas'); }

  /* The engine's own zoom clamp, mirrored so the customer's first pinch cannot
     snap the garment to a different size. Same breakpoint the engine uses. */
  function minD() { return window.innerWidth <= 768 ? 1.05 : 1.55; }
  var MAX_D = 4;

  /* Read the DRAWN frame. No camera contact — this answers "what is on screen",
     never "what would be on screen". */
  function silhouette() {
    var c = canvasEl();
    if (!c || !c.width || !c.height) return null;
    var w = c.width, h = c.height;
    var t = document.createElement('canvas'); t.width = w; t.height = h;
    var x = t.getContext('2d');
    try { x.drawImage(c, 0, 0); } catch (e) { return null; }
    var d;
    try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return null; }
    var br = d[0], bg = d[1], bb = d[2];
    var minX = w, minY = h, maxX = -1, maxY = -1, n = 0;
    for (var y = 0; y < h; y += 2) {
      for (var px = 0; px < w; px += 2) {
        var i = (y * w + px) * 4;
        if (Math.abs(d[i] - br) + Math.abs(d[i + 1] - bg) + Math.abs(d[i + 2] - bb) > 24) {
          n++;
          if (px < minX) minX = px; if (px > maxX) maxX = px;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;
    return {
      pixels: n, box: [minX, minY, maxX, maxY],
      wFrac: (maxX - minX + 1) / w, hFrac: (maxY - minY + 1) / h,
      clipped: minX <= 2 || maxX >= w - 3 || minY <= 2 || maxY >= h - 3
    };
  }

  function garmentCentre() {
    if (!window.threeScene || typeof THREE === 'undefined') return null;
    function shown(o) { while (o) { if (o.visible === false) return false; o = o.parent; } return true; }
    var box = new THREE.Box3(), found = false;
    window.threeScene.traverse(function (o) {
      if (o.isMesh && o !== window._svContactShadow && shown(o) && !/proxy/i.test(o.name || '')) {
        box.expandByObject(o); found = true;
      }
    });
    if (!found) return null;
    var s = new THREE.Vector3(); box.getSize(s);
    if (!isFinite(s.y) || s.y < 0.3) return null; /* not loaded yet */
    var c = new THREE.Vector3(); box.getCenter(c);
    return c;
  }

  /* Camera stillness: the choreography writes the camera repeatedly, so we
     wait for a quiet period rather than guessing a timeout. */
  /* ⛔ FIXED 2026-09-08 — CAMERA POSITION ALONE MISSES A BASE CHANGE.
     Measured on DEV: switching Men's Jacket -> Men's Gilet moves NOTHING on
     window.threeCamera for the full 7s swap animation — position sampled
     16 times at 500ms held the identical {x,y,z} throughout, while the
     garment's own bounding box (read via garmentCentre()'s traversal) grew
     and shrank as the new mesh loaded in. A camera-only stillness check can
     never see this: `lastPos` never changes, so it never re-arms, and this
     block's single boot-time run is never repeated — the exact defect
     `SV_GARMENT_FIT_SILHOUETTE.FINDINGS.md` recorded for style/gender
     switches. Watching the garment's bounding-box SIZE alongside camera
     position closes it without touching the engine bundle at all: the same
     "wait for quiet, then act" shape this block already uses for the
     camera, extended to the one thing that actually changes on a base
     swap. */
  var lastPos = null, sizeRef = null, stillSince = 0;

  /* ⛔ FIRST ATTEMPT AT THIS FIX WAS WRONG, CAUGHT BEFORE SHIPPING. It compared
     garmentSizeKey() by EXACT match, same shape as the camera's posKey. But the
     garment has a continuous idle sway at rest — 10 samples 400ms apart on a
     stationary Jacket showed z cycling 0.598 -> 0.562 -> 0.598 (peak-to-peak
     0.036), x swaying similarly, over a roughly 3-4s period. Exact match never
     saw two consecutive polls agree, so `run()` never fired even once — not a
     silent no-op, a regression that broke the working boot-time fit. A DELTA
     FROM A REFERENCE POINT, not equality, is the right comparison whenever the
     "unchanged" state is itself in continuous low-amplitude motion. */
  var SIZE_DRIFT_TOL = 0.06; /* idle sway measured <=0.036 peak-to-peak; a real
                                 base swap (Jacket -> Gilet, measured) moves the
                                 box depth by >0.10 within the first second */
  function garmentSizeKey() {
    if (!window.threeScene || typeof THREE === 'undefined') return null;
    function shown(o) { while (o) { if (o.visible === false) return false; o = o.parent; } return true; }
    var box = new THREE.Box3(), found = false;
    window.threeScene.traverse(function (o) {
      if (o.isMesh && o !== window._svContactShadow && shown(o) && !/proxy/i.test(o.name || '')) {
        box.expandByObject(o); found = true;
      }
    });
    if (!found) return null;
    var s = new THREE.Vector3(); box.getSize(s);
    if (!isFinite(s.y) || s.y < 0.3) return null; /* not loaded yet */
    return s.x.toFixed(3) + ',' + s.y.toFixed(3) + ',' + s.z.toFixed(3);
  }
  function sizeDrifted(ref, cur) {
    if (!ref || !cur) return cur !== ref;
    var a = ref.split(',').map(Number), b = cur.split(',').map(Number);
    for (var i = 0; i < 3; i++) if (Math.abs(a[i] - b[i]) > SIZE_DRIFT_TOL) return true;
    return false;
  }
  function cameraIsStill() {
    var c = cam();
    if (!c) { stillSince = 0; return false; }
    var p = c.position;
    var posKey = p.x.toFixed(4) + ',' + p.y.toFixed(4) + ',' + p.z.toFixed(4);
    var sizeKey = garmentSizeKey();
    var now = Date.now();
    if (posKey !== lastPos || sizeDrifted(sizeRef, sizeKey)) {
      lastPos = posKey; if (sizeKey) sizeRef = sizeKey; stillSince = now; return false;
    }
    return stillSince && (now - stillSince) >= SETTLE_MS;
  }

  function step(reason) {
    var c = cam(), centre = garmentCentre(), sil = silhouette();
    if (!c || !centre || !sil) return null;
    var frac = Math.max(sil.wFrac, sil.hFrac);
    if (frac >= TARGET_MIN && frac <= TARGET_MAX) {
      return { skipped: 'already within target', frac: +frac.toFixed(3) };
    }
    var dir = c.position.clone().sub(centre);
    var dist = dir.length();
    if (!isFinite(dist) || dist < 1e-4) return null;
    dir.normalize();
    /* Apparent size is inversely proportional to distance, so scaling the
       distance by frac/TARGET moves the silhouette to the target. */
    var want = dist * (frac / TARGET);
    want = Math.max(minD(), Math.min(MAX_D, want));
    if (Math.abs(want - dist) < 0.01) return { skipped: 'already at solve', frac: +frac.toFixed(3) };
    c.position.copy(centre.clone().add(dir.multiplyScalar(want)));
    c.lookAt(centre);
    if (typeof window.svSetNeedsRender === 'function') window.svSetNeedsRender();
    return { reason: reason, from: +dist.toFixed(3), to: +want.toFixed(3),
             fracBefore: +frac.toFixed(3), clippedBefore: sil.clipped };
  }

  function run(reason) {
    var trail = [];
    var i = 0;
    function next() {
      if (i++ >= MAX_STEPS) { finish(); return; }
      var r = step(reason);
      if (!r) { finish(); return; }
      trail.push(r);
      if (r.skipped) { finish(); return; }
      setTimeout(next, 260); /* let the on-demand renderer draw before re-reading */
    }
    function finish() {
      var sil = silhouette();
      last = { at: Date.now(), reason: reason, steps: trail,
               fracAfter: sil ? +Math.max(sil.wFrac, sil.hFrac).toFixed(3) : null,
               clippedAfter: sil ? sil.clipped : null };
      window.__svFitSilhouetteLast = last;
    }
    next();
  }

  /* Arm once the camera has been still, and never before the choreography. */
  var started = Date.now();
  var armed = false;
  setInterval(function () {
    if (Date.now() - started < MIN_START_MS) return;
    if (!cameraIsStill()) { armed = true; return; }   /* moving again -> re-arm */
    if (!armed) return;
    armed = false;
    run('settled');
  }, 400);

  /* ⛔ This comment used to claim "base changes move the camera again". Measured
     2026-09-08: they do not — cameraIsStill() now also tracks garmentSizeKey()
     above, which is what actually changes on a style/gender/base swap. */
  window.addEventListener('resize', function () { armed = true; }, { passive: true });
  window.addEventListener('orientationchange', function () { armed = true; }, { passive: true });

  /* A guard you cannot see fail is not a guard. Reports what is DRAWN. */
  window.svAuditFitSilhouette = function () {
    var sil = silhouette();
    var c = cam(), centre = garmentCentre();
    var report = {
      target: TARGET, acceptable: [TARGET_MIN, TARGET_MAX],
      drawnWidthFrac: sil ? +sil.wFrac.toFixed(3) : null,
      drawnHeightFrac: sil ? +sil.hFrac.toFixed(3) : null,
      clipped: sil ? sil.clipped : null,
      cameraDistance: (c && centre) ? +c.position.distanceTo(centre).toFixed(3) : null,
      floor: minD(), ceiling: MAX_D,
      lastRun: last,
      garmentSizeKey: sizeRef, stillnessArmed: armed
    };
    var frac = sil ? Math.max(sil.wFrac, sil.hFrac) : null;
    report.withinTarget = frac === null ? null : (frac >= TARGET_MIN && frac <= TARGET_MAX);
    if (report.clipped) {
      console.error('SV GARMENT FIT SILHOUETTE: 🔴 the garment is CLIPPED by the canvas edge.', report);
    } else if (report.withinTarget === false) {
      console.warn('SV GARMENT FIT SILHOUETTE: garment fills ' + frac.toFixed(3) +
                   ' of the frame, outside ' + TARGET_MIN + '–' + TARGET_MAX + '.', report);
    } else {
      console.log('SV GARMENT FIT SILHOUETTE audit:', report);
    }
    return report;
  };
})();

/* ===========================================================================
   SV STEP ARIA STATE — keep aria-expanded truthful (2026-09-22)
   Measured on DEV at 1440x900: step 1 was collapsed (no `expanded` class, the
   content 0px tall and opacity 0) while its header still said
   aria-expanded="true". The engine only refreshes that attribute on a CLICK of
   the header, so any collapse made in code (the chooser commit does one) leaves
   the attribute behind. A screen reader then announces a closed step as open.
   Watch the class instead of the click. Writes one attribute, nothing else.
   Rollback: pending-patches/sv-owner-fixes.PRE-liveGiletNoAuto.LIVE-ROLLBACK.js
   =========================================================================== */
(function () {
  'use strict';
  if (window.__svStepAriaInit) return; /* Theme Editor re-runs this script */
  window.__svStepAriaInit = true;

  function apply(section) {
    var h = section.querySelector('.section-header');
    if (!h) return;
    var open = section.classList.contains('expanded') ? 'true' : 'false';
    if (h.getAttribute('aria-expanded') !== open) h.setAttribute('aria-expanded', open);
  }

  function start() {
    var sections = document.querySelectorAll('.config-section');
    if (!sections.length) return false;
    var obs = new MutationObserver(function (records) {
      records.forEach(function (r) { apply(r.target); });
    });
    sections.forEach(function (s) {
      apply(s);
      obs.observe(s, { attributes: true, attributeFilter: ['class'] });
    });
    return true;
  }

  var tries = 0;
  var poll = setInterval(function () {
    if (start() || ++tries > 40) clearInterval(poll); /* ~20s ceiling */
  }, 500);

  window.svAuditStepAria = function () {
    var bad = [];
    document.querySelectorAll('.config-section').forEach(function (s) {
      var h = s.querySelector('.section-header');
      if (!h) return;
      var open = s.classList.contains('expanded') ? 'true' : 'false';
      if (h.getAttribute('aria-expanded') !== open) bad.push({ id: s.id, says: h.getAttribute('aria-expanded'), is: open });
    });
    if (bad.length) console.error('SV STEP ARIA STATE: 🔴 mismatched steps', bad);
    else console.log('SV STEP ARIA STATE audit: all steps report their real state');
    return bad;
  };
})();
